import { Country } from '@bemlo/enums';
import { DoctorSpecialization } from '@bemlo/enums';
import { Market } from '@bemlo/enums';
import { NurseSpecialization } from '@bemlo/enums';
import { Profession } from '@bemlo/enums';
import { Specialization } from '@bemlo/enums';
import { TenderStatus } from '@bemlo/enums';
import { WorkHours } from '@bemlo/enums';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AbstractConnection = {
  __typename?: 'AbstractConnection';
  assignee?: Maybe<Identity>;
  assigneeId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<RankedCompany>;
  contactRequest?: Maybe<ContactRequest>;
  contactStatus?: Maybe<ConnectionContactStatus>;
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobApplicationNoteToEmployers?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  profile?: Maybe<Profile>;
  profileId: Scalars['String']['output'];
  receipt?: Maybe<Receipt>;
  source?: Maybe<ConnectionSource>;
  status: ConnectionStatus;
  unlockedAt?: Maybe<Scalars['Int']['output']>;
};

export type AcceptPresentationInput = {
  acceptedFillRate?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<Array<CreateAcceptedAvailabilityInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  presentationId: Scalars['String']['input'];
  shiftIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AcceptedAvailability = {
  __typename?: 'AcceptedAvailability';
  bookedAvailability?: Maybe<BookedAvailability>;
  days: Array<AcceptedDay>;
  id: Scalars['String']['output'];
  scope: AvailabilityScope;
};

export type AcceptedDay = {
  __typename?: 'AcceptedDay';
  bookedDay?: Maybe<BookedDay>;
  id: Scalars['String']['output'];
};

export type AcknowledgeBroadcastMessageInput = {
  id: Scalars['String']['input'];
};

export enum ActorType {
  CONSULTANT = 'CONSULTANT',
  EMPLOYEE = 'EMPLOYEE',
  ORG_MEMBER = 'ORG_MEMBER',
  PROFESSIONAL = 'PROFESSIONAL',
  VISITOR = 'VISITOR'
}

export type AddNoteInput = {
  jobApplicationId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type AddShiftToCandidateScheduleInformation = {
  __typename?: 'AddShiftToCandidateScheduleInformation';
  availabilityOverlap?: Maybe<Scalars['Int']['output']>;
  bookings: Array<CandidateInformationShift>;
  candidateId: Scalars['String']['output'];
  flexShift?: Maybe<CandidateInformationShift>;
  hasActiveSuggestion: Scalars['Boolean']['output'];
  newShift: ScheduleSlot;
  resourceAvailability: Array<ResourceAvailability>;
  shiftAvailability: ShiftAvailability;
  violations: SchedulingViolations;
  weekOverview: CandidateScheduleOverview;
};

export type AggregatedSalariesMetadata = {
  __typename?: 'AggregatedSalariesMetadata';
  aggregatedAt: Scalars['Int']['output'];
  numberOfReportedSalaries: Scalars['Int']['output'];
  options: SalariesOptionsMap;
};

export type AggregatedSalaryGroup = {
  __typename?: 'AggregatedSalaryGroup';
  aggregatedAt: Scalars['Int']['output'];
  country: Country;
  profession: Profession;
  region: Region;
  specialization: Specialization;
  values: Array<Scalars['Float']['output']>;
};

export type AlgoliaLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius?: Scalars['Int']['input'];
};

export type AllTenderSuppliersFilterArgs = {
  hideBlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllowedShiftInput = {
  breakTime: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  maxLength: Scalars['Int']['input'];
  minLength: Scalars['Int']['input'];
  scheduleResourceId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum ApplicationSource {
  GENERATED = 'GENERATED',
  JOB_APPLICATION = 'JOB_APPLICATION',
  VACANCY_APPLICATION = 'VACANCY_APPLICATION'
}

export type AppliedToVacancyWrapper = {
  __typename?: 'AppliedToVacancyWrapper';
  appliedAt: Scalars['Int']['output'];
  appliedDirectly: Scalars['Boolean']['output'];
  vacancy: Vacancy;
};

export type ApplyToShiftInput = {
  scheduleSlotId: Scalars['String']['input'];
};

export type ArchiveConnectionAndRemoveEmployerContactInput = {
  connectionId: Scalars['String']['input'];
};

export type ArchiveConnectionInput = {
  connectionId: Scalars['String']['input'];
};

export type ArchiveShiftInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['String']['input'];
};

export type AssignInput = {
  assignee: Scalars['String']['input'];
  jobApplicationId: Scalars['String']['input'];
};

export type Assignment = {
  __typename?: 'Assignment';
  bookingId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  file: File;
  id: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parentType: AttachmentParentType;
  referenceUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export enum AttachmentParentType {
  PRESENTATION = 'PRESENTATION',
  REFERENCE = 'REFERENCE',
  REQUIREMENT_FULFILLMENT = 'REQUIREMENT_FULFILLMENT',
  TENDER = 'TENDER'
}

export type AttestTimesheetInput = {
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  onCallDisturbances?: InputMaybe<Array<OnCallDisturbanceInput>>;
  startDateTime: Scalars['Date']['input'];
  timesheetId: Scalars['String']['input'];
};

export type AttributionCriterion = {
  __typename?: 'AttributionCriterion';
  id: Scalars['String']['output'];
  tenderId: Scalars['String']['output'];
  type: AttributionCriterionType;
  weight: Scalars['Float']['output'];
};

export type AttributionCriterionScoring = {
  __typename?: 'AttributionCriterionScoring';
  attributionCriterion: AttributionCriterion;
  attributionCriterionId: Scalars['String']['output'];
  calculatedValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  presentationId: Scalars['String']['output'];
  reportedValue?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export enum AttributionCriterionType {
  CONTINUITY = 'CONTINUITY',
  FILL_RATE = 'FILL_RATE'
}

export type AvailabilityScope = {
  __typename?: 'AvailabilityScope';
  scope: Scalars['Int']['output'];
  shiftHours: Array<ShiftHours>;
};

export type AvailableTenderPriceGroup = {
  __typename?: 'AvailableTenderPriceGroup';
  basePay: Scalars['Float']['output'];
  compensationModelId?: Maybe<Scalars['String']['output']>;
  currency: Currency;
  id: Scalars['String']['output'];
  priceGroupId: Scalars['String']['output'];
  priceZoneId?: Maybe<Scalars['String']['output']>;
  pricing: TenderPricing;
  priority?: Maybe<Scalars['Int']['output']>;
  specializations: Array<Specialization>;
  supplierId: Scalars['String']['output'];
  tenderId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TenderPriceGroupType;
};

export type BankIdCert = {
  __typename?: 'BankIdCert';
  notAfter: Scalars['String']['output'];
  notBefore: Scalars['String']['output'];
};

export type BankIdDevice = {
  __typename?: 'BankIdDevice';
  ipAddress: Scalars['String']['output'];
};

export type BankIdOrder = {
  __typename?: 'BankIdOrder';
  autoStartToken: Scalars['String']['output'];
  orderRef: Scalars['String']['output'];
};

export type BankIdSignature = {
  __typename?: 'BankIdSignature';
  cert: BankIdCert;
  device: BankIdDevice;
  ocspResponse: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  user: BankIdUser;
};

export type BankIdTransaction = {
  __typename?: 'BankIdTransaction';
  hintCode?: Maybe<Scalars['String']['output']>;
  orderRef: Scalars['String']['output'];
  status: BankIdTransactionStatus;
};

export enum BankIdTransactionStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type BankIdUser = {
  __typename?: 'BankIdUser';
  givenName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personalNumber: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type BaseSchedule = {
  __typename?: 'BaseSchedule';
  createdAt: Scalars['Date']['output'];
  defaultForUnitId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  scheduleDraft: ScheduleDraft;
  scheduleDraftId: Scalars['String']['output'];
};

export type BatscriptInterpreterInput = {
  locale?: InputMaybe<Locale>;
  medium: Medium;
  templateString: Scalars['String']['input'];
  vacancy?: InputMaybe<CompleteVacancyInput>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type BillingInformation = {
  __typename?: 'BillingInformation';
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressPlace?: Maybe<Scalars['String']['output']>;
  billingAddressPostalCode?: Maybe<Scalars['String']['output']>;
  billingAddressStreet1?: Maybe<Scalars['String']['output']>;
  billingAddressStreet2?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingReference?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export enum BillingStatus {
  CREDITED = 'CREDITED',
  INVOICE_PAID = 'INVOICE_PAID',
  INVOICE_SENT = 'INVOICE_SENT',
  UNHANDLED = 'UNHANDLED'
}

export type BookCandidateOnFlexShiftsInput = {
  candidateId: Scalars['String']['input'];
  flexShifts: Array<FlexShiftInput>;
};

export type BookCandidateOnShiftInput = {
  candidateId: Scalars['String']['input'];
  flexShiftId?: InputMaybe<Scalars['String']['input']>;
  scheduleSlotId: Scalars['String']['input'];
};

export type BookedAvailability = {
  __typename?: 'BookedAvailability';
  days: Array<BookedDay>;
  id: Scalars['String']['output'];
  scope: AvailabilityScope;
};

export type BookedDay = {
  __typename?: 'BookedDay';
  id: Scalars['String']['output'];
};

export type BookingStatisticsDataPoint = {
  __typename?: 'BookingStatisticsDataPoint';
  basePay: Scalars['Float']['output'];
  bookingId: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  hours: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  personalIdentityNumber: Scalars['String']['output'];
  presentationId: Scalars['String']['output'];
  priceGroupId?: Maybe<Scalars['String']['output']>;
  profession: Profession;
  specializations: Array<Specialization>;
  supplierId: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  tenderId: Scalars['String']['output'];
  tenderTitle: Scalars['String']['output'];
  tenderWaiverTitle?: Maybe<Scalars['String']['output']>;
  timeUnit: StatisticsTimeUnit;
  timestamp: Scalars['Date']['output'];
  unitId: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
};

export type BroadcastMessage = {
  __typename?: 'BroadcastMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  publishedBy: Scalars['String']['output'];
  recipientGroups: Array<BroadcastMessageRecipientGroup>;
  recipientOrganizationIds: Array<Scalars['String']['output']>;
  sender: Organization;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum BroadcastMessageRecipientGroup {
  EMPLOYEES = 'EMPLOYEES',
  INTERNAL = 'INTERNAL',
  SUPPLIERS = 'SUPPLIERS'
}

export type CancelScheduleDraftGenerationInput = {
  id: Scalars['String']['input'];
  useLatestOutput?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelShiftBookingInput = {
  reason?: InputMaybe<ShiftBookingCancellationReason>;
  shiftBookingId: Scalars['String']['input'];
};

export type Candidate = {
  __typename?: 'Candidate';
  address?: Maybe<Scalars['String']['output']>;
  assigneeId?: Maybe<Scalars['String']['output']>;
  bornAt?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Array<CandidateComment>>;
  /** @deprecated Will be replaced soon */
  contactStatus?: Maybe<ConnectionContactStatus>;
  contract?: Maybe<CandidateContract>;
  createdAt: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayProfile: DisplayProfile;
  email?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  fileUploads: Array<FileUpload>;
  fullName: Scalars['String']['output'];
  graduatedAt?: Maybe<Scalars['Float']['output']>;
  homeCountry?: Maybe<Country>;
  homeMunicipality?: Maybe<Scalars['String']['output']>;
  homeRegion?: Maybe<WhichRegionAlternative>;
  homeUnit?: Maybe<Unit>;
  hprNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  interests: CandidateInterests;
  isInterestedInContact?: Maybe<Scalars['Boolean']['output']>;
  /** Only exists for sovereign candidates right now */
  lead?: Maybe<CandidateLead>;
  /** ID of the candidate a BOOKED or MIRRORED candidate is tied to. */
  mirrorOf?: Maybe<Scalars['String']['output']>;
  personalIdentityNumber?: Maybe<Scalars['String']['output']>;
  personalIdentityNumberSource?: Maybe<Scalars['String']['output']>;
  personalIdentityNumberUpdatedAt?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profession: Profession;
  /** ID of the profile a SOVEREIGN or MIRRORED candidate is tied to. */
  profileId?: Maybe<Scalars['String']['output']>;
  qualifications: CandidateQualifications;
  shiftApplicationsInLast30daysCount: Scalars['Int']['output'];
  status?: Maybe<ConnectionStatus>;
  tags: Array<Tag>;
  type: CandidateType;
  updatedAt: Scalars['Float']['output'];
};

export type CandidateBooking = {
  __typename?: 'CandidateBooking';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  bookedAvailabilities: Array<BookedAvailability>;
  candidateBookingStatistics: CandidateBookingStatistics;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  displayProfile?: Maybe<DisplayProfile>;
  /** Id of the supplier organization */
  employerId: Scalars['String']['output'];
  /** Date of last booked shift */
  endsAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  managerIds: Array<Scalars['String']['output']>;
  managers: Array<Identity>;
  orderer: Organization;
  /** Id of the orderer organization */
  organizationId: Scalars['String']['output'];
  presentation: Presentation;
  presentationId: Scalars['String']['output'];
  replacementFor?: Maybe<CandidateBooking>;
  schedule: Array<CandidateScheduleSlot>;
  shifts: Array<ShiftBooking>;
  /** Date of first booked shift */
  startsAt: Scalars['Date']['output'];
  status: CandidateBookingStatus;
  suggestions: Array<ShiftSuggestion>;
  supplier: Organization;
  tender: Tender;
  tenderId: Scalars['String']['output'];
  timesheets: Array<Timesheet>;
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CandidateBookingEdge = {
  __typename?: 'CandidateBookingEdge';
  cursor: Scalars['String']['output'];
  node: CandidateBooking;
};

export type CandidateBookingFilter = {
  AND?: InputMaybe<Array<CandidateBookingFilter>>;
  NOT?: InputMaybe<Array<CandidateBookingFilter>>;
  OR?: InputMaybe<Array<CandidateBookingFilter>>;
  archivedAt?: InputMaybe<DateComparator>;
  archivedBy?: InputMaybe<IdComparator>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  employerId?: InputMaybe<IdComparator>;
  endsAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  managerIds?: InputMaybe<IdArrayComparator>;
  organizationId?: InputMaybe<IdComparator>;
  presentation?: InputMaybe<PresentationFilter>;
  presentationId?: InputMaybe<IdComparator>;
  startsAt?: InputMaybe<DateComparator>;
  status?: InputMaybe<CandidateBookingStatusComparator>;
  tender?: InputMaybe<TenderFilter>;
  tenderId?: InputMaybe<IdComparator>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export type CandidateBookingStatistics = {
  __typename?: 'CandidateBookingStatistics';
  count: Scalars['Int']['output'];
  fillRate?: Maybe<Scalars['Float']['output']>;
  hours: Scalars['Float']['output'];
};

export enum CandidateBookingStatus {
  ARCHIVED = 'ARCHIVED',
  BOOKED = 'BOOKED',
  COMPLETED = 'COMPLETED'
}

export type CandidateBookingStatusComparator = {
  eq?: InputMaybe<CandidateBookingStatus>;
  in?: InputMaybe<Array<CandidateBookingStatus>>;
  neq?: InputMaybe<CandidateBookingStatus>;
  nin?: InputMaybe<Array<CandidateBookingStatus>>;
};

export type CandidateBookingsCursorSearchResult = {
  __typename?: 'CandidateBookingsCursorSearchResult';
  edges: Array<CandidateBookingEdge>;
  pageInfo: PageInfo;
};

export type CandidateComment = {
  __typename?: 'CandidateComment';
  candidateId: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CandidateContract = {
  __typename?: 'CandidateContract';
  allowedShiftHours: Array<ShiftHours>;
  defaultDayBreak?: Maybe<Scalars['String']['output']>;
  defaultWeekBreak?: Maybe<Scalars['String']['output']>;
  employment: EmploymentType;
  endsAt?: Maybe<Scalars['Date']['output']>;
  fullTimeWeekly: Scalars['Float']['output'];
  homeUnitId: Scalars['String']['output'];
  organizationKeys: Array<Scalars['String']['output']>;
  serviceLevel: Scalars['Float']['output'];
  startsAt?: Maybe<Scalars['Date']['output']>;
  weekendFrequency?: Maybe<Scalars['String']['output']>;
};

export type CandidateContractFilter = {
  AND?: InputMaybe<Array<CandidateContractFilter>>;
  NOT?: InputMaybe<Array<CandidateContractFilter>>;
  OR?: InputMaybe<Array<CandidateContractFilter>>;
  allowedShiftHours?: InputMaybe<ShiftHoursArrayComparator>;
  employment?: InputMaybe<EmploymentTypeComparator>;
  endsAt?: InputMaybe<NullableDateComparator>;
  fullTimeWeekly?: InputMaybe<NumberComparator>;
  homeUnit?: InputMaybe<UnitFilter>;
  homeUnitId?: InputMaybe<IdComparator>;
  organizationKeys?: InputMaybe<IdArrayComparator>;
  serviceLevel?: InputMaybe<NumberComparator>;
  startsAt?: InputMaybe<NullableDateComparator>;
};

export type CandidateContractInput = {
  allowedShiftHours?: InputMaybe<Array<ShiftHours>>;
  defaultDayBreak?: InputMaybe<Scalars['String']['input']>;
  defaultWeekBreak?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentType>;
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  fullTimeWeekly?: InputMaybe<Scalars['Float']['input']>;
  homeUnitId?: InputMaybe<Scalars['String']['input']>;
  organizationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceLevel?: InputMaybe<Scalars['Float']['input']>;
  startsAt?: InputMaybe<Scalars['Date']['input']>;
  weekendFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateCursorSearchResult = {
  __typename?: 'CandidateCursorSearchResult';
  edges: Array<CandidateEdge>;
  pageInfo: PageInfo;
};

export type CandidateEdge = {
  __typename?: 'CandidateEdge';
  cursor: Scalars['String']['output'];
  node: Candidate;
};

export type CandidateFilter = {
  AND?: InputMaybe<Array<CandidateFilter>>;
  NOT?: InputMaybe<Array<CandidateFilter>>;
  OR?: InputMaybe<Array<CandidateFilter>>;
  address?: InputMaybe<StringComparator>;
  assignedTo?: InputMaybe<NullableIdComparator>;
  availability?: InputMaybe<ResourceAvailabilityListRelationComparator>;
  bornAt?: InputMaybe<DateComparator>;
  candidateBooking?: InputMaybe<CandidateBookingFilter>;
  contactStatus?: InputMaybe<ConnectionContactStatusComparator>;
  contract?: InputMaybe<CandidateContractFilter>;
  createdAt?: InputMaybe<DateComparator>;
  email?: InputMaybe<StringComparator>;
  experience?: InputMaybe<NumberComparator>;
  fullName?: InputMaybe<StringComparator>;
  graduatedAt?: InputMaybe<DateComparator>;
  homeCountry?: InputMaybe<CountryComparator>;
  homeMunicipality?: InputMaybe<MunicipalityComparator>;
  homeRegion?: InputMaybe<RegionComparator>;
  id?: InputMaybe<IdComparator>;
  identity?: InputMaybe<IdentityFilter>;
  interests?: InputMaybe<CandidateInterestsFilter>;
  personalIdentityNumber?: InputMaybe<IdComparator>;
  personalIdentityNumberSource?: InputMaybe<PersonalIdentityNumberSourceComparator>;
  personalIdentityNumberUpdatedAt?: InputMaybe<DateComparator>;
  phoneNumber?: InputMaybe<StringComparator>;
  profession?: InputMaybe<ProfessionComparator>;
  profileId?: InputMaybe<NullableIdComparator>;
  qualifications?: InputMaybe<CandidateQualificationsFilter>;
  shiftBookings?: InputMaybe<ShiftBookingListRelationComparator>;
  status?: InputMaybe<ConnectionStatusComparator>;
  tags?: InputMaybe<IdArrayComparator>;
  type?: InputMaybe<CandidateTypeComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export type CandidateInformationShift = {
  __typename?: 'CandidateInformationShift';
  activity: ShiftActivity;
  breakTime: Scalars['Float']['output'];
  endDateTime: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  startDateTime: Scalars['Date']['output'];
  unitId: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
};

export type CandidateInterests = {
  __typename?: 'CandidateInterests';
  availabilityFreeText?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Array<Country>>;
  departments?: Maybe<Array<WhichDepartmentToWorkInAlternative>>;
  jobTypes?: Maybe<Array<JobType>>;
  municipalities?: Maybe<Array<Municipality>>;
  regions?: Maybe<Array<WhichRegionAlternative>>;
  shiftHours?: Maybe<Array<ShiftHours>>;
  /** Expects week numbers in the format of 33, 43 etc. */
  weekInterests?: Maybe<Array<Scalars['String']['output']>>;
  workForms?: Maybe<Array<WorkForm>>;
};

export type CandidateInterestsFilter = {
  AND?: InputMaybe<Array<CandidateInterestsFilter>>;
  NOT?: InputMaybe<Array<CandidateInterestsFilter>>;
  OR?: InputMaybe<Array<CandidateInterestsFilter>>;
  countries?: InputMaybe<CountryArrayComparator>;
  departments?: InputMaybe<DepartmentArrayComparator>;
  jobTypes?: InputMaybe<JobTypeArrayComparator>;
  municipalities?: InputMaybe<MunicipalityArrayComparator>;
  regions?: InputMaybe<RegionArrayComparator>;
  shiftHours?: InputMaybe<ShiftHoursArrayComparator>;
  workForms?: InputMaybe<WorkFormArrayComparator>;
};

export type CandidateInterestsInput = {
  availabilityFreeText?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Country>>;
  departments?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  jobTypes?: InputMaybe<Array<JobType>>;
  municipalities?: InputMaybe<Array<Municipality>>;
  regions?: InputMaybe<Array<WhichRegionAlternative>>;
  shiftHours?: InputMaybe<Array<ShiftHours>>;
  /** Expects week numbers in the format of 33, 43 etc. */
  weekInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  workForms?: InputMaybe<Array<WorkForm>>;
};

export type CandidateLead = {
  __typename?: 'CandidateLead';
  employmentStatus?: Maybe<CurrentEmploymentStatus>;
  extent?: Maybe<HowMuchWorkAlternative>;
  karens?: Maybe<Array<WhichRegionAlternative>>;
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type CandidateLeadInput = {
  employmentStatus?: InputMaybe<CurrentEmploymentStatus>;
  extent?: InputMaybe<HowMuchWorkAlternative>;
  karens?: InputMaybe<Array<WhichRegionAlternative>>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateQualifications = {
  __typename?: 'CandidateQualifications';
  driversLicenses?: Maybe<Array<DriversLicense>>;
  isMedsTrained?: Maybe<Scalars['Boolean']['output']>;
  journalSystems?: Maybe<Array<JournalSystem>>;
  norwegianLicenseStatus?: Maybe<LicenseStatus>;
  specializations?: Maybe<Array<Specialization>>;
  swedishLicenseStatus?: Maybe<LicenseStatus>;
};

export type CandidateQualificationsFilter = {
  AND?: InputMaybe<Array<CandidateQualificationsFilter>>;
  NOT?: InputMaybe<Array<CandidateQualificationsFilter>>;
  OR?: InputMaybe<Array<CandidateQualificationsFilter>>;
  driversLicenses?: InputMaybe<DriversLicenseArrayComparator>;
  isMedsTrained?: InputMaybe<NullableBooleanComparator>;
  journalSystems?: InputMaybe<JournalSystemArrayComparator>;
  norwegianLicenseStatus?: InputMaybe<LicenseStatusComparator>;
  specializations?: InputMaybe<SpecializationArrayComparator>;
  swedishLicenseStatus?: InputMaybe<LicenseStatusComparator>;
};

export type CandidateQualificationsInput = {
  driversLicenses?: InputMaybe<Array<DriversLicense>>;
  isMedsTrained?: InputMaybe<Scalars['Boolean']['input']>;
  journalSystems?: InputMaybe<Array<JournalSystem>>;
  norwegianLicenseStatus?: InputMaybe<LicenseStatus>;
  specializations?: InputMaybe<Array<Specialization>>;
  swedishLicenseStatus?: InputMaybe<LicenseStatus>;
};

export enum CandidateRequirementType {
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
  CUSTOM = 'CUSTOM',
  CV_DOCUMENT = 'CV_DOCUMENT',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  EXPERIENCE = 'EXPERIENCE',
  HOSP_DOCUMENT = 'HOSP_DOCUMENT',
  IVO_DOCUMENT = 'IVO_DOCUMENT',
  JOURNAL_SYSTEM = 'JOURNAL_SYSTEM',
  OTHER_DOCUMENT = 'OTHER_DOCUMENT',
  REFERENCE = 'REFERENCE',
  REFERENCE_DOCUMENT = 'REFERENCE_DOCUMENT',
  SITH_CARD = 'SITH_CARD',
  SPECIALIZATION = 'SPECIALIZATION',
  SPECIALIZATION_DOCUMENT = 'SPECIALIZATION_DOCUMENT'
}

export type CandidateScheduleOverview = {
  __typename?: 'CandidateScheduleOverview';
  bookedHours: Scalars['Float']['output'];
  bookedShiftsCount: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
};

export type CandidateScheduleSlot = {
  __typename?: 'CandidateScheduleSlot';
  activity: ShiftActivity;
  applications: Array<ShiftApplication>;
  breakTime: Scalars['Float']['output'];
  candidateId: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSeen: Scalars['Boolean']['output'];
  isUninteresting: Scalars['Boolean']['output'];
  myMostRecentApplication?: Maybe<ShiftApplication>;
  myMostRecentBooking?: Maybe<ShiftBooking>;
  scheduleResource: ScheduleResource;
  scheduleResourceId: Scalars['String']['output'];
  seenCount: Scalars['Int']['output'];
  shifts: Array<Shift>;
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  suggestions: Array<ShiftSuggestion>;
  tags: Array<Tag>;
  uninterestingCount: Scalars['Int']['output'];
  unit: Unit;
  unitId: Scalars['String']['output'];
};

export enum CandidateType {
  BOOKED = 'BOOKED',
  EMPLOYED = 'EMPLOYED',
  MANAGED = 'MANAGED',
  MIRRORED = 'MIRRORED',
  SOVEREIGN = 'SOVEREIGN',
  STATIC = 'STATIC',
  SYNCED = 'SYNCED'
}

export type CandidateTypeComparator = {
  eq?: InputMaybe<CandidateType>;
  in?: InputMaybe<Array<CandidateType>>;
  neq?: InputMaybe<CandidateType>;
  nin?: InputMaybe<Array<CandidateType>>;
};

export type Comment = {
  __typename?: 'Comment';
  blogPostSlug: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  freeText: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  isModerator: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCommentId?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Profession>;
};

export type CompanyRating = {
  __typename?: 'CompanyRating';
  averageRating: Scalars['Float']['output'];
  bayesScore: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
};

export type CompanyReview = {
  __typename?: 'CompanyReview';
  companyReply?: Maybe<Reply>;
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  freeText: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  market: Market;
  name?: Maybe<Scalars['String']['output']>;
  profession: Profession;
  rating?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<BankIdSignature>;
};

export type CompensationInterval = {
  __typename?: 'CompensationInterval';
  activity: CompensationIntervalActivity;
  articleId?: Maybe<Scalars['String']['output']>;
  compensationValue: Scalars['Float']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAdditive: Scalars['Boolean']['output'];
  isAllDay: Scalars['Boolean']['output'];
  modifier: CompensationModifier;
  startTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
  validDays: Array<CompensationModelDay>;
};

export enum CompensationIntervalActivity {
  ACTIVE_NON_RESIDENT_ON_CALL = 'ACTIVE_NON_RESIDENT_ON_CALL',
  ACTIVE_RESIDENT_ON_CALL = 'ACTIVE_RESIDENT_ON_CALL',
  NON_RESIDENT_ON_CALL = 'NON_RESIDENT_ON_CALL',
  ORDINARY = 'ORDINARY',
  RESIDENT_ON_CALL = 'RESIDENT_ON_CALL'
}

export type CompensationModel = {
  __typename?: 'CompensationModel';
  country: Country;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  intervals: Array<CompensationInterval>;
  organizationId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum CompensationModelDay {
  DAY_BEFORE_HOLIDAY = 'DAY_BEFORE_HOLIDAY',
  FRIDAY = 'FRIDAY',
  HOLIDAY = 'HOLIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SMALL_HOLIDAY = 'SMALL_HOLIDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export enum CompensationModifier {
  ADDITION = 'ADDITION',
  FACTOR = 'FACTOR',
  NONE = 'NONE'
}

export type CompleteJobPostingInput = {
  archivedAt?: InputMaybe<Scalars['Int']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  descriptionHtml: Scalars['String']['input'];
  descriptionTemplate: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  integration: JobPostingIntegration;
  lastApplicationDate?: InputMaybe<Scalars['Date']['input']>;
  locale: Locale;
  publishedAt?: InputMaybe<Scalars['Int']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  publishingError?: InputMaybe<Scalars['String']['input']>;
  status: JobPostingStatus;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};

export type CompleteVacancyEstimatedCompensation = {
  high: Scalars['Float']['input'];
  low: Scalars['Float']['input'];
  updatedAt: Scalars['Int']['input'];
};

export type CompleteVacancyInput = {
  assignedTo: Array<Scalars['String']['input']>;
  country: Country;
  createdAt: Scalars['Int']['input'];
  department: WhichDepartmentToWorkInAlternative;
  description?: InputMaybe<Scalars['String']['input']>;
  driversLicenseRequirements: DriversLicense;
  employerId: Scalars['String']['input'];
  /** Cached calculation of vacancy salary. Assumes includeHolidayPay is true. Estimate updated on vacancy review. No additional reads required. */
  expectedCompensation?: InputMaybe<CompleteVacancyEstimatedCompensation>;
  experienceRequired?: InputMaybe<HowMuchExperienceAlternative>;
  freeTextRequirements?: InputMaybe<Scalars['String']['input']>;
  hasLastApplicationDate: Scalars['Boolean']['input'];
  howMuchWork?: InputMaybe<HowMuchWorkAlternative>;
  id: Scalars['String']['input'];
  internalComment?: InputMaybe<Scalars['String']['input']>;
  isSpecializationRequired: Scalars['Boolean']['input'];
  jobEndsAt?: InputMaybe<Scalars['Int']['input']>;
  jobStartsAt?: InputMaybe<Scalars['Int']['input']>;
  jobType: JobType;
  journalSystems: Array<JournalSystem>;
  lastApplicationDate?: InputMaybe<Scalars['Date']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  numberOfResources: Scalars['Int']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  origin: VacancyOrigin;
  procuredAmount?: InputMaybe<Scalars['Float']['input']>;
  procuredAmountCurrency?: InputMaybe<Currency>;
  profession: Profession;
  region: WhichRegionAlternative;
  reviewStatus: VacancyReviewStatus;
  specializations: Array<Specialization>;
  status?: InputMaybe<VacancyStatus>;
  tags: Array<Scalars['String']['input']>;
  tenderId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
  viewedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  workHours: Array<WorkHours>;
};

export type ConflictingShiftsViolation = {
  shiftId: Scalars['String']['output'];
  type: SchedulingViolationsType;
  violatingShift?: Maybe<CandidateInformationShift>;
  violatingShiftId: Scalars['String']['output'];
};

export enum ConnectionContactStatus {
  ABANDONED = 'ABANDONED',
  AWAITING_DOCUMENTS = 'AWAITING_DOCUMENTS',
  BOOKED_FOR_MISSION = 'BOOKED_FOR_MISSION',
  CONTACTED = 'CONTACTED',
  CONTACT_REQUEST_ACCEPTED = 'CONTACT_REQUEST_ACCEPTED',
  CONTACT_REQUEST_SENT = 'CONTACT_REQUEST_SENT',
  EXISTING_CONTACT = 'EXISTING_CONTACT',
  IN_CONTACT = 'IN_CONTACT',
  IN_DISCUSSION = 'IN_DISCUSSION',
  NO_RESPONSE = 'NO_RESPONSE',
  ON_MISSION = 'ON_MISSION',
  PRESENTED = 'PRESENTED'
}

export type ConnectionContactStatusComparator = {
  eq?: InputMaybe<ConnectionContactStatus>;
  in?: InputMaybe<Array<ConnectionContactStatus>>;
  neq?: InputMaybe<ConnectionContactStatus>;
  nin?: InputMaybe<Array<ConnectionContactStatus>>;
};

export enum ConnectionSource {
  CANDIDATE_SENT_CONTACT_REQUEST = 'CANDIDATE_SENT_CONTACT_REQUEST',
  DIRECT_JOB_POSTING_APPLICATION = 'DIRECT_JOB_POSTING_APPLICATION',
  EMPLOYER_SENT_CONTACT_REQUEST = 'EMPLOYER_SENT_CONTACT_REQUEST'
}

export enum ConnectionStatus {
  ARCHIVED = 'ARCHIVED',
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  UNLOCKED = 'UNLOCKED'
}

export type ConnectionStatusComparator = {
  eq?: InputMaybe<ConnectionStatus>;
  in?: InputMaybe<Array<ConnectionStatus>>;
  neq?: InputMaybe<ConnectionStatus>;
  nin?: InputMaybe<Array<ConnectionStatus>>;
};

export type ConsultantCredentials = {
  __typename?: 'ConsultantCredentials';
  code: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type ContactOnJobPostingInput = {
  contacting: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};

export type ContactPreferences = {
  __typename?: 'ContactPreferences';
  identityId: Scalars['String']['output'];
  isInterestedInContact: Scalars['Boolean']['output'];
  isInterestedInMatchingVacancies?: Maybe<Scalars['Boolean']['output']>;
  market: Scalars['String']['output'];
  updatedIsInterestedInContactAt: Scalars['Date']['output'];
  updatedIsInterestedInMatchingVacanciesAt?: Maybe<Scalars['Date']['output']>;
};

export type ContactRequest = {
  __typename?: 'ContactRequest';
  acceptedAt?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  connection: AbstractConnection;
  contactRequestOpenedAt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  displayProfile: DisplayProfile;
  emailSentAt?: Maybe<Scalars['Int']['output']>;
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastReminderSentAt?: Maybe<Scalars['Int']['output']>;
  noteFromEmployer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Always returns 0 */
  numberOfMatchingVacancies: Scalars['Int']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  profileId: Scalars['String']['output'];
  rejectedAt?: Maybe<Scalars['Int']['output']>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<ContactRequestRejectionReason>;
  sender?: Maybe<Identity>;
  senderId: Scalars['String']['output'];
  sentBy: Scalars['String']['output'];
  sentReminderCount?: Maybe<Scalars['Int']['output']>;
  status: ContactRequestStatus;
  textSentAt?: Maybe<Scalars['Int']['output']>;
  vacancyIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ContactRequestRejectionReason {
  ALREADY_IN_CONTACT = 'ALREADY_IN_CONTACT',
  DISLIKE_COMPANY = 'DISLIKE_COMPANY'
}

export enum ContactRequestStatus {
  ACCEPTED = 'ACCEPTED',
  ARCHIVED = 'ARCHIVED',
  REJECTED = 'REJECTED',
  SENT = 'SENT'
}

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  externalConversation?: Maybe<ExternalConversation>;
  hasFlaggedMessages: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internalConversation?: Maybe<InternalConversation>;
  isMember: Scalars['Boolean']['output'];
  lastMessage?: Maybe<Message>;
  members: Array<ConversationMember>;
  messages: Array<Message>;
  presentation?: Maybe<Presentation>;
  tender?: Maybe<Tender>;
  tenderWaiver?: Maybe<TenderWaiver>;
  title?: Maybe<Scalars['String']['output']>;
  topic: ConversationTopic;
  type: ConversationType;
  updatedAt: Scalars['Date']['output'];
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor: Scalars['String']['output'];
  node: Conversation;
};

export type ConversationFilter = {
  AND?: InputMaybe<Array<ConversationFilter>>;
  NOT?: InputMaybe<ConversationFilter>;
  OR?: InputMaybe<Array<ConversationFilter>>;
  candidate?: InputMaybe<CandidateFilter>;
  hasUnreadMessages?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdComparator>;
  inConversation?: InputMaybe<IdComparator>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<StringComparator>;
  partnerOrganizationId?: InputMaybe<NullableIdComparator>;
  presentation?: InputMaybe<PresentationFilter>;
  tender?: InputMaybe<TenderFilter>;
  tenderWaiver?: InputMaybe<TenderWaiverFilter>;
  title?: InputMaybe<StringComparator>;
  unit?: InputMaybe<UnitFilter>;
};

export type ConversationMember = {
  __typename?: 'ConversationMember';
  conversationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  joinedAt: Scalars['Date']['output'];
  sender: Identity;
};

export type ConversationTopic = {
  __typename?: 'ConversationTopic';
  id?: Maybe<Scalars['String']['output']>;
  type: ConversationTopicType;
};

export enum ConversationTopicType {
  CANDIDATE = 'CANDIDATE',
  NONE = 'NONE',
  PRESENTATION = 'PRESENTATION',
  TENDER = 'TENDER',
  TENDER_WAIVER = 'TENDER_WAIVER',
  UNIT = 'UNIT'
}

export enum ConversationType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export type ConversationsCursorSearchResult = {
  __typename?: 'ConversationsCursorSearchResult';
  edges: Array<ConversationEdge>;
  pageInfo: PageInfo;
};

export type ConvertFileUploadToAttachmentInput = {
  fileUploadId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: AttachmentParentType;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CopyTenderInput = {
  fromDate: Scalars['Date']['input'];
  id: Scalars['String']['input'];
};

export { Country };

export type CountryArrayComparator = {
  all?: InputMaybe<Array<Country>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<Country>>;
  has?: InputMaybe<Country>;
  some?: InputMaybe<Array<Country>>;
};

export type CountryComparator = {
  eq?: InputMaybe<Country>;
  in?: InputMaybe<Array<Country>>;
  neq?: InputMaybe<Country>;
  nin?: InputMaybe<Array<Country>>;
};

export type CreateAcceptedAvailabilityInput = {
  days: Array<CreateAcceptedDayInput>;
  presentedAvailabilityId: Scalars['String']['input'];
  scope: CreateAvailabilityScopeInput;
};

export type CreateAcceptedDayInput = {
  presentedDayId: Scalars['String']['input'];
};

export type CreateAttributionCriterionInput = {
  type: AttributionCriterionType;
  weight: Scalars['Float']['input'];
};

export type CreateAvailabilityScopeInput = {
  scope: Scalars['Int']['input'];
  shiftHours: Array<ShiftHours>;
};

export type CreateBaseScheduleInput = {
  isDefault: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  scheduleDraftId: Scalars['String']['input'];
};

export type CreateBillingInformationInput = {
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressPlace?: InputMaybe<Scalars['String']['input']>;
  billingAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingAddressStreet1?: InputMaybe<Scalars['String']['input']>;
  billingAddressStreet2?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingReference?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateBroadcastMessageInput = {
  content: Scalars['String']['input'];
  expiresAt: Scalars['Date']['input'];
  recipientGroups: Array<BroadcastMessageRecipientGroup>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCandidateCommentInput = {
  comment: Scalars['String']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  blogPostSlug: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  freeText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profession?: InputMaybe<Profession>;
};

export type CreateCompanyReviewInput = {
  email: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  freeText: Scalars['String']['input'];
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  market: Market;
  name?: InputMaybe<Scalars['String']['input']>;
  profession: Profession;
  rating: Scalars['Int']['input'];
};

export type CreateCompensationIntervalInput = {
  activity: CompensationIntervalActivity;
  articleId?: InputMaybe<Scalars['String']['input']>;
  compensationValue: Scalars['Float']['input'];
  endTime: Scalars['String']['input'];
  isAdditive: Scalars['Boolean']['input'];
  isAllDay: Scalars['Boolean']['input'];
  modifier: CompensationModifier;
  startTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
  validDays: Array<CompensationModelDay>;
};

export type CreateCompensationModelInput = {
  country: Country;
  createdIntervals?: InputMaybe<Array<CreateCompensationIntervalInput>>;
  title: Scalars['String']['input'];
};

export type CreateCustomRoleInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type CreateDelegationInput = {
  delegateId: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateEventBookmarkInput = {
  eventId: Scalars['String']['input'];
};

export type CreateExternalConversationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  partnerOrganizationId: Scalars['String']['input'];
  presentationId?: InputMaybe<Scalars['String']['input']>;
  tenderId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInternalConversationInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  identityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  presentationId?: InputMaybe<Scalars['String']['input']>;
  tenderId?: InputMaybe<Scalars['String']['input']>;
  tenderWaiverId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobApplicationInput = {
  employerId?: InputMaybe<Scalars['String']['input']>;
  /** Specify profileId when creating job applications as admin user */
  profileId?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobPostingTemplateInput = {
  data?: Scalars['String']['input'];
  descriptionTemplate: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  integration: JobPostingIntegration;
  locale: Locale;
  titleTemplate: Scalars['String']['input'];
};

export type CreateJobPostingsInput = {
  jobDescription: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  lastApplicationDate?: InputMaybe<Scalars['Date']['input']>;
  vacancyId: Scalars['String']['input'];
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  topicId: Scalars['String']['input'];
  topicType: TopicType;
};

export type CreateOrganizationInput = {
  defaultLocale: Scalars['String']['input'];
  defaultPricing?: InputMaybe<PricingInput>;
  displayName: Scalars['String']['input'];
  features: Array<EmployerFeatures>;
  graphicProfile?: InputMaybe<GraphicProfileInput>;
  id: Scalars['String']['input'];
  interest?: InputMaybe<InterestInput>;
  jobTypes: Array<JobType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  markets: Array<Market>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Markets the organization recruits in. E.g. should it show up on bemlo.se? */
  recruitsIn: Array<Market>;
  type: OrganizationType;
};

export type CreatePeriodInput = {
  endsAt: Scalars['Date']['input'];
  startsAt: Scalars['Date']['input'];
};

export type CreatePoolInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  unitIds: Array<Scalars['String']['input']>;
};

export type CreatePresentedAvailabilitiesInput = {
  availabilities: Array<CreatePresentedAvailabilityInput>;
  presentationId: Scalars['String']['input'];
};

export type CreatePresentedAvailabilityInput = {
  days: Array<CreatePresentedDayInput>;
  scope: CreateAvailabilityScopeInput;
  tenderedAvailabilityId: Scalars['String']['input'];
};

export type CreatePresentedDayInput = {
  tenderedDayId: Scalars['String']['input'];
};

export type CreatePriceZoneInput = {
  articlePrefix?: InputMaybe<Scalars['String']['input']>;
  municipalities: Array<Municipality>;
  title: Scalars['String']['input'];
};

export type CreateRankedCompanyInput = {
  id: Scalars['String']['input'];
  market: Market;
  organizationId: Scalars['String']['input'];
};

export type CreateReceiptInput = {
  articleInfo: Scalars['String']['input'];
  articleName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['Int']['input'];
};

export type CreateReferenceInput = {
  answers?: InputMaybe<ReferenceAnswersInput>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referentId: Scalars['String']['input'];
  type: ReferenceType;
};

export type CreateReplyInput = {
  blogPostSlug: Scalars['String']['input'];
  freeText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCommentId: Scalars['String']['input'];
};

export type CreateResourceAvailabilityInput = {
  candidateId: Scalars['String']['input'];
  endDateTime: Scalars['Date']['input'];
  /** If false the candidate will be marked as unavailable. */
  isAvailable?: Scalars['Boolean']['input'];
  shiftHours?: InputMaybe<ShiftHours>;
  source: ResourceAvailabilitySource;
  startDateTime: Scalars['Date']['input'];
};

export type CreateSalaryInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  baseSalary: Scalars['Int']['input'];
  company: Scalars['String']['input'];
  country: Country;
  email?: InputMaybe<Scalars['String']['input']>;
  experience: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  hasPerks: Scalars['Boolean']['input'];
  jobType: JobType;
  ob: Scalars['Boolean']['input'];
  obEvening?: InputMaybe<Scalars['Int']['input']>;
  obLongWeekend?: InputMaybe<Scalars['Int']['input']>;
  obNight?: InputMaybe<Scalars['Int']['input']>;
  obWeekend?: InputMaybe<Scalars['Int']['input']>;
  otherPerk?: InputMaybe<Scalars['String']['input']>;
  perks?: InputMaybe<Array<Perk>>;
  profession: Profession;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  specialization?: InputMaybe<Specialization>;
  summerJob?: InputMaybe<Scalars['Boolean']['input']>;
  tjanstePension: Scalars['Boolean']['input'];
  vacationIncluded: Scalars['Boolean']['input'];
  workForm: WorkForm;
  workplace: Scalars['String']['input'];
};

export type CreateScheduleDraftFromBaseScheduleInput = {
  baseScheduleId: Scalars['String']['input'];
  schedulingPeriodId: Scalars['String']['input'];
};

export type CreateScheduleDraftInput = {
  baseScheduleDraftId?: InputMaybe<Scalars['String']['input']>;
  schedulingPeriodId: Scalars['String']['input'];
};

export type CreateScheduleDraftResourcesInput = {
  resources: Array<ScheduleDraftResourceInput>;
  scheduleDraftId: Scalars['String']['input'];
};

export type CreateScheduleDraftShiftInput = {
  activity: ShiftActivity;
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  onCallTime?: InputMaybe<OnCallTimeInput>;
  scheduleResourceId: Scalars['String']['input'];
  startDateTime: Scalars['Date']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateScheduleResourceInput = {
  isMedsTrained?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  professions: Array<Profession>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  unitId: Scalars['String']['input'];
};

export type CreateSchedulingPeriodActivityInput = {
  activity: ShiftActivity;
  breakTime: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  day?: InputMaybe<Scalars['Int']['input']>;
  length: Scalars['Int']['input'];
  participants: Array<Scalars['String']['input']>;
  scheduleResourceId: Scalars['String']['input'];
  schedulingPeriodId: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};

export type CreateSchedulingPeriodConfigurationInput = {
  length?: InputMaybe<Scalars['Int']['input']>;
  preferencesDeadlineDaysPrior?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  schedulingDeadlineDaysPrior?: InputMaybe<Scalars['Int']['input']>;
  startsOnDay?: InputMaybe<Day>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchedulingPeriodInput = {
  index: Scalars['Int']['input'];
  /** Only applicable for the initial period */
  startsAt?: InputMaybe<Scalars['Date']['input']>;
  unitId: Scalars['String']['input'];
};

export type CreateSchedulingPeriodPromptInput = {
  isPersonal: Scalars['Boolean']['input'];
  prompt: Scalars['String']['input'];
  resourceConfigurationIds: Array<Scalars['String']['input']>;
};

export type CreateSchedulingPeriodResourceConfigurationInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  dayBreak?: InputMaybe<Scalars['String']['input']>;
  fullTimeWeekly?: InputMaybe<Scalars['Float']['input']>;
  hoursBalance?: InputMaybe<Scalars['Float']['input']>;
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  requiredDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  schedulingPeriodId: Scalars['String']['input'];
  serviceLevel?: InputMaybe<Scalars['Float']['input']>;
  shiftHours?: InputMaybe<Array<ShiftHours>>;
  unitId?: InputMaybe<Scalars['String']['input']>;
  weekBreak?: InputMaybe<Scalars['String']['input']>;
  weekendFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateShiftInput = {
  activity: ShiftActivity;
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  onCallTime?: InputMaybe<OnCallTimeInput>;
  scheduleResourceId: Scalars['String']['input'];
  startDateTime: Scalars['Date']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateShiftPresetInput = {
  breakTime: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  onCallTime?: InputMaybe<CreateShiftPresetOnCallTimeInput>;
  scheduleResourceId: Scalars['String']['input'];
  schedulingPeriodId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CreateShiftPresetOnCallTimeInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type: OnCallType;
};

export type CreateSupplierDeviationInput = {
  action: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  type: SupplierDeviationType;
};

export type CreateTagInput = {
  label: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateTenderFromWaiverInput = {
  scope?: InputMaybe<Scalars['Int']['input']>;
  shiftIds?: InputMaybe<Array<Scalars['String']['input']>>;
  waiverId: Scalars['String']['input'];
};

export type CreateTenderInput = {
  attributionCriteria?: InputMaybe<Array<CreateAttributionCriterionInput>>;
  billingInformationId?: InputMaybe<Scalars['String']['input']>;
  candidateDescription?: InputMaybe<Scalars['String']['input']>;
  contactPersonUserId?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  endsAt: Scalars['Date']['input'];
  fromTenderTemplateId?: InputMaybe<Scalars['String']['input']>;
  lastPresentationDate?: InputMaybe<Scalars['Date']['input']>;
  managerIds: Array<Scalars['String']['input']>;
  presentationReviewerIds: Array<Scalars['String']['input']>;
  pricing: TenderPricing;
  profession?: InputMaybe<Profession>;
  rows?: InputMaybe<TenderRowType>;
  scheduleDescription?: InputMaybe<Scalars['String']['input']>;
  scheduleResourceId: Scalars['String']['input'];
  scheduleType?: InputMaybe<TenderScheduleType>;
  scope: Scalars['Int']['input'];
  setupRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  shiftIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt: Scalars['Date']['input'];
  vacancyDescription?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTenderInvoiceInput = {
  candidateBookingId: Scalars['String']['input'];
  timesheetIds: Array<Scalars['String']['input']>;
};

export type CreateTenderPriceGroupInput = {
  departments: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  professions: Array<Profession>;
  specializations: Array<Specialization>;
  suppliers?: InputMaybe<Array<TenderPriceGroupSupplierInput>>;
  title: Scalars['String']['input'];
  type: TenderPriceGroupType;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTenderTemplateInput = {
  name: Scalars['String']['input'];
  profession: Profession;
};

export type CreateTenderWaiverInput = {
  department: WhichDepartmentToWorkInAlternative;
  endsAt: Scalars['Date']['input'];
  motivation: Scalars['String']['input'];
  profession: Profession;
  reviewerIds: Array<Scalars['String']['input']>;
  scheduleResourceId: Scalars['String']['input'];
  scope: Scalars['Int']['input'];
  specializations: Array<Specialization>;
  startsAt: Scalars['Date']['input'];
  unitId: Scalars['String']['input'];
  vacancyDescription?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTenderedAvailabilitiesInput = {
  availabilities: Array<CreateTenderedAvailabilityInput>;
  tenderId: Scalars['String']['input'];
};

export type CreateTenderedAvailabilityInput = {
  days: Array<CreateTenderedDayInput>;
  period: CreatePeriodInput;
  scope: CreateAvailabilityScopeInput;
};

export type CreateTenderedDayInput = {
  date: Scalars['Date']['input'];
};

export type CreateTenderedShiftInput = {
  activity: ShiftActivity;
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  onCallTime?: InputMaybe<OnCallTimeInput>;
  row: Scalars['Int']['input'];
  startDateTime: Scalars['Date']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUnitInput = {
  address: Scalars['String']['input'];
  country: Country;
  defaultBillingInformationId?: InputMaybe<Scalars['String']['input']>;
  /** Departments this unit can tender */
  departments: Array<WhichDepartmentToWorkInAlternative>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  municipality: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentUnitId?: InputMaybe<Scalars['String']['input']>;
  region: WhichRegionAlternative;
  shiftContactEmail?: InputMaybe<Scalars['String']['input']>;
  shiftContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  type: UnitType;
};

export type CreateVacancyInput = {
  assignedTo?: InputMaybe<Array<Scalars['String']['input']>>;
  country: Country;
  department: WhichDepartmentToWorkInAlternative;
  description?: InputMaybe<Scalars['String']['input']>;
  driversLicenseRequirements: DriversLicense;
  employerId: Scalars['String']['input'];
  experienceRequired?: InputMaybe<HowMuchExperienceAlternative>;
  freeTextRequirements?: InputMaybe<Scalars['String']['input']>;
  howMuchWork?: InputMaybe<HowMuchWorkAlternative>;
  internalComment?: InputMaybe<Scalars['String']['input']>;
  isSpecializationRequired: Scalars['Boolean']['input'];
  jobEndsAt?: InputMaybe<Scalars['Int']['input']>;
  jobStartsAt?: InputMaybe<Scalars['Int']['input']>;
  jobType: JobType;
  journalSystems?: InputMaybe<Array<JournalSystem>>;
  lastApplicationDate?: InputMaybe<Scalars['Date']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  numberOfResources: Scalars['Int']['input'];
  profession: Profession;
  region: WhichRegionAlternative;
  specializations?: InputMaybe<Array<Specialization>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  workHours?: InputMaybe<Array<WorkHours>>;
};

export type CrossOrg = {
  __typename?: 'CrossOrg';
  edges: Array<CrossOrgEdge>;
  nodes: Array<CrossOrgNode>;
};

export type CrossOrgEdge = {
  __typename?: 'CrossOrgEdge';
  id: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CrossOrgNode = {
  __typename?: 'CrossOrgNode';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unitRelation: UnitRelation;
};

export enum Currency {
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  SEK = 'SEK',
  USD = 'USD'
}

export enum CurrentEmploymentStatus {
  EMPLOYED = 'EMPLOYED',
  IN_STAFFING = 'IN_STAFFING',
  UNDER_NOTICE = 'UNDER_NOTICE'
}

export type CustomClaims = {
  role: Role;
};

export type CustomRequirement = {
  __typename?: 'CustomRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type CustomRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type CustomRole = {
  __typename?: 'CustomRole';
  /** This role will be assigned to users with the specified attributes */
  attributeKeys: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  labeledRoles: Array<RbacRole>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type DateComparator = {
  /** In unix time (seconds) */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** In unix time (seconds) */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  neq?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Day {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DayBudget = {
  __typename?: 'DayBudget';
  date: Scalars['String']['output'];
  demand: SchedulingPeriodDayDemand;
  scheduleResourceId: Scalars['String']['output'];
};

export type DayBudgetsPeriodInput = {
  endsAt: Scalars['Date']['input'];
  startsAt: Scalars['Date']['input'];
};

export type Delegation = {
  __typename?: 'Delegation';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  delegate: Identity;
  delegateId: Scalars['String']['output'];
  delegator: Identity;
  delegatorId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
};

export type DeleteBaseScheduleInput = {
  id: Scalars['String']['input'];
};

export type DeleteBroadcastMessageInput = {
  id: Scalars['String']['input'];
};

export type DeletePresentedAvailabilityInput = {
  id: Scalars['String']['input'];
};

export type DeletePresentedDayInput = {
  id: Scalars['String']['input'];
};

export type DeleteReferenceInput = {
  referenceId: Scalars['String']['input'];
};

export type DeleteScheduleDraftInput = {
  scheduleDraftId: Scalars['String']['input'];
};

export type DeleteSchedulingPeriodActivityInput = {
  id: Scalars['String']['input'];
};

export type DeleteSupplierDeviationInput = {
  id: Scalars['String']['input'];
};

export type DeleteTenderInvoiceInput = {
  id: Scalars['String']['input'];
};

export type DeleteTenderedAvailabilityInput = {
  id: Scalars['String']['input'];
};

export type DeleteTenderedDayInput = {
  id: Scalars['String']['input'];
};

export type DepartmentAlternative = {
  __typename?: 'DepartmentAlternative';
  label: Scalars['String']['output'];
  overCategory: WhichDepartmentToWorkInAlternative;
  value: WhichDepartmentToWorkInAlternative;
};

export type DepartmentArrayComparator = {
  all?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  has?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  some?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
};

export type DepartmentComparator = {
  eq?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  in?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  neq?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  nin?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
};

export type DepartmentOptionOptions = {
  __typename?: 'DepartmentOptionOptions';
  labels: Array<Scalars['String']['output']>;
  values: Array<WhichDepartmentToWorkInAlternative>;
};

export type DetailedTenderFillRate = {
  __typename?: 'DetailedTenderFillRate';
  acceptedHours?: Maybe<Scalars['Float']['output']>;
  acceptedPercentage: Scalars['Float']['output'];
  bookedHours?: Maybe<Scalars['Float']['output']>;
  bookedPercentage: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  presentedHours?: Maybe<Scalars['Float']['output']>;
  presentedPercentage: Scalars['Float']['output'];
  totalHours?: Maybe<Scalars['Float']['output']>;
  totalShifts?: Maybe<Scalars['Int']['output']>;
  unbookedHours?: Maybe<Scalars['Float']['output']>;
};

export type DisableEmployeeInput = {
  identityId: Scalars['String']['input'];
};

export type DisplayFileUpload = {
  __typename?: 'DisplayFileUpload';
  candidateId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isUploadedByCandidate: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  referenceUrl?: Maybe<Scalars['String']['output']>;
  uploadType: FileUploadType;
  uploadedAt: Scalars['Int']['output'];
  uploadedBy: FileUploadAuthor;
};

export type DisplayJobPosting = {
  __typename?: 'DisplayJobPosting';
  bemloApplicationUrl: Scalars['String']['output'];
  customDescription?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  departmentValue: WhichDepartmentToWorkInAlternative;
  employer: Scalars['String']['output'];
  extent: Scalars['String']['output'];
  extentValue: HowMuchWorkAlternative;
  id: Scalars['String']['output'];
  isSpecializationRequired: Scalars['Boolean']['output'];
  jobDescription: Scalars['String']['output'];
  jobEndsAt: Scalars['String']['output'];
  jobRole: Scalars['String']['output'];
  jobStartsAt: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  jobType: JobType;
  lastApplicationDate: Scalars['String']['output'];
  municipality: Scalars['String']['output'];
  profession: Scalars['String']['output'];
  professionValue: Profession;
  region: Scalars['String']['output'];
  regionValue: WhichRegionAlternative;
  specializations: Array<Scalars['String']['output']>;
  specializationsValue: Array<Specialization>;
  whichProfession: Profession;
};

export type DisplayOffer = {
  __typename?: 'DisplayOffer';
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  noteToEmployers?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  source: ApplicationSource;
  status: OfferStatus;
};

export type DisplayProfile = {
  __typename?: 'DisplayProfile';
  addShiftScheduleInformation: AddShiftToCandidateScheduleInformation;
  availability: Array<ResourceAvailability>;
  candidateBooking?: Maybe<CandidateBooking>;
  connection?: Maybe<AbstractConnection>;
  contract?: Maybe<CandidateContract>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  fileUploads: Array<DisplayFileUpload>;
  graduatedAt?: Maybe<Scalars['Int']['output']>;
  homeCountry?: Maybe<Country>;
  homeMunicipality?: Maybe<Scalars['String']['output']>;
  homeRegion?: Maybe<Scalars['String']['output']>;
  homeUnit?: Maybe<Unit>;
  id: Scalars['String']['output'];
  identityId?: Maybe<Scalars['String']['output']>;
  information: Array<DisplayProfileInformation>;
  interests: CandidateInterests;
  isConnected: Scalars['Boolean']['output'];
  isInterestedInContact: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['Date']['output']>;
  lead?: Maybe<CandidateLead>;
  matchingShifts: Array<AddShiftToCandidateScheduleInformation>;
  name: Scalars['String']['output'];
  offer?: Maybe<DisplayOffer>;
  personalIdentityNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profession: Profession;
  profileConnectionStatus: ProfileConnectionStatus;
  qualifications: CandidateQualifications;
  referenceCount: Scalars['Int']['output'];
  references?: Maybe<Array<Reference>>;
  shiftApplicationsInLast30daysCount: Scalars['Int']['output'];
  shiftBookings: Array<ShiftBooking>;
  shiftSuggestions: Array<ShiftSuggestion>;
  source: ProfileSource;
  tags: Array<Tag>;
  type: CandidateType;
  updatedAt: Scalars['Int']['output'];
  vacancies: Array<AppliedToVacancyWrapper>;
  vacancyApplications: Array<VacancyApplication>;
};


export type DisplayProfileaddShiftScheduleInformationArgs = {
  scheduleSlotId: Scalars['String']['input'];
};


export type DisplayProfileavailabilityArgs = {
  filter?: InputMaybe<ResourceAvailabilityFilter>;
};


export type DisplayProfilematchingShiftsArgs = {
  filter: MatchingShiftsFilter;
};


export type DisplayProfileshiftBookingsArgs = {
  filter?: InputMaybe<ShiftBookingFilter>;
};


export type DisplayProfileshiftSuggestionsArgs = {
  filter?: InputMaybe<ShiftSuggestionFilter>;
};

export type DisplayProfileCursorSearchResult = {
  __typename?: 'DisplayProfileCursorSearchResult';
  edges: Array<DisplayProfileEdge>;
  pageInfo: PageInfo;
};

export type DisplayProfileEdge = {
  __typename?: 'DisplayProfileEdge';
  cursor: Scalars['String']['output'];
  node: DisplayProfile;
};

export type DisplayProfileInformation = {
  __typename?: 'DisplayProfileInformation';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DisplayProfilesPagedResult = {
  __typename?: 'DisplayProfilesPagedResult';
  hits: Array<DisplayProfile>;
  hitsPerPage: Scalars['Float']['output'];
  nbHits: Scalars['Float']['output'];
  nbPages: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
};

export type DoctorOptions = {
  __typename?: 'DoctorOptions';
  country: Country;
  region?: Maybe<Region>;
  specialization: DoctorSpecialization;
};

export { DoctorSpecialization };

export type DocumentRequirement = {
  __typename?: 'DocumentRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  document: FileUploadType;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  type: CandidateRequirementType;
};

export type DocumentRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  document: FileUploadType;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  type: CandidateRequirementType;
};

export enum DriversLicense {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  NONE = 'NONE'
}

export type DriversLicenseArrayComparator = {
  all?: InputMaybe<Array<DriversLicense>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<DriversLicense>>;
  has?: InputMaybe<DriversLicense>;
  some?: InputMaybe<Array<DriversLicense>>;
};

export type DriversLicenseComparator = {
  eq?: InputMaybe<DriversLicense>;
  in?: InputMaybe<Array<DriversLicense>>;
  neq?: InputMaybe<DriversLicense>;
  nin?: InputMaybe<Array<DriversLicense>>;
};

export type DriversLicenseRequirement = {
  __typename?: 'DriversLicenseRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  driversLicense: DriversLicense;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
};

export type DriversLicenseRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  driversLicense: DriversLicense;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
};

export enum DynamicTenderStatus {
  ASSIGNED = 'ASSIGNED',
  CLOSED = 'CLOSED',
  CLOSED_FOR_PRESENTATIONS = 'CLOSED_FOR_PRESENTATIONS',
  DRAFT = 'DRAFT',
  FILLED = 'FILLED',
  OPEN_FOR_PRESENTATIONS = 'OPEN_FOR_PRESENTATIONS',
  PUBLISHED = 'PUBLISHED',
  READY_TO_PUBLISH = 'READY_TO_PUBLISH',
  REQUESTED_TO_PUBLISH = 'REQUESTED_TO_PUBLISH',
  URGENT = 'URGENT'
}

export type EditFileUploadInput = {
  fileUploadFields: FileUploadInputFields;
  fileUploadId: Scalars['String']['input'];
};

export type EmployerApplication = {
  __typename?: 'EmployerApplication';
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
};

export enum EmployerFeatures {
  BEMLO_CANDIDATE_DATABASE = 'BEMLO_CANDIDATE_DATABASE',
  CALL_REQUESTS = 'CALL_REQUESTS',
  CANDIDATES_CREATE = 'CANDIDATES_CREATE',
  CANDIDATES_STATIC = 'CANDIDATES_STATIC',
  CANDIDATES_SYNCED = 'CANDIDATES_SYNCED',
  CONTACT_REQUESTS = 'CONTACT_REQUESTS',
  DIRECT_ACCESS = 'DIRECT_ACCESS',
  EMPLOYEES = 'EMPLOYEES',
  EXTERNAL_CANDIDATES = 'EXTERNAL_CANDIDATES',
  GENERIC_JOB_POSTING_APPLICATIONS = 'GENERIC_JOB_POSTING_APPLICATIONS',
  JOB_POSTINGS = 'JOB_POSTINGS',
  LEADS = 'LEADS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SCHEDULES = 'SCHEDULES',
  STATISTICS = 'STATISTICS',
  TENDERS_CREATE = 'TENDERS_CREATE',
  TENDERS_PRESENT = 'TENDERS_PRESENT',
  TENDERS_TIME_REPORTS = 'TENDERS_TIME_REPORTS',
  VACANCIES_TENDER = 'VACANCIES_TENDER'
}

export type Employment = {
  __typename?: 'Employment';
  homeUnit: Unit;
  homeUnitId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationKeys: Array<Scalars['String']['output']>;
  type: EmploymentType;
};

export type EmploymentFilter = {
  AND?: InputMaybe<Array<EmploymentFilter>>;
  NOT?: InputMaybe<Array<EmploymentFilter>>;
  OR?: InputMaybe<Array<EmploymentFilter>>;
  homeUnit?: InputMaybe<UnitFilter>;
  homeUnitId?: InputMaybe<IdComparator>;
  id?: InputMaybe<IdComparator>;
  organizationId?: InputMaybe<IdComparator>;
  organizationKeys?: InputMaybe<IdArrayComparator>;
};

export enum EmploymentType {
  CONTRACT = 'CONTRACT',
  HOURLY = 'HOURLY',
  PERMANENT = 'PERMANENT',
  TEMPORARY = 'TEMPORARY'
}

export type EmploymentTypeComparator = {
  eq?: InputMaybe<EmploymentType>;
  in?: InputMaybe<Array<EmploymentType>>;
  neq?: InputMaybe<EmploymentType>;
  nin?: InputMaybe<Array<EmploymentType>>;
};

export type EnableTenderTimesheetsInput = {
  tenderId: Scalars['String']['input'];
};

export type Event = {
  __typename?: 'Event';
  action: EventAction;
  bookmark?: Maybe<EventBookmark>;
  candidateBooking?: Maybe<CandidateBooking>;
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  notification?: Maybe<EventNotification>;
  objectId: Scalars['String']['output'];
  presentation?: Maybe<Presentation>;
  scheduleResource?: Maybe<ScheduleResource>;
  scope: EventScope;
  shift?: Maybe<Shift>;
  shiftApplication?: Maybe<ShiftApplication>;
  shiftBooking?: Maybe<ShiftBooking>;
  shiftSuggestion?: Maybe<ShiftSuggestion>;
  tender?: Maybe<Tender>;
  tenderWaiver?: Maybe<TenderWaiver>;
  user?: Maybe<Identity>;
};

export enum EventAction {
  ACCEPTANCE_WITHDRAWN = 'ACCEPTANCE_WITHDRAWN',
  ACCEPTED = 'ACCEPTED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ADJUSTED = 'ADJUSTED',
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
  ASSIGNED = 'ASSIGNED',
  ATTESTED = 'ATTESTED',
  BILLING_INFORMATION_CHANGED = 'BILLING_INFORMATION_CHANGED',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  CONFIRMED = 'CONFIRMED',
  CONTACT_PERSON_CHANGED = 'CONTACT_PERSON_CHANGED',
  CREATED = 'CREATED',
  DEADLINE_EXCEEDED = 'DEADLINE_EXCEEDED',
  EXTENDED = 'EXTENDED',
  IGNORED = 'IGNORED',
  MANAGERS_CHANGED = 'MANAGERS_CHANGED',
  MARKED_AS_ABSENT = 'MARKED_AS_ABSENT',
  MARKED_AS_ASSIGNED = 'MARKED_AS_ASSIGNED',
  MARKED_AS_FILLED = 'MARKED_AS_FILLED',
  MARKED_AS_READY = 'MARKED_AS_READY',
  MARKED_AS_READY_TO_CREATE = 'MARKED_AS_READY_TO_CREATE',
  MARKED_AS_READY_TO_PUBLISH = 'MARKED_AS_READY_TO_PUBLISH',
  MARKED_AS_READY_TO_REVIEW = 'MARKED_AS_READY_TO_REVIEW',
  MARKED_AS_URGENT = 'MARKED_AS_URGENT',
  PREPARED = 'PREPARED',
  PUBLISHED = 'PUBLISHED',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  REJECTION_WITHDRAWN = 'REJECTION_WITHDRAWN',
  REOPENED = 'REOPENED',
  REPLACEMENT_SUGGESTED = 'REPLACEMENT_SUGGESTED',
  REQUIREMENTS_CHANGED = 'REQUIREMENTS_CHANGED',
  RETURNED = 'RETURNED',
  REVIEWED = 'REVIEWED',
  REVISED = 'REVISED',
  REVOKED = 'REVOKED',
  SCHEDULE_CHANGED = 'SCHEDULE_CHANGED',
  SCORED = 'SCORED',
  SENT = 'SENT',
  SHIFT_ACCEPTED = 'SHIFT_ACCEPTED',
  SHIFT_ARCHIVED = 'SHIFT_ARCHIVED',
  SHIFT_REJECTED = 'SHIFT_REJECTED',
  SHIFT_SUGGESTED = 'SHIFT_SUGGESTED',
  SHIFT_UPDATED = 'SHIFT_UPDATED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  SUGGESTED = 'SUGGESTED',
  TENDER_CREATED_FROM_WAIVER = 'TENDER_CREATED_FROM_WAIVER',
  TENDER_DELETED = 'TENDER_DELETED',
  TIMED_OUT = 'TIMED_OUT',
  UNIT_MANAGERS_CHANGED = 'UNIT_MANAGERS_CHANGED',
  UPDATED = 'UPDATED',
  VIEWED = 'VIEWED',
  WITHDRAWN = 'WITHDRAWN'
}

export type EventActionComparator = {
  eq?: InputMaybe<EventAction>;
  in?: InputMaybe<Array<EventAction>>;
  neq?: InputMaybe<EventAction>;
  nin?: InputMaybe<Array<EventAction>>;
};

export type EventBookmark = {
  __typename?: 'EventBookmark';
  createdAt: Scalars['Date']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
};

export type EventBookmarkFilter = {
  AND?: InputMaybe<Array<EventBookmarkFilter>>;
  NOT?: InputMaybe<Array<EventBookmarkFilter>>;
  OR?: InputMaybe<Array<EventBookmarkFilter>>;
  event?: InputMaybe<EventFilter>;
  eventId?: InputMaybe<IdComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<IdComparator>;
};

export type EventBookmarkListRelationComparator = {
  every?: InputMaybe<EventBookmarkFilter>;
  none?: InputMaybe<EventBookmarkFilter>;
  some?: InputMaybe<EventBookmarkFilter>;
};

export type EventFilter = {
  AND?: InputMaybe<Array<EventFilter>>;
  NOT?: InputMaybe<Array<EventFilter>>;
  OR?: InputMaybe<Array<EventFilter>>;
  action?: InputMaybe<EventActionComparator>;
  bookmarks?: InputMaybe<EventBookmarkListRelationComparator>;
  candidateBooking?: InputMaybe<CandidateBookingFilter>;
  createdAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<IdComparator>;
  notifications?: InputMaybe<EventNotificationListRelationComparator>;
  presentation?: InputMaybe<PresentationFilter>;
  scope?: InputMaybe<EventScopeComparator>;
  shiftBooking?: InputMaybe<ShiftBookingFilter>;
  shiftSuggestion?: InputMaybe<ShiftSuggestionFilter>;
  tender?: InputMaybe<TenderFilter>;
  tenderWaiver?: InputMaybe<TenderWaiverFilter>;
  userId?: InputMaybe<IdComparator>;
};

export type EventNotification = {
  __typename?: 'EventNotification';
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  viewedAt?: Maybe<Scalars['Date']['output']>;
};

export type EventNotificationFilter = {
  AND?: InputMaybe<Array<EventNotificationFilter>>;
  NOT?: InputMaybe<Array<EventNotificationFilter>>;
  OR?: InputMaybe<Array<EventNotificationFilter>>;
  event?: InputMaybe<EventFilter>;
  eventId?: InputMaybe<IdComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<IdComparator>;
  viewedAt?: InputMaybe<NullableDateComparator>;
};

export type EventNotificationListRelationComparator = {
  every?: InputMaybe<EventNotificationFilter>;
  none?: InputMaybe<EventNotificationFilter>;
  some?: InputMaybe<EventNotificationFilter>;
};

export enum EventObjectType {
  BOOKING_SHIFT = 'BOOKING_SHIFT',
  CANDIDATE_BOOKING = 'CANDIDATE_BOOKING',
  CONVERSATION = 'CONVERSATION',
  LEAD_REGISTRATION = 'LEAD_REGISTRATION',
  LEAD_REGISTRATION_OFFER = 'LEAD_REGISTRATION_OFFER',
  PRESENTATION = 'PRESENTATION',
  PRESENTATION_REVIEW = 'PRESENTATION_REVIEW',
  PRESENTATION_SHIFT = 'PRESENTATION_SHIFT',
  REQUIREMENT = 'REQUIREMENT',
  REQUIREMENT_FULFILLMENT = 'REQUIREMENT_FULFILLMENT',
  SCHEDULE_RESOURCE = 'SCHEDULE_RESOURCE',
  SHIFT = 'SHIFT',
  SHIFT_APPLICATION = 'SHIFT_APPLICATION',
  SHIFT_BOOKING = 'SHIFT_BOOKING',
  SHIFT_SUGGESTION = 'SHIFT_SUGGESTION',
  TENDER = 'TENDER',
  TENDER_SHIFT = 'TENDER_SHIFT',
  TENDER_WAIVER = 'TENDER_WAIVER',
  TIMESHEET = 'TIMESHEET',
  TIME_REPORT_SHIFT = 'TIME_REPORT_SHIFT'
}

export enum EventScope {
  BOOKING_SHIFT = 'BOOKING_SHIFT',
  CANDIDATE_BOOKING = 'CANDIDATE_BOOKING',
  CONVERSATION = 'CONVERSATION',
  DRAFT_TENDER = 'DRAFT_TENDER',
  LEAD_REGISTRATION = 'LEAD_REGISTRATION',
  LEAD_REGISTRATION_OFFER = 'LEAD_REGISTRATION_OFFER',
  POOL_SCHEDULE_RESOURCE = 'POOL_SCHEDULE_RESOURCE',
  POOL_SHIFT = 'POOL_SHIFT',
  POOL_SHIFT_APPLICATION = 'POOL_SHIFT_APPLICATION',
  POOL_SHIFT_BOOKING = 'POOL_SHIFT_BOOKING',
  POOL_TIMESHEET = 'POOL_TIMESHEET',
  PRESENTATION = 'PRESENTATION',
  PRESENTATION_REVIEW = 'PRESENTATION_REVIEW',
  REPLACEMENT_PRESENTATION = 'REPLACEMENT_PRESENTATION',
  SHIFT_SUGGESTION = 'SHIFT_SUGGESTION',
  TENDER = 'TENDER',
  TENDER_WAIVER = 'TENDER_WAIVER'
}

export type EventScopeComparator = {
  eq?: InputMaybe<EventScope>;
  in?: InputMaybe<Array<EventScope>>;
  neq?: InputMaybe<EventScope>;
  nin?: InputMaybe<Array<EventScope>>;
};

export type ExperienceRequirement = {
  __typename?: 'ExperienceRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  department?: Maybe<WhichDepartmentToWorkInAlternative>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  numberOfYears: Scalars['Float']['output'];
};

export type ExperienceRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  numberOfYears: Scalars['Float']['input'];
};

export type ExtendCandidateBookingInput = {
  id: Scalars['String']['input'];
  newEndDate?: InputMaybe<Scalars['Date']['input']>;
  newStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExternalConversation = {
  __typename?: 'ExternalConversation';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  partner?: Maybe<Organization>;
  partnerOrganizationId: Scalars['String']['output'];
};

export type FetchSalaryStatisticsInput = {
  country: Country;
  profession: Profession;
  region: Region;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['Float']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  referenceUrl?: Maybe<Scalars['String']['output']>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  candidateId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  employerId?: Maybe<Scalars['String']['output']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  referenceUrl: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Int']['output']>;
  uploadType: FileUploadType;
  uploadedAt: Scalars['Int']['output'];
  uploadedByBemlo?: Maybe<Scalars['Boolean']['output']>;
};

export enum FileUploadAuthor {
  BEMLO = 'BEMLO',
  CANDIDATE = 'CANDIDATE',
  EMPLOYER = 'EMPLOYER'
}

export type FileUploadInput = {
  candidateId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy: Scalars['String']['input'];
  employerId?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Int']['input']>;
  uploadType: FileUploadType;
  uploadedAt: Scalars['Int']['input'];
  uploadedByBemlo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadInputFields = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: InputMaybe<Scalars['Int']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  referenceUrl?: InputMaybe<Scalars['String']['input']>;
  uploadType?: InputMaybe<FileUploadType>;
};

export enum FileUploadType {
  CV = 'CV',
  HOSP = 'HOSP',
  IVO = 'IVO',
  LICENSE = 'LICENSE',
  OTHER = 'OTHER',
  REFERENCE = 'REFERENCE',
  SPECIALIZATION = 'SPECIALIZATION'
}

export type FilterApplicationOptions = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  isFromBemlo?: InputMaybe<Scalars['Boolean']['input']>;
  markets?: InputMaybe<Array<Market>>;
  offer?: InputMaybe<OfferOptions>;
  professions?: InputMaybe<Array<Profession>>;
};

export type FindContactRequestsFilter = {
  /** Only return contact requests with fewer reminders than specified. */
  maxRemindersCount?: InputMaybe<Scalars['Int']['input']>;
  /** Only return contact requests without have a more recent reminder. */
  minHoursSinceLastReminder?: InputMaybe<Scalars['Int']['input']>;
  /** Only return contact requests for the specified identities. */
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return contact requests with the specified status. This filter is ignored when sending reminders. */
  status?: InputMaybe<ContactRequestStatus>;
};

export type FindReceiptsByEmployerInput = {
  endTimestamp: Scalars['Int']['input'];
  startTimestamp: Scalars['Int']['input'];
};

export type FindSalaryGroupInput = {
  country: Country;
  profession: Profession;
  region: Region;
  specialization: Specialization;
};

export type FindUnhandledReceiptsByEmployerInput = {
  employerId: Scalars['String']['input'];
  endTimestamp: Scalars['Int']['input'];
};

export type FindUnhandledReceiptsInput = {
  employerId?: InputMaybe<Scalars['String']['input']>;
  endTimestamp: Scalars['Int']['input'];
  startTimestamp: Scalars['Int']['input'];
};

export type FlagMessageInput = {
  isFlagged: Scalars['Boolean']['input'];
  messageId: Scalars['String']['input'];
};

export type FlexShiftInput = {
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  startDateTime: Scalars['Date']['input'];
};

export type FlowStatistics = {
  __typename?: 'FlowStatistics';
  approvedHours: Array<GraphDataPoint>;
  approvedHoursKpi: Scalars['Int']['output'];
  bookedHoursByStaffingAgency: Array<GraphDataPoint>;
  bookedHoursKpi: Scalars['Int']['output'];
  bookingData: Array<BookingStatisticsDataPoint>;
  cost: Array<GraphDataPoint>;
  endDate: Scalars['Date']['output'];
  fillRate: Array<GraphDataPoint>;
  numberOfActiveResourcesKpi: Scalars['Int']['output'];
  numberOfActiveSuppliersKpi: Scalars['Int']['output'];
  numberOfActiveUnitsKpi: Scalars['Int']['output'];
  numberOfTenders: Array<GraphDataPoint>;
  requestedAndBookedHours: Array<GraphDataPoint>;
  requestedHoursByUnit: Array<GraphDataPoint>;
  requestedHoursKpi: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  supplierStatistics: Array<FlowSupplierStatistics>;
  tenderData: Array<TenderStatisticsDataPoint>;
  tenderWaiverData: Array<TenderWaiverStatisticsDataPoint>;
  tenderWaiverFillRate: Array<GraphDataPoint>;
  timeUnit: StatisticsTimeUnit;
  totalCostKpi: Scalars['Int']['output'];
  totalNumberOfTendersKpi: Scalars['Int']['output'];
};

export type FlowSupplierStatistics = {
  __typename?: 'FlowSupplierStatistics';
  bookedHours: Scalars['Int']['output'];
  numberOfBookedConsultants: Scalars['Int']['output'];
  numberOfTendersWithBookings: Scalars['Int']['output'];
  supplierId: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  OTHER = 'OTHER'
}

export type GenerateScheduleDraftInput = {
  baseScheduleDraftId?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  schedulingPeriodId: Scalars['String']['input'];
};

export type GetFlowStatisticsInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  tenderFilter: TenderFilter;
  timeUnit: StatisticsTimeUnit;
};

export type GetStatisticsInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  timeUnit: StatisticsTimeUnit;
};

export type GraphDataPoint = {
  __typename?: 'GraphDataPoint';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  values: Array<GraphValue>;
};

export type GraphValue = {
  __typename?: 'GraphValue';
  seriesKey: StatisticsSeriesKey;
  value: Scalars['Float']['output'];
};

export type GraphicProfile = {
  __typename?: 'GraphicProfile';
  /** Used for avatars etc. sometimes in circles. Should be square. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type GraphicProfileInput = {
  /** Used for avatars etc. sometimes in circles. Should be square. */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type HandleOfferInput = {
  id: Scalars['String']['input'];
  source: ApplicationSource;
};

export enum HowMuchExperienceAlternative {
  FIVE_TO_TEN = 'FIVE_TO_TEN',
  LESS_THAN_ONE = 'LESS_THAN_ONE',
  MORE_THAN_TEN = 'MORE_THAN_TEN',
  NEW_GRADUATE = 'NEW_GRADUATE',
  ONE_TO_TWO = 'ONE_TO_TWO',
  STUDENT = 'STUDENT',
  THREE_TO_FIVE = 'THREE_TO_FIVE',
  TWO = 'TWO',
  TWO_TO_THREE = 'TWO_TO_THREE'
}

export enum HowMuchWorkAlternative {
  FULLTIME = 'FULLTIME',
  IRREGULAR_PART_TIME = 'IRREGULAR_PART_TIME',
  REGULAR_PART_TIME = 'REGULAR_PART_TIME'
}

export type HowMuchWorkComparator = {
  eq?: InputMaybe<HowMuchWorkAlternative>;
  in?: InputMaybe<Array<HowMuchWorkAlternative>>;
  neq?: InputMaybe<HowMuchWorkAlternative>;
  nin?: InputMaybe<Array<HowMuchWorkAlternative>>;
};

export type HprPerson = {
  __typename?: 'HprPerson';
  birthDate: Scalars['String']['output'];
  isAuthorized: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  profession?: Maybe<Profession>;
  professionRaw?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type IdArrayComparator = {
  all?: InputMaybe<Array<Scalars['String']['input']>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  some?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IdComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Identity = {
  __typename?: 'Identity';
  assignment?: Maybe<Assignment>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  candidate?: Maybe<Candidate>;
  combinedRoles?: Maybe<Array<RbacRole>>;
  connections: Array<AbstractConnection>;
  contactPreferences?: Maybe<ContactPreferences>;
  createdAt: Scalars['Date']['output'];
  customRoles?: Maybe<Array<CustomRole>>;
  delegateOf: Array<Delegation>;
  delegations: Array<Delegation>;
  /** IDs of the users that have active delegations to this user */
  delegatorIds: Array<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  disabledNotifications?: Maybe<Array<Scalars['String']['output']>>;
  email: Scalars['String']['output'];
  employment?: Maybe<Employment>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobApplications: Array<JobApplication>;
  lastSeen?: Maybe<Scalars['Date']['output']>;
  locale: Scalars['String']['output'];
  notificationInterests?: Maybe<NotificationInterests>;
  org?: Maybe<OrgMembership>;
  organization?: Maybe<Organization>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<RbacRole>>;
  rules: Scalars['String']['output'];
  type: ActorType;
  updatedAt: Scalars['Date']['output'];
  userNotificationPreferences: Array<NotificationPreference>;
  vacancyApplications: Array<VacancyApplication>;
};

export type IdentityFilter = {
  AND?: InputMaybe<Array<IdentityFilter>>;
  NOT?: InputMaybe<Array<IdentityFilter>>;
  OR?: InputMaybe<Array<IdentityFilter>>;
  employment?: InputMaybe<EmploymentFilter>;
  id?: InputMaybe<IdComparator>;
};

export type Interest = {
  __typename?: 'Interest';
  assistantNurse: Scalars['Boolean']['output'];
  doctor: Scalars['Boolean']['output'];
  northernSweden: Scalars['Boolean']['output'];
  norway: Scalars['Boolean']['output'];
  nurse: Scalars['Boolean']['output'];
  socialEducator?: Maybe<Scalars['Boolean']['output']>;
  stockholm: Scalars['Boolean']['output'];
  subPrime: Scalars['Boolean']['output'];
  sweden: Scalars['Boolean']['output'];
};

export type InterestInput = {
  assistantNurse: Scalars['Boolean']['input'];
  doctor: Scalars['Boolean']['input'];
  northernSweden: Scalars['Boolean']['input'];
  norway: Scalars['Boolean']['input'];
  nurse: Scalars['Boolean']['input'];
  socialEducator?: InputMaybe<Scalars['Boolean']['input']>;
  stockholm: Scalars['Boolean']['input'];
  subPrime: Scalars['Boolean']['input'];
  sweden: Scalars['Boolean']['input'];
};

export type InternalConversation = {
  __typename?: 'InternalConversation';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type InviteEmployeeInput = {
  candidateInput: UpdateCandidateInput;
  email: Scalars['String']['input'];
  employmentType: EmploymentType;
  fullName: Scalars['String']['input'];
  homeUnitId: Scalars['String']['input'];
  organizationKeys: Array<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profession: Profession;
};

export type InviteEmployeesInput = {
  invites: Array<InviteEmployeeInput>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteOrgMemberInput = {
  customRoleIds?: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  organizationKeys: Array<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InvitePriceGroupFrameworkParticipantInput = {
  organizationId: Scalars['String']['input'];
  priceGroupId: Scalars['String']['input'];
};

export type InviteReferenceInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InviteSuppliersToTenderInput = {
  priceGroups?: InputMaybe<Array<PublishToTenderPriceGroupInput>>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenderId: Scalars['String']['input'];
};

export type InviteTestEmployeeInput = {
  candidateInput?: InputMaybe<UpdateCandidateInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  homeUnitId: Scalars['String']['input'];
  organizationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profession: Profession;
};

export type InviteTestEmployeesInput = {
  invites: Array<InviteTestEmployeeInput>;
};

export type JobApplication = {
  __typename?: 'JobApplication';
  assignedTo?: Maybe<Scalars['String']['output']>;
  bookedDateAndTimeString?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use direct applications directly instead. */
  employersToMatchWith: Array<Scalars['String']['output']>;
  firstCalledAt?: Maybe<Scalars['Float']['output']>;
  firstSentAt?: Maybe<Scalars['Float']['output']>;
  hasAnswered: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  isContacted: Scalars['Boolean']['output'];
  isReadyToSend: Scalars['Boolean']['output'];
  /** Shown in manager to all recipients */
  noteToEmployers?: Maybe<Scalars['String']['output']>;
  numberOfTimesContacted: Scalars['Int']['output'];
  offers: Array<Offer>;
  profile: Profile;
  profileId: Scalars['String']['output'];
  remainingSlots: Scalars['Int']['output'];
  sentBy?: Maybe<Scalars['String']['output']>;
  sentToEmployers?: Maybe<Array<Scalars['String']['output']>>;
  snoozedUntilDate?: Maybe<Scalars['Int']['output']>;
  stage: JobApplicationStage;
  status: JobApplicationStatus;
  superheroName: Scalars['String']['output'];
  totalValue: Scalars['Int']['output'];
  /** @deprecated No vacancy application anymore. Temporal support of retool */
  vacancies: Array<Vacancy>;
  /** @deprecated No vacancy applications anymore. Temporal support of retool */
  vacanciesToMatchWith: Array<Scalars['String']['output']>;
};

export enum JobApplicationStage {
  INBOUND = 'INBOUND',
  MANAGED = 'MANAGED',
  OUTBOUND = 'OUTBOUND',
  PROPOSED = 'PROPOSED'
}

export enum JobApplicationStatus {
  AWAITING_REVIEW = 'AWAITING_REVIEW',
  COMPLETED = 'COMPLETED',
  IGNORED = 'IGNORED',
  NEW = 'NEW',
  SENT = 'SENT',
  TIMED_OUT = 'TIMED_OUT'
}

export type JobApplicationsFilter = {
  createdAtEnd?: InputMaybe<Scalars['Int']['input']>;
  createdAtStart?: InputMaybe<Scalars['Int']['input']>;
  filterOptions?: InputMaybe<FilterApplicationOptions>;
  firstSentAtEnd?: InputMaybe<Scalars['Int']['input']>;
  firstSentAtStart?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<JobApplicationStage>;
  status?: InputMaybe<JobApplicationStatus>;
};

export type JobPosting = {
  __typename?: 'JobPosting';
  archivedAt?: Maybe<Scalars['Int']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  descriptionHtml: Scalars['String']['output'];
  descriptionTemplate: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integration: JobPostingIntegration;
  lastApplicationDate?: Maybe<Scalars['Date']['output']>;
  locale: Locale;
  publishedAt?: Maybe<Scalars['Int']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  publishingError?: Maybe<Scalars['String']['output']>;
  status: JobPostingStatus;
  templateId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  vacancy: Vacancy;
  vacancyId: Scalars['String']['output'];
};

export enum JobPostingIntegration {
  BEMLO = 'BEMLO',
  PLATSBANKEN = 'PLATSBANKEN'
}

export type JobPostingIntegrationArrayComparator = {
  all?: InputMaybe<Array<JobPostingIntegration>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<JobPostingIntegration>>;
  has?: InputMaybe<JobPostingIntegration>;
  some?: InputMaybe<Array<JobPostingIntegration>>;
};

export type JobPostingOptions = {
  __typename?: 'JobPostingOptions';
  departmentOptions: DepartmentOptionOptions;
  municipalityOptions: MunicipalityOptionsOptions;
  regionOptions: RegionOptionOptions;
  specializations: SpecializationOptionOptions;
};

export enum JobPostingStatus {
  APPLICATION_CLOSED = 'APPLICATION_CLOSED',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PREPARED = 'PREPARED',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
  PUBLISHING_FAILED = 'PUBLISHING_FAILED'
}

export type JobPostingTemplate = {
  __typename?: 'JobPostingTemplate';
  descriptionTemplate: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integration: JobPostingIntegration;
  locale: Locale;
  titleTemplate: Scalars['String']['output'];
};

export type JobPostingsByIdInput = {
  ids: Array<Scalars['String']['input']>;
};

export enum JobType {
  IRREGULAR_PARTTIME = 'IRREGULAR_PARTTIME',
  JOUR = 'JOUR',
  PERMANENT = 'PERMANENT',
  STAFFING = 'STAFFING',
  TEMPORARY = 'TEMPORARY'
}

export type JobTypeArrayComparator = {
  all?: InputMaybe<Array<JobType>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<JobType>>;
  has?: InputMaybe<JobType>;
  some?: InputMaybe<Array<JobType>>;
};

export type JobTypeComparator = {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
};

export enum JournalSystem {
  ASYNJAVISPH = 'ASYNJAVISPH',
  BMS = 'BMS',
  COMBINE = 'COMBINE',
  COSMIC = 'COSMIC',
  IMX = 'IMX',
  MELIOR = 'MELIOR',
  MILLENNIUM = 'MILLENNIUM',
  NCSCROSS = 'NCSCROSS',
  OBSTERIX = 'OBSTERIX',
  PMO = 'PMO',
  PRATOR = 'PRATOR',
  PROCAPITA = 'PROCAPITA',
  TAKECARE = 'TAKECARE',
  VAS = 'VAS'
}

export type JournalSystemArrayComparator = {
  all?: InputMaybe<Array<JournalSystem>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<JournalSystem>>;
  has?: InputMaybe<JournalSystem>;
  some?: InputMaybe<Array<JournalSystem>>;
};

export type JournalSystemRequirement = {
  __typename?: 'JournalSystemRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  journalSystem: JournalSystem;
};

export type JournalSystemRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  journalSystem: JournalSystem;
};

export enum LicenseStatus {
  HAS_APPLIED = 'HAS_APPLIED',
  HAS_LICENSE = 'HAS_LICENSE',
  NO_LICENSE = 'NO_LICENSE'
}

export type LicenseStatusComparator = {
  eq?: InputMaybe<LicenseStatus>;
  in?: InputMaybe<Array<LicenseStatus>>;
  neq?: InputMaybe<LicenseStatus>;
  nin?: InputMaybe<Array<LicenseStatus>>;
};

export enum Locale {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NB = 'NB',
  SV = 'SV'
}

export type MarkReadyToSendInput = {
  isReadyToSend: Scalars['Boolean']['input'];
  jobApplicationId: Scalars['String']['input'];
};

export { Market };

export type MatchingShiftsFilter = {
  endDateTime: Scalars['Date']['input'];
  startDateTime: Scalars['Date']['input'];
};

export enum Medium {
  HTML = 'HTML',
  TEXT = 'TEXT',
  XML = 'XML'
}

export type Message = {
  __typename?: 'Message';
  conversationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFlagged: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  seenBy: Array<Scalars['String']['output']>;
  sender: ConversationMember;
  sentAt: Scalars['Date']['output'];
  sentBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum Municipality {
  AARBORTE_HATTFJELLDAL = 'AARBORTE_HATTFJELLDAL',
  AFJORD = 'AFJORD',
  AL = 'AL',
  ALE = 'ALE',
  ALESUND = 'ALESUND',
  ALINGSAS = 'ALINGSAS',
  ALMHULT = 'ALMHULT',
  ALSTAHAUG = 'ALSTAHAUG',
  ALTA = 'ALTA',
  ALVDAL = 'ALVDAL',
  ALVDALEN = 'ALVDALEN',
  ALVER = 'ALVER',
  ALVESTA = 'ALVESTA',
  ALVKARLEBY = 'ALVKARLEBY',
  ALVSBYN = 'ALVSBYN',
  AMAL = 'AMAL',
  AMLI = 'AMLI',
  AMOT = 'AMOT',
  ANDOY = 'ANDOY',
  ANEBY = 'ANEBY',
  ANGE = 'ANGE',
  ANGELHOLM = 'ANGELHOLM',
  ARBOGA = 'ARBOGA',
  ARDAL = 'ARDAL',
  ARE = 'ARE',
  AREMARK = 'AREMARK',
  ARENDAL = 'ARENDAL',
  ARJANG = 'ARJANG',
  ARJEPLOG = 'ARJEPLOG',
  ARVIDSJAUR = 'ARVIDSJAUR',
  ARVIKA = 'ARVIKA',
  AS = 'AS',
  ASELE = 'ASELE',
  ASERAL = 'ASERAL',
  ASKER = 'ASKER',
  ASKERSUND = 'ASKERSUND',
  ASKOY = 'ASKOY',
  ASKVOLL = 'ASKVOLL',
  ASNES = 'ASNES',
  ASTORP = 'ASTORP',
  ATVIDABERG = 'ATVIDABERG',
  AUKRA = 'AUKRA',
  AURE = 'AURE',
  AURLAND = 'AURLAND',
  AURSKOG_HOLAND = 'AURSKOG_HOLAND',
  AUSTEVOLL = 'AUSTEVOLL',
  AUSTRHEIM = 'AUSTRHEIM',
  AVEROY = 'AVEROY',
  AVESTA = 'AVESTA',
  BAERUM = 'BAERUM',
  BALSFJORD = 'BALSFJORD',
  BAMBLE = 'BAMBLE',
  BARDU = 'BARDU',
  BASTAD = 'BASTAD',
  BATSFJORD = 'BATSFJORD',
  BEIARN = 'BEIARN',
  BENGTSFORS = 'BENGTSFORS',
  BERG = 'BERG',
  BERGEN = 'BERGEN',
  BERLEVAG = 'BERLEVAG',
  BINDAL = 'BINDAL',
  BIRKENES = 'BIRKENES',
  BJERKREIM = 'BJERKREIM',
  BJORNAFJORDEN = 'BJORNAFJORDEN',
  BJURHOLM = 'BJURHOLM',
  BJUV = 'BJUV',
  BO = 'BO',
  BODEN = 'BODEN',
  BODO = 'BODO',
  BOKN = 'BOKN',
  BOLLEBYGD = 'BOLLEBYGD',
  BOLLNAS = 'BOLLNAS',
  BOMLO = 'BOMLO',
  BORAS = 'BORAS',
  BORGHOLM = 'BORGHOLM',
  BORLANGE = 'BORLANGE',
  BOTKYRKA = 'BOTKYRKA',
  BOXHOLM = 'BOXHOLM',
  BRACKE = 'BRACKE',
  BREMANGER = 'BREMANGER',
  BRISTOL = 'BRISTOL',
  BROMOLLA = 'BROMOLLA',
  BRONNOY = 'BRONNOY',
  BURLOV = 'BURLOV',
  BYGLAND = 'BYGLAND',
  BYKLE = 'BYKLE',
  DALS_ED = 'DALS_ED',
  DANDERYD = 'DANDERYD',
  DEGERFORS = 'DEGERFORS',
  DONNA = 'DONNA',
  DOROTEA = 'DOROTEA',
  DOVRE = 'DOVRE',
  DRAMMEN = 'DRAMMEN',
  DRANGEDAL = 'DRANGEDAL',
  DYROY = 'DYROY',
  EDA = 'EDA',
  EIDFJORD = 'EIDFJORD',
  EIDSKOG = 'EIDSKOG',
  EIDSVOLL = 'EIDSVOLL',
  EIGERSUND = 'EIGERSUND',
  EKERO = 'EKERO',
  EKSJO = 'EKSJO',
  ELVERUM = 'ELVERUM',
  EMMABODA = 'EMMABODA',
  ENEBAKK = 'ENEBAKK',
  ENGERDAL = 'ENGERDAL',
  ENKOPING = 'ENKOPING',
  ESKILSTUNA = 'ESKILSTUNA',
  ESLOV = 'ESLOV',
  ESSUNGA = 'ESSUNGA',
  ETNE = 'ETNE',
  ETNEDAL = 'ETNEDAL',
  EVENES_EVENASSI = 'EVENES_EVENASSI',
  EVJE_OG_HORNNES = 'EVJE_OG_HORNNES',
  FAERDER = 'FAERDER',
  FAGERSTA = 'FAGERSTA',
  FALKENBERG = 'FALKENBERG',
  FALKOPING = 'FALKOPING',
  FALUN = 'FALUN',
  FARGELANDA = 'FARGELANDA',
  FARSUND = 'FARSUND',
  FAUSKE_FUOSSKO = 'FAUSKE_FUOSSKO',
  FEDJE = 'FEDJE',
  FILIPSTAD = 'FILIPSTAD',
  FINSPANG = 'FINSPANG',
  FITJAR = 'FITJAR',
  FJALER = 'FJALER',
  FJORD = 'FJORD',
  FLA = 'FLA',
  FLAKSTAD = 'FLAKSTAD',
  FLATANGER = 'FLATANGER',
  FLEKKEFJORD = 'FLEKKEFJORD',
  FLEN = 'FLEN',
  FLESBERG = 'FLESBERG',
  FOLLDAL = 'FOLLDAL',
  FORSHAGA = 'FORSHAGA',
  FREDRIKSTAD = 'FREDRIKSTAD',
  FROGN = 'FROGN',
  FROLAND = 'FROLAND',
  FROSTA = 'FROSTA',
  FROYA = 'FROYA',
  FYRESDAL = 'FYRESDAL',
  GAGNEF = 'GAGNEF',
  GALLIVARE = 'GALLIVARE',
  GAMVIK = 'GAMVIK',
  GAUSDAL = 'GAUSDAL',
  GAVLE = 'GAVLE',
  GILDESKAL = 'GILDESKAL',
  GISKE = 'GISKE',
  GISLAVED = 'GISLAVED',
  GJEMNES = 'GJEMNES',
  GJERDRUM = 'GJERDRUM',
  GJERSTAD = 'GJERSTAD',
  GJESDAL = 'GJESDAL',
  GJOVIK = 'GJOVIK',
  GLOPPEN = 'GLOPPEN',
  GNESTA = 'GNESTA',
  GNOSJO = 'GNOSJO',
  GOL = 'GOL',
  GOTEBORG = 'GOTEBORG',
  GOTENE = 'GOTENE',
  GOTLAND = 'GOTLAND',
  GRAN = 'GRAN',
  GRANE = 'GRANE',
  GRASTORP = 'GRASTORP',
  GRATANGEN = 'GRATANGEN',
  GRIMSTAD = 'GRIMSTAD',
  GRONG = 'GRONG',
  GRUE = 'GRUE',
  GRUMS = 'GRUMS',
  GULEN = 'GULEN',
  GULLSPANG = 'GULLSPANG',
  HA = 'HA',
  HAABO = 'HAABO',
  HABMER_HAMAROY = 'HABMER_HAMAROY',
  HABO = 'HABO',
  HADSEL = 'HADSEL',
  HAEGEBOSTAD = 'HAEGEBOSTAD',
  HAGFORS = 'HAGFORS',
  HALDEN = 'HALDEN',
  HALLEFORS = 'HALLEFORS',
  HALLSBERG = 'HALLSBERG',
  HALLSTAHAMMAR = 'HALLSTAHAMMAR',
  HALMSTAD = 'HALMSTAD',
  HAMAR = 'HAMAR',
  HAMMARO = 'HAMMARO',
  HAMMERFEST = 'HAMMERFEST',
  HANINGE = 'HANINGE',
  HAPARANDA = 'HAPARANDA',
  HAREID = 'HAREID',
  HARJEDALEN = 'HARJEDALEN',
  HARNOSAND = 'HARNOSAND',
  HARRYDA = 'HARRYDA',
  HARSTAD = 'HARSTAD',
  HASSLEHOLM = 'HASSLEHOLM',
  HASVIK = 'HASVIK',
  HAUGESUND = 'HAUGESUND',
  HEBY = 'HEBY',
  HEDEMORA = 'HEDEMORA',
  HEIM = 'HEIM',
  HELSINGBORG = 'HELSINGBORG',
  HEMNES = 'HEMNES',
  HEMSEDAL = 'HEMSEDAL',
  HEROY_MORE_OG_ROMSDAL = 'HEROY_MORE_OG_ROMSDAL',
  HEROY_NORDLAND = 'HEROY_NORDLAND',
  HERRLJUNGA = 'HERRLJUNGA',
  HITRA = 'HITRA',
  HJARTDAL = 'HJARTDAL',
  HJELMELAND = 'HJELMELAND',
  HJO = 'HJO',
  HOFORS = 'HOFORS',
  HOGANAS = 'HOGANAS',
  HOGSBY = 'HOGSBY',
  HOL = 'HOL',
  HOLE = 'HOLE',
  HOLMESTRAND = 'HOLMESTRAND',
  HOLTALEN = 'HOLTALEN',
  HOOR = 'HOOR',
  HORBY = 'HORBY',
  HORTEN = 'HORTEN',
  HOYANGER = 'HOYANGER',
  HOYLANDET = 'HOYLANDET',
  HUDDINGE = 'HUDDINGE',
  HUDIKSVALL = 'HUDIKSVALL',
  HULTSFRED = 'HULTSFRED',
  HURDAL = 'HURDAL',
  HUSTADVIKA = 'HUSTADVIKA',
  HVALER = 'HVALER',
  HYLLESTAD = 'HYLLESTAD',
  HYLTE = 'HYLTE',
  IBESTAD = 'IBESTAD',
  INDEROY = 'INDEROY',
  INDRE_FOSEN = 'INDRE_FOSEN',
  INDRE_OSTFOLD = 'INDRE_OSTFOLD',
  IVELAND = 'IVELAND',
  JARFALLA = 'JARFALLA',
  JEVNAKER = 'JEVNAKER',
  JOKKMOKK = 'JOKKMOKK',
  JONKOPING = 'JONKOPING',
  KAFJORD = 'KAFJORD',
  KALIX = 'KALIX',
  KALMAR = 'KALMAR',
  KARASJOK = 'KARASJOK',
  KARLSBORG = 'KARLSBORG',
  KARLSHAMN = 'KARLSHAMN',
  KARLSKOGA = 'KARLSKOGA',
  KARLSKRONA = 'KARLSKRONA',
  KARLSOY = 'KARLSOY',
  KARLSTAD = 'KARLSTAD',
  KARMOY = 'KARMOY',
  KATRINEHOLM = 'KATRINEHOLM',
  KAUTOKEINO = 'KAUTOKEINO',
  KAVLINGE = 'KAVLINGE',
  KIL = 'KIL',
  KINDA = 'KINDA',
  KINN = 'KINN',
  KIRUNA = 'KIRUNA',
  KLEPP = 'KLEPP',
  KLIPPAN = 'KLIPPAN',
  KNIVSTA = 'KNIVSTA',
  KONGSBERG = 'KONGSBERG',
  KONGSVINGER = 'KONGSVINGER',
  KOPING = 'KOPING',
  KRAGERO = 'KRAGERO',
  KRAMFORS = 'KRAMFORS',
  KRISTIANSAND = 'KRISTIANSAND',
  KRISTIANSTAD = 'KRISTIANSTAD',
  KRISTIANSUND = 'KRISTIANSUND',
  KRISTINEHAMN = 'KRISTINEHAMN',
  KRODSHERAD = 'KRODSHERAD',
  KROKOM = 'KROKOM',
  KUMLA = 'KUMLA',
  KUNGALV = 'KUNGALV',
  KUNGSBACKA = 'KUNGSBACKA',
  KUNGSOR = 'KUNGSOR',
  KVAEFJORD = 'KVAEFJORD',
  KVAENANGEN = 'KVAENANGEN',
  KVAM = 'KVAM',
  KVINESDAL = 'KVINESDAL',
  KVINNHERAD = 'KVINNHERAD',
  KVITESEID = 'KVITESEID',
  KVITSOY = 'KVITSOY',
  LAERDAL = 'LAERDAL',
  LAHOLM = 'LAHOLM',
  LANDSKRONA = 'LANDSKRONA',
  LARVIK = 'LARVIK',
  LAVANGEN = 'LAVANGEN',
  LAXA = 'LAXA',
  LEBESBY = 'LEBESBY',
  LEIRFJORD = 'LEIRFJORD',
  LEKA = 'LEKA',
  LEKEBERG = 'LEKEBERG',
  LEKSAND = 'LEKSAND',
  LERUM = 'LERUM',
  LESJA = 'LESJA',
  LESSEBO = 'LESSEBO',
  LEVANGER = 'LEVANGER',
  LIDINGO = 'LIDINGO',
  LIDKOPING = 'LIDKOPING',
  LIER = 'LIER',
  LIERNE = 'LIERNE',
  LILLA_EDET = 'LILLA_EDET',
  LILLEHAMMER = 'LILLEHAMMER',
  LILLESAND = 'LILLESAND',
  LILLESTROM = 'LILLESTROM',
  LINDESBERG = 'LINDESBERG',
  LINDESNES = 'LINDESNES',
  LINKOPING = 'LINKOPING',
  LJUNGBY = 'LJUNGBY',
  LJUSDAL = 'LJUSDAL',
  LJUSNARSBERG = 'LJUSNARSBERG',
  LODINGEN = 'LODINGEN',
  LOM = 'LOM',
  LOMMA = 'LOMMA',
  LOPPA = 'LOPPA',
  LORENSKOG = 'LORENSKOG',
  LOTEN = 'LOTEN',
  LUDVIKA = 'LUDVIKA',
  LULEA = 'LULEA',
  LUND = 'LUND',
  LUND_ROGALAND = 'LUND_ROGALAND',
  LUNNER = 'LUNNER',
  LUROY = 'LUROY',
  LUSTER = 'LUSTER',
  LYCKSELE = 'LYCKSELE',
  LYNGDAL = 'LYNGDAL',
  LYNGEN = 'LYNGEN',
  LYSEKIL = 'LYSEKIL',
  MALA = 'MALA',
  MALMO = 'MALMO',
  MALSELV = 'MALSELV',
  MALUNG_SALEN = 'MALUNG_SALEN',
  MALVIK = 'MALVIK',
  MARIESTAD = 'MARIESTAD',
  MARK = 'MARK',
  MARKARYD = 'MARKARYD',
  MARKER = 'MARKER',
  MASFJORDEN = 'MASFJORDEN',
  MASOY = 'MASOY',
  MELHUS = 'MELHUS',
  MELLERUD = 'MELLERUD',
  MELOY = 'MELOY',
  MERAKER = 'MERAKER',
  MIDTRE_GAULDAL = 'MIDTRE_GAULDAL',
  MIDT_TELEMARK = 'MIDT_TELEMARK',
  MJOLBY = 'MJOLBY',
  MODALEN = 'MODALEN',
  MODUM = 'MODUM',
  MOLDE = 'MOLDE',
  MOLNDAL = 'MOLNDAL',
  MONSTERAS = 'MONSTERAS',
  MORA = 'MORA',
  MORBYLANGA = 'MORBYLANGA',
  MOSKENES = 'MOSKENES',
  MOSS = 'MOSS',
  MOTALA = 'MOTALA',
  MULLSJO = 'MULLSJO',
  MUNKEDAL = 'MUNKEDAL',
  MUNKFORS = 'MUNKFORS',
  NACKA = 'NACKA',
  NAEROYSUND = 'NAEROYSUND',
  NAMSOS = 'NAMSOS',
  NAMSSKOGAN = 'NAMSSKOGAN',
  NANNESTAD = 'NANNESTAD',
  NARVIK = 'NARVIK',
  NASSJO = 'NASSJO',
  NES = 'NES',
  NESBYEN = 'NESBYEN',
  NESNA = 'NESNA',
  NESODDEN = 'NESODDEN',
  NESSEBY = 'NESSEBY',
  NISSEDAL = 'NISSEDAL',
  NITTEDAL = 'NITTEDAL',
  NOME = 'NOME',
  NORA = 'NORA',
  NORBERG = 'NORBERG',
  NORDANSTIG = 'NORDANSTIG',
  NORDKAPP = 'NORDKAPP',
  NORDMALING = 'NORDMALING',
  NORDREISA = 'NORDREISA',
  NORDRE_FOLLO = 'NORDRE_FOLLO',
  NORDRE_LAND = 'NORDRE_LAND',
  NORD_AURDAL = 'NORD_AURDAL',
  NORD_FRON = 'NORD_FRON',
  NORD_ODAL = 'NORD_ODAL',
  NORE_OG_UVDAL = 'NORE_OG_UVDAL',
  NORRKOPING = 'NORRKOPING',
  NORRTALJE = 'NORRTALJE',
  NORSJO = 'NORSJO',
  NOTODDEN = 'NOTODDEN',
  NYBRO = 'NYBRO',
  NYKOPING = 'NYKOPING',
  NYKVARN = 'NYKVARN',
  NYNASHAMN = 'NYNASHAMN',
  OCKELBO = 'OCKELBO',
  OCKERO = 'OCKERO',
  ODESHOG = 'ODESHOG',
  OKSNES = 'OKSNES',
  OLOFSTROM = 'OLOFSTROM',
  OPPDAL = 'OPPDAL',
  OREBRO = 'OREBRO',
  ORKELLJUNGA = 'ORKELLJUNGA',
  ORKLAND = 'ORKLAND',
  ORLAND = 'ORLAND',
  ORNSKOLDSVIK = 'ORNSKOLDSVIK',
  ORSA = 'ORSA',
  ORSTA = 'ORSTA',
  ORUST = 'ORUST',
  OS = 'OS',
  OSBY = 'OSBY',
  OSEN = 'OSEN',
  OSKARSHAMN = 'OSKARSHAMN',
  OSLO = 'OSLO',
  OSTERAKER = 'OSTERAKER',
  OSTEROY = 'OSTEROY',
  OSTERSUND = 'OSTERSUND',
  OSTHAMMAR = 'OSTHAMMAR',
  OSTRA_GOINGE = 'OSTRA_GOINGE',
  OSTRE_TOTEN = 'OSTRE_TOTEN',
  OVANAKER = 'OVANAKER',
  OVERHALLA = 'OVERHALLA',
  OVERKALIX = 'OVERKALIX',
  OVERTORNEA = 'OVERTORNEA',
  OVRE_EIKER = 'OVRE_EIKER',
  OXELOSUND = 'OXELOSUND',
  OYER = 'OYER',
  OYGARDEN = 'OYGARDEN',
  OYSTRE_SLIDRE = 'OYSTRE_SLIDRE',
  PAJALA = 'PAJALA',
  PARTILLE = 'PARTILLE',
  PERSTORP = 'PERSTORP',
  PITEA = 'PITEA',
  PORSANGER = 'PORSANGER',
  PORSGRUNN = 'PORSGRUNN',
  RADE = 'RADE',
  RAELINGEN = 'RAELINGEN',
  RAGUNDA = 'RAGUNDA',
  RAKKESTAD = 'RAKKESTAD',
  RANA = 'RANA',
  RANDABERG = 'RANDABERG',
  RATTVIK = 'RATTVIK',
  RAUMA = 'RAUMA',
  RENDALEN = 'RENDALEN',
  RENNEBU = 'RENNEBU',
  RINDAL = 'RINDAL',
  RINGEBU = 'RINGEBU',
  RINGERIKE = 'RINGERIKE',
  RINGSAKER = 'RINGSAKER',
  RISOR = 'RISOR',
  ROBERTSFORS = 'ROBERTSFORS',
  RODOY = 'RODOY',
  ROLLAG = 'ROLLAG',
  RONNEBY = 'RONNEBY',
  ROROS = 'ROROS',
  ROST = 'ROST',
  ROYRVIK = 'ROYRVIK',
  SAFFLE = 'SAFFLE',
  SALA = 'SALA',
  SALANGEN = 'SALANGEN',
  SALEM = 'SALEM',
  SALTDAL = 'SALTDAL',
  SAMNANGER = 'SAMNANGER',
  SANDE = 'SANDE',
  SANDEFJORD = 'SANDEFJORD',
  SANDNES = 'SANDNES',
  SANDVIKEN = 'SANDVIKEN',
  SARPSBORG = 'SARPSBORG',
  SATER = 'SATER',
  SAUDA = 'SAUDA',
  SAVSJO = 'SAVSJO',
  SEL = 'SEL',
  SELBU = 'SELBU',
  SELJORD = 'SELJORD',
  SENJA = 'SENJA',
  SIGDAL = 'SIGDAL',
  SIGTUNA = 'SIGTUNA',
  SILJAN = 'SILJAN',
  SIMRISHAMN = 'SIMRISHAMN',
  SIRDAL = 'SIRDAL',
  SJOBO = 'SJOBO',
  SKARA = 'SKARA',
  SKAUN = 'SKAUN',
  SKELLEFTEA = 'SKELLEFTEA',
  SKIEN = 'SKIEN',
  SKINNSKATTEBERG = 'SKINNSKATTEBERG',
  SKIPTVET = 'SKIPTVET',
  SKJAK = 'SKJAK',
  SKJERVOY = 'SKJERVOY',
  SKOVDE = 'SKOVDE',
  SKURUP = 'SKURUP',
  SMEDJEBACKEN = 'SMEDJEBACKEN',
  SMOLA = 'SMOLA',
  SNASA = 'SNASA',
  SODERHAMN = 'SODERHAMN',
  SODERKOPING = 'SODERKOPING',
  SODERTALJE = 'SODERTALJE',
  SOGNDAL = 'SOGNDAL',
  SOKNDAL = 'SOKNDAL',
  SOLA = 'SOLA',
  SOLLEFTEA = 'SOLLEFTEA',
  SOLLENTUNA = 'SOLLENTUNA',
  SOLNA = 'SOLNA',
  SOLUND = 'SOLUND',
  SOLVESBORG = 'SOLVESBORG',
  SOMNA = 'SOMNA',
  SONDRE_LAND = 'SONDRE_LAND',
  SORFOLD = 'SORFOLD',
  SORREISA = 'SORREISA',
  SORSELE = 'SORSELE',
  SORTLAND_SUORTA = 'SORTLAND_SUORTA',
  SOR_AURDAL = 'SOR_AURDAL',
  SOR_FRON = 'SOR_FRON',
  SOR_ODAL = 'SOR_ODAL',
  SOR_VARANGER = 'SOR_VARANGER',
  SOTENAS = 'SOTENAS',
  STAD = 'STAD',
  STAFFANSTORP = 'STAFFANSTORP',
  STANGE = 'STANGE',
  STAVANGER = 'STAVANGER',
  STEIGEN = 'STEIGEN',
  STEINKJER = 'STEINKJER',
  STENUNGSUND = 'STENUNGSUND',
  STJORDAL = 'STJORDAL',
  STOCKHOLM = 'STOCKHOLM',
  STORD = 'STORD',
  STORFJORD = 'STORFJORD',
  STORFORS = 'STORFORS',
  STORUMAN = 'STORUMAN',
  STOR_ELVDAL = 'STOR_ELVDAL',
  STRAND = 'STRAND',
  STRANDA = 'STRANDA',
  STRANGNAS = 'STRANGNAS',
  STROMSTAD = 'STROMSTAD',
  STROMSUND = 'STROMSUND',
  STRYN = 'STRYN',
  SULA = 'SULA',
  SULDAL = 'SULDAL',
  SUNDBYBERG = 'SUNDBYBERG',
  SUNDSVALL = 'SUNDSVALL',
  SUNNDAL = 'SUNNDAL',
  SUNNE = 'SUNNE',
  SUNNFJORD = 'SUNNFJORD',
  SURAHAMMAR = 'SURAHAMMAR',
  SURNADAL = 'SURNADAL',
  SVALOV = 'SVALOV',
  SVEDALA = 'SVEDALA',
  SVEIO = 'SVEIO',
  SVENLJUNGA = 'SVENLJUNGA',
  SYKKYLVEN = 'SYKKYLVEN',
  TABY = 'TABY',
  TANA = 'TANA',
  TANUM = 'TANUM',
  TIBRO = 'TIBRO',
  TIDAHOLM = 'TIDAHOLM',
  TIERP = 'TIERP',
  TIME = 'TIME',
  TIMRA = 'TIMRA',
  TINGSRYD = 'TINGSRYD',
  TINGVOLL = 'TINGVOLL',
  TINN = 'TINN',
  TJELDSUND = 'TJELDSUND',
  TJORN = 'TJORN',
  TOKKE = 'TOKKE',
  TOLGA = 'TOLGA',
  TOMELILLA = 'TOMELILLA',
  TONSBERG = 'TONSBERG',
  TOREBODA = 'TOREBODA',
  TORSAS = 'TORSAS',
  TORSBY = 'TORSBY',
  TRAENA = 'TRAENA',
  TRANAS = 'TRANAS',
  TRANEMO = 'TRANEMO',
  TRELLEBORG = 'TRELLEBORG',
  TROLLHATTAN = 'TROLLHATTAN',
  TROMSO = 'TROMSO',
  TRONDHEIM = 'TRONDHEIM',
  TROSA = 'TROSA',
  TRYSIL = 'TRYSIL',
  TVEDESTRAND = 'TVEDESTRAND',
  TYDAL = 'TYDAL',
  TYNSET = 'TYNSET',
  TYRESO = 'TYRESO',
  TYSNES = 'TYSNES',
  TYSVAER = 'TYSVAER',
  UDDEVALLA = 'UDDEVALLA',
  ULLENSAKER = 'ULLENSAKER',
  ULLENSVANG = 'ULLENSVANG',
  ULRICEHAMN = 'ULRICEHAMN',
  ULSTEIN = 'ULSTEIN',
  ULVIK = 'ULVIK',
  UMEA = 'UMEA',
  UPPLANDS_BRO = 'UPPLANDS_BRO',
  UPPLANDS_VASBY = 'UPPLANDS_VASBY',
  UPPSALA = 'UPPSALA',
  UPPVIDINGE = 'UPPVIDINGE',
  UTSIRA = 'UTSIRA',
  VADSO = 'VADSO',
  VADSTENA = 'VADSTENA',
  VAEROY = 'VAEROY',
  VAGA = 'VAGA',
  VAGAN = 'VAGAN',
  VAGGERYD = 'VAGGERYD',
  VAKSDAL = 'VAKSDAL',
  VALDEMARSVIK = 'VALDEMARSVIK',
  VALER_INNLANDET = 'VALER_INNLANDET',
  VALER_VIKEN = 'VALER_VIKEN',
  VALLE = 'VALLE',
  VALLENTUNA = 'VALLENTUNA',
  VANERSBORG = 'VANERSBORG',
  VANG = 'VANG',
  VANNAS = 'VANNAS',
  VANSBRO = 'VANSBRO',
  VANYLVEN = 'VANYLVEN',
  VARA = 'VARA',
  VARBERG = 'VARBERG',
  VARDO = 'VARDO',
  VARGARDA = 'VARGARDA',
  VARMDO = 'VARMDO',
  VARNAMO = 'VARNAMO',
  VASTERAS = 'VASTERAS',
  VASTERVIK = 'VASTERVIK',
  VAXHOLM = 'VAXHOLM',
  VAXJO = 'VAXJO',
  VEFSN = 'VEFSN',
  VEGA = 'VEGA',
  VEGARSHEI = 'VEGARSHEI',
  VELLINGE = 'VELLINGE',
  VENNESLA = 'VENNESLA',
  VERDAL = 'VERDAL',
  VESTBY = 'VESTBY',
  VESTNES = 'VESTNES',
  VESTRE_SLIDRE = 'VESTRE_SLIDRE',
  VESTRE_TOTEN = 'VESTRE_TOTEN',
  VESTVAGOY = 'VESTVAGOY',
  VETLANDA = 'VETLANDA',
  VEVELSTAD = 'VEVELSTAD',
  VIK = 'VIK',
  VILHELMINA = 'VILHELMINA',
  VIMMERBY = 'VIMMERBY',
  VINDAFJORD = 'VINDAFJORD',
  VINDELN = 'VINDELN',
  VINGAKER = 'VINGAKER',
  VINJE = 'VINJE',
  VOLDA = 'VOLDA',
  VOSS = 'VOSS',
  YDRE = 'YDRE',
  YSTAD = 'YSTAD'
}

export type MunicipalityAlternative = {
  __typename?: 'MunicipalityAlternative';
  label: Scalars['String']['output'];
  region: WhichRegionAlternative;
  value: Scalars['String']['output'];
};

export type MunicipalityArrayComparator = {
  all?: InputMaybe<Array<Municipality>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<Municipality>>;
  has?: InputMaybe<Municipality>;
  some?: InputMaybe<Array<Municipality>>;
};

export type MunicipalityComparator = {
  eq?: InputMaybe<Municipality>;
  in?: InputMaybe<Array<Municipality>>;
  neq?: InputMaybe<Municipality>;
  nin?: InputMaybe<Array<Municipality>>;
};

export type MunicipalityOptionsOptions = {
  __typename?: 'MunicipalityOptionsOptions';
  labels: Array<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptContactRequest: ContactRequest;
  acceptOffers: Array<DisplayProfile>;
  acceptPresentation: Presentation;
  acceptScheduleDraft: ScheduleDraft;
  acknowledgeBroadcastMessage?: Maybe<BroadcastMessage>;
  addInternalNoteToJobApplication: Scalars['Boolean']['output'];
  addMembers: Conversation;
  addNoteToEmployersToJobApplication: Scalars['Boolean']['output'];
  addRequirementsToTenderTemplate: TenderTemplate;
  addResourceToSchedulingPeriod: SchedulingPeriod;
  addRole: Identity;
  aggregateSalary: Scalars['Boolean']['output'];
  applyToEmployer: Scalars['Boolean']['output'];
  applyToShift: ShiftApplication;
  applyToVacancy: VacancyApplication;
  approveTenderWaiver: TenderWaiver;
  archiveCandidateBooking: CandidateBooking;
  archiveConnection: Scalars['String']['output'];
  archiveConnectionAndRemoveEmployerContact: Scalars['String']['output'];
  archiveExpiredJobApplications: Scalars['Int']['output'];
  archiveExpiredJobPostings: Scalars['Int']['output'];
  archiveJobPosting: JobPosting;
  archiveJobPostings: Array<JobPosting>;
  archivePresentation: Presentation;
  archiveShift: Shift;
  archiveShifts: Array<Shift>;
  assignJobApplication: Scalars['Boolean']['output'];
  assignTenderWinner: Tender;
  attestTimesheet: Timesheet;
  attestTimesheets: Array<Timesheet>;
  authenticateWithBankId: BankIdOrder;
  bookCandidate: CandidateBooking;
  bookCandidateOnFlexShifts: Array<ShiftBooking>;
  bookCandidateOnShift: ShiftBooking;
  bookCandidateOnShifts: Array<ShiftBooking>;
  bookReplacement: CandidateBooking;
  cancelScheduleDraftGeneration: ScheduleDraft;
  cancelShiftBooking: ShiftBooking;
  checkAndSendGroupedNotifications: Scalars['Boolean']['output'];
  checkAwaitingReviewLeads: Scalars['Boolean']['output'];
  closeExpiredTenders: Scalars['Int']['output'];
  closeTender: Tender;
  closeTenderWaiver: TenderWaiver;
  contactOnJobPosting: Scalars['Boolean']['output'];
  copyTender: Tender;
  createAttachmentFromFileUpload: Attachment;
  createBaseSchedule: BaseSchedule;
  createBillingInformation: BillingInformation;
  createBroadcastMessage: BroadcastMessage;
  createCandidate: Scalars['String']['output'];
  createCandidateComments: Array<CandidateComment>;
  createComment: Scalars['String']['output'];
  createCompanyReview: BankIdOrder;
  createCompanyReviewWithoutBankId: Scalars['String']['output'];
  createCompensationModel: CompensationModel;
  createConnection: AbstractConnection;
  createCustomRole: CustomRole;
  createDelegation: Delegation;
  createEmptyScheduleDraft: ScheduleDraft;
  createEventBookmark: EventBookmark;
  createJobApplication: Scalars['String']['output'];
  createJobPostingTemplate: JobPostingTemplate;
  createNote: Note;
  createOrganization: Scalars['String']['output'];
  createPool: Pool;
  createPresentedAvailability: Array<PresentedAvailability>;
  createPriceZone: PriceZone;
  createRankedCompany: RankedCompany;
  createReceipt: Receipt;
  createReference: Reference;
  createReply: Scalars['String']['output'];
  createResourceAvailability: Array<ResourceAvailability>;
  createSalary: Salary;
  createScheduleDraftFromBaseSchedule: ScheduleDraft;
  createScheduleDraftResources: ScheduleDraft;
  createScheduleResource: ScheduleResource;
  createSchedulingPeriod: SchedulingPeriod;
  createSchedulingPeriodActivity: SchedulingPeriodActivity;
  createSchedulingPeriodConfiguration: SchedulingPeriodConfiguration;
  createShiftPreset: ScheduleResource;
  createShifts: Array<Shift>;
  createSupplierDeviation: SupplierDeviation;
  createTag: Tag;
  createTender: Tender;
  createTenderFromWaiver: Tender;
  createTenderInvoice: TenderInvoice;
  createTenderPriceGroup: TenderPriceGroup;
  createTenderTemplate: TenderTemplate;
  createTenderWaiver: TenderWaiver;
  createTenderedAvailability: Array<TenderedAvailability>;
  createUnit: Unit;
  createVacancy: Vacancy;
  deleteAttachment: Scalars['Boolean']['output'];
  deleteBaseSchedule: BaseSchedule;
  deleteBroadcastMessage: BroadcastMessage;
  deleteCandidate: Scalars['Boolean']['output'];
  deleteCompanyReview: Scalars['String']['output'];
  deleteDelegation: Scalars['String']['output'];
  deleteDraftTender: Scalars['Boolean']['output'];
  deleteEmployee: Scalars['Boolean']['output'];
  deleteEventBookmark: EventBookmark;
  deleteFileUpload: Scalars['Boolean']['output'];
  deleteJobApplication: Scalars['Boolean']['output'];
  deleteOldNotifications: Scalars['Int']['output'];
  deleteOwnProfile: Scalars['String']['output'];
  deleteProfile: Scalars['String']['output'];
  deleteReference: Scalars['Boolean']['output'];
  deleteRequirementsFromTenderTemplate: TenderTemplate;
  deleteResourceAvailability: Scalars['Boolean']['output'];
  deleteScheduleDraft: Scalars['Boolean']['output'];
  deleteSchedulingPeriodActivity: Scalars['Boolean']['output'];
  deleteShiftPreset: ScheduleResource;
  deleteSupplierDeviation: SupplierDeviation;
  deleteTenderInvoice: Scalars['Boolean']['output'];
  deleteTenderPriceGroup: Scalars['Boolean']['output'];
  deleteTenderTemplate: Scalars['Boolean']['output'];
  deleteUnit: Unit;
  disableEmployee: Scalars['Boolean']['output'];
  enableTenderTimesheets: Tender;
  extendCandidateBooking: CandidateBooking;
  flagMessage: Message;
  forceSendAllPreparedJobApplications: Scalars['Boolean']['output'];
  generateInitialOffersForAwaitingJobApplications: Scalars['Boolean']['output'];
  generatePresentation: Presentation;
  generateReplacementPresentation: Presentation;
  generateScheduleDraft: ScheduleDraft;
  generateSignedUploadUrl: Scalars['String']['output'];
  getConsultantCredentials: ConsultantCredentials;
  getConsultantInviteLink: Scalars['String']['output'];
  ignoreJobApplication: Scalars['Boolean']['output'];
  importUnits: Scalars['Int']['output'];
  inviteEmployee: Candidate;
  inviteEmployees: Array<Candidate>;
  inviteOrgMember: Identity;
  invitePriceGroupFrameworkParticipant: TenderPriceGroup;
  inviteReference: Reference;
  inviteSuppliersToTender: Tender;
  inviteTestEmployees: Array<Candidate>;
  joinConversation: Conversation;
  leaveConversation: Conversation;
  markAsReadyToSendJobApplications: Scalars['Boolean']['output'];
  markAsViewed: Array<EventNotification>;
  markCandidateAsAbsent: ShiftBooking;
  markConversationAsViewed: Conversation;
  markJobApplicationReadyToSend: Scalars['Boolean']['output'];
  markMessageAsViewed: Message;
  markPresentationAsReadyForReview: Presentation;
  markScheduleSlotAsSeen: ScheduleSlot;
  markScheduleSlotAsUninteresting: ScheduleSlot;
  markShiftAsAcknowledged: ShiftBooking;
  markTenderAsFilled: Tender;
  markTenderAsUrgent: Tender;
  markTenderReadyToPublish: Tender;
  openUpPresentationForRevision: Presentation;
  publishJobPostings: Array<JobPosting>;
  publishJobPostingsWithoutTemplate: JobPosting;
  publishShifts: Array<Shift>;
  publishTender: Tender;
  readContactRequest: ContactRequest;
  refreshTenderScope: Tender;
  refreshTenderVacancies: Array<Vacancy>;
  refundConnection: AbstractConnection;
  registerAttachment: Attachment;
  registerEvent: Scalars['Boolean']['output'];
  registerFileUpload: FileUpload;
  registerProfessional: Scalars['String']['output'];
  rejectContactRequest: ContactRequest;
  rejectOffers: Array<DisplayProfile>;
  rejectPresentation: Presentation;
  rejectTenderWaiver: TenderWaiver;
  reopenTender: Tender;
  reopenTenderWaiver: TenderWaiver;
  reportJobApplicationCall: Scalars['Boolean']['output'];
  reportResourceAvailability: Array<ResourceAvailability>;
  reportTime: Timesheet;
  reportTimes: Array<Timesheet>;
  requestEmailReset: Scalars['Boolean']['output'];
  requestMoreContacts: Scalars['Boolean']['output'];
  rescoreSupplier: Tender;
  rescoreTender: Tender;
  resetPassword: Scalars['Boolean']['output'];
  respondToShiftApplication: ShiftApplication;
  respondToShiftSuggestion: ShiftSuggestion;
  respondToShiftSuggestions: ShiftSuggestion;
  retryPublishingPlatsbankenJobPostings: Array<Scalars['String']['output']>;
  returnTimesheet: Timesheet;
  returnTimesheets: Array<Timesheet>;
  reviewPresentation: PresentationReview;
  revokePresentation: Presentation;
  sendAllPreparedJobApplications: Scalars['Boolean']['output'];
  sendConfirmationReminder: Presentation;
  sendConsultantManagerPendingTimesheetNotifications: Scalars['Boolean']['output'];
  sendContactRequest: ContactRequest;
  sendContactRequestReminders: SendContactRequestRemindersResult;
  sendDirectApplicationsNotifications: Scalars['Boolean']['output'];
  sendJobApplication: Scalars['Boolean']['output'];
  sendMessage: Conversation;
  sendPresentation: Presentation;
  sendPresentationConfirmationReminders: Scalars['Boolean']['output'];
  sendUnitManagerPendingTimesheetNotifications: Scalars['Boolean']['output'];
  sendUpcomingUnoccupiedShiftsReminder: Scalars['Boolean']['output'];
  setCustomClaims: Scalars['Boolean']['output'];
  setJobApplicationOffers: Scalars['Boolean']['output'];
  setJobApplicationOffersBulk: Array<Scalars['Boolean']['output']>;
  setRoles: Identity;
  signReference: BankIdOrder;
  snoozeJobApplicationUntilDate: Scalars['Boolean']['output'];
  startExternalConversation: ExternalConversation;
  startInternalConversation: InternalConversation;
  submitDataPurgeRequest: Scalars['Boolean']['output'];
  subscribeToNewsletter: Scalars['Boolean']['output'];
  suggestShift: ShiftSuggestion;
  suggestShifts: Array<ShiftSuggestion>;
  tenderShifts: Array<Shift>;
  updateAttachment: Attachment;
  updateBillingInformation: BillingInformation;
  updateBroadcastMessage: BroadcastMessage;
  updateCandidate: Candidate;
  updateCandidateBookingManagers: CandidateBooking;
  updateCandidatePersonalIdentityNumber: Candidate;
  updateCandidates: Array<Candidate>;
  updateCompanyRankings: Scalars['Boolean']['output'];
  updateCompensationModel: CompensationModel;
  updateConnection: AbstractConnection;
  updateContactPreferences: ContactPreferences;
  updateCustomRole: CustomRole;
  updateDayDemands: SchedulingPeriod;
  updateDelegation: Delegation;
  updateEmployment: Employment;
  updateEmployments: Array<Employment>;
  updateFileUpload: FileUpload;
  updateGraphicProfile: Organization;
  updateJobApplicationAnsweredStatus: Scalars['Boolean']['output'];
  updateJobApplicationContactedStatus: Scalars['Boolean']['output'];
  updateJobApplicationSlots: Scalars['Boolean']['output'];
  updateJobApplicationStage: JobApplication;
  updateJobPostingTemplate: JobPostingTemplate;
  updateNote: Note;
  updateNotificationInterests: NotificationInterests;
  updateOrgMember: Identity;
  updateOrganization: Organization;
  updateOrganizationFeatures: Organization;
  updatePool: Pool;
  updatePresentation: Presentation;
  updatePresentedAvailability: Array<PresentedAvailability>;
  updatePriceZone: PriceZone;
  updateRankedCompany: Scalars['Boolean']['output'];
  updateReference: Reference;
  updateReferenceAnswers: Reference;
  updateReferenceStatus: Reference;
  updateRequirementFulfillmentForPresentation: RequirementFulfillment;
  updateResourceAvailability: Array<ResourceAvailability>;
  updateScheduleDraft: ScheduleDraft;
  updateScheduleResource: ScheduleResource;
  updateSchedulingPeriod: SchedulingPeriod;
  updateSchedulingPeriodActivity: SchedulingPeriodActivity;
  updateSchedulingPeriodConfiguration: SchedulingPeriodConfiguration;
  updateSchedulingPeriodPrompts: SchedulingPeriod;
  updateSchedulingPeriodResourceConfigurations: SchedulingPeriod;
  updateShift: Shift;
  updateShiftDemands: SchedulingPeriod;
  updateShifts: Array<Shift>;
  updateTender: Tender;
  updateTenderPriceGroup: TenderPriceGroup;
  updateTenderPriceGroupCompensationModel: TenderPriceGroup;
  updateTenderRequirements: Requirements;
  updateTenderShiftsSchedule: Tender;
  updateTenderSupplierDecision: TenderSupplier;
  updateTenderTemplate: TenderTemplate;
  updateTenderTemplateRequirements: Requirements;
  updateTenderWaiver: TenderWaiver;
  updateTenderedAvailability: Array<TenderedAvailability>;
  updateTendersConfiguration: TendersConfiguration;
  updateUnit: Unit;
  uploadSchedulerOutput: ScheduleDraft;
  viewPresentation: Presentation;
  viewVacancy: Vacancy;
  withdrawPresentation: Presentation;
  withdrawPresentationAcceptance: Presentation;
  withdrawShiftApplication: ShiftApplication;
  withdrawTenderWaiverRejection: TenderWaiver;
};


export type MutationacceptContactRequestArgs = {
  employerId: Scalars['String']['input'];
};


export type MutationacceptOffersArgs = {
  offers: Array<HandleOfferInput>;
};


export type MutationacceptPresentationArgs = {
  input: AcceptPresentationInput;
};


export type MutationacceptScheduleDraftArgs = {
  scheduleDraftId: Scalars['String']['input'];
};


export type MutationacknowledgeBroadcastMessageArgs = {
  data: AcknowledgeBroadcastMessageInput;
};


export type MutationaddInternalNoteToJobApplicationArgs = {
  data: AddNoteInput;
};


export type MutationaddMembersArgs = {
  conversationId: Scalars['String']['input'];
  memberIds: Array<Scalars['String']['input']>;
};


export type MutationaddNoteToEmployersToJobApplicationArgs = {
  data: AddNoteInput;
};


export type MutationaddRequirementsToTenderTemplateArgs = {
  input: RequirementsInput;
  tenderTemplateId: Scalars['String']['input'];
};


export type MutationaddResourceToSchedulingPeriodArgs = {
  data: CreateSchedulingPeriodResourceConfigurationInput;
};


export type MutationaddRoleArgs = {
  id: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationapplyToEmployerArgs = {
  id: Scalars['String']['input'];
};


export type MutationapplyToShiftArgs = {
  data: ApplyToShiftInput;
};


export type MutationapplyToVacancyArgs = {
  employerId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};


export type MutationapproveTenderWaiverArgs = {
  id: Scalars['String']['input'];
  reviewComment: Scalars['String']['input'];
};


export type MutationarchiveCandidateBookingArgs = {
  id: Scalars['String']['input'];
};


export type MutationarchiveConnectionArgs = {
  data: ArchiveConnectionInput;
};


export type MutationarchiveConnectionAndRemoveEmployerContactArgs = {
  data: ArchiveConnectionAndRemoveEmployerContactInput;
};


export type MutationarchiveJobPostingArgs = {
  jobPostingId: Scalars['String']['input'];
};


export type MutationarchiveJobPostingsArgs = {
  jobPostingIds: Array<Scalars['String']['input']>;
};


export type MutationarchivePresentationArgs = {
  id: Scalars['String']['input'];
};


export type MutationarchiveShiftArgs = {
  data: ArchiveShiftInput;
};


export type MutationarchiveShiftsArgs = {
  data: Array<ArchiveShiftInput>;
};


export type MutationassignJobApplicationArgs = {
  data: AssignInput;
};


export type MutationassignTenderWinnerArgs = {
  tenderId: Scalars['String']['input'];
};


export type MutationattestTimesheetArgs = {
  data: AttestTimesheetInput;
};


export type MutationattestTimesheetsArgs = {
  data: Array<AttestTimesheetInput>;
};


export type MutationbookCandidateArgs = {
  presentationId: Scalars['String']['input'];
};


export type MutationbookCandidateOnFlexShiftsArgs = {
  data: BookCandidateOnFlexShiftsInput;
};


export type MutationbookCandidateOnShiftArgs = {
  data: BookCandidateOnShiftInput;
};


export type MutationbookCandidateOnShiftsArgs = {
  data: Array<BookCandidateOnShiftInput>;
};


export type MutationbookReplacementArgs = {
  presentationId: Scalars['String']['input'];
};


export type MutationcancelScheduleDraftGenerationArgs = {
  data: CancelScheduleDraftGenerationInput;
};


export type MutationcancelShiftBookingArgs = {
  data: CancelShiftBookingInput;
};


export type MutationcloseTenderArgs = {
  id: Scalars['String']['input'];
};


export type MutationcloseTenderWaiverArgs = {
  id: Scalars['String']['input'];
};


export type MutationcontactOnJobPostingArgs = {
  input: ContactOnJobPostingInput;
};


export type MutationcopyTenderArgs = {
  input: CopyTenderInput;
};


export type MutationcreateAttachmentFromFileUploadArgs = {
  input: ConvertFileUploadToAttachmentInput;
};


export type MutationcreateBaseScheduleArgs = {
  data: CreateBaseScheduleInput;
};


export type MutationcreateBillingInformationArgs = {
  data: CreateBillingInformationInput;
};


export type MutationcreateBroadcastMessageArgs = {
  data: CreateBroadcastMessageInput;
};


export type MutationcreateCandidateArgs = {
  fullName: Scalars['String']['input'];
  input?: InputMaybe<UpdateCandidateInput>;
  profession: Profession;
};


export type MutationcreateCandidateCommentsArgs = {
  candidateId: Scalars['String']['input'];
  input: Array<CreateCandidateCommentInput>;
};


export type MutationcreateCommentArgs = {
  data: CreateCommentInput;
};


export type MutationcreateCompanyReviewArgs = {
  data: CreateCompanyReviewInput;
};


export type MutationcreateCompanyReviewWithoutBankIdArgs = {
  data: CreateCompanyReviewInput;
};


export type MutationcreateCompensationModelArgs = {
  data: CreateCompensationModelInput;
};


export type MutationcreateConnectionArgs = {
  connectionStatus?: InputMaybe<ConnectionStatus>;
  employerId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};


export type MutationcreateCustomRoleArgs = {
  input: CreateCustomRoleInput;
};


export type MutationcreateDelegationArgs = {
  data: CreateDelegationInput;
};


export type MutationcreateEmptyScheduleDraftArgs = {
  data: CreateScheduleDraftInput;
};


export type MutationcreateEventBookmarkArgs = {
  data: CreateEventBookmarkInput;
};


export type MutationcreateJobApplicationArgs = {
  data: CreateJobApplicationInput;
};


export type MutationcreateJobPostingTemplateArgs = {
  data: CreateJobPostingTemplateInput;
};


export type MutationcreateNoteArgs = {
  data: CreateNoteInput;
};


export type MutationcreateOrganizationArgs = {
  data: CreateOrganizationInput;
};


export type MutationcreatePoolArgs = {
  input: CreatePoolInput;
};


export type MutationcreatePresentedAvailabilityArgs = {
  data: CreatePresentedAvailabilitiesInput;
};


export type MutationcreatePriceZoneArgs = {
  data: CreatePriceZoneInput;
};


export type MutationcreateRankedCompanyArgs = {
  data: CreateRankedCompanyInput;
};


export type MutationcreateReceiptArgs = {
  data: CreateReceiptInput;
};


export type MutationcreateReferenceArgs = {
  input: CreateReferenceInput;
};


export type MutationcreateReplyArgs = {
  data: CreateReplyInput;
};


export type MutationcreateResourceAvailabilityArgs = {
  data: Array<CreateResourceAvailabilityInput>;
};


export type MutationcreateSalaryArgs = {
  createSalaryData: CreateSalaryInput;
};


export type MutationcreateScheduleDraftFromBaseScheduleArgs = {
  data: CreateScheduleDraftFromBaseScheduleInput;
};


export type MutationcreateScheduleDraftResourcesArgs = {
  data: CreateScheduleDraftResourcesInput;
};


export type MutationcreateScheduleResourceArgs = {
  data: CreateScheduleResourceInput;
};


export type MutationcreateSchedulingPeriodArgs = {
  data: CreateSchedulingPeriodInput;
};


export type MutationcreateSchedulingPeriodActivityArgs = {
  data: CreateSchedulingPeriodActivityInput;
};


export type MutationcreateSchedulingPeriodConfigurationArgs = {
  data: CreateSchedulingPeriodConfigurationInput;
};


export type MutationcreateShiftPresetArgs = {
  data: CreateShiftPresetInput;
};


export type MutationcreateShiftsArgs = {
  data: Array<CreateShiftInput>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateSupplierDeviationArgs = {
  data: CreateSupplierDeviationInput;
};


export type MutationcreateTagArgs = {
  data: CreateTagInput;
};


export type MutationcreateTenderArgs = {
  input: CreateTenderInput;
};


export type MutationcreateTenderFromWaiverArgs = {
  data: CreateTenderFromWaiverInput;
};


export type MutationcreateTenderInvoiceArgs = {
  data: CreateTenderInvoiceInput;
};


export type MutationcreateTenderPriceGroupArgs = {
  input: CreateTenderPriceGroupInput;
};


export type MutationcreateTenderTemplateArgs = {
  input: CreateTenderTemplateInput;
};


export type MutationcreateTenderWaiverArgs = {
  data: CreateTenderWaiverInput;
};


export type MutationcreateTenderedAvailabilityArgs = {
  data: CreateTenderedAvailabilitiesInput;
};


export type MutationcreateUnitArgs = {
  input: CreateUnitInput;
  organizationIdOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateVacancyArgs = {
  input: CreateVacancyInput;
};


export type MutationdeleteAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteBaseScheduleArgs = {
  data: DeleteBaseScheduleInput;
};


export type MutationdeleteBroadcastMessageArgs = {
  data: DeleteBroadcastMessageInput;
};


export type MutationdeleteCandidateArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteCompanyReviewArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteDelegationArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteDraftTenderArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteEmployeeArgs = {
  identityId: Scalars['String']['input'];
};


export type MutationdeleteEventBookmarkArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteFileUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationdeleteJobApplicationArgs = {
  jobApplicationId: Scalars['String']['input'];
};


export type MutationdeleteProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationdeleteReferenceArgs = {
  data: DeleteReferenceInput;
};


export type MutationdeleteRequirementsFromTenderTemplateArgs = {
  input: RequirementsInput;
  tenderTemplateId: Scalars['String']['input'];
};


export type MutationdeleteResourceAvailabilityArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationdeleteScheduleDraftArgs = {
  data: DeleteScheduleDraftInput;
};


export type MutationdeleteSchedulingPeriodActivityArgs = {
  data: DeleteSchedulingPeriodActivityInput;
};


export type MutationdeleteShiftPresetArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteSupplierDeviationArgs = {
  data: DeleteSupplierDeviationInput;
};


export type MutationdeleteTenderInvoiceArgs = {
  data: DeleteTenderInvoiceInput;
};


export type MutationdeleteTenderPriceGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteTenderTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteUnitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdisableEmployeeArgs = {
  data: DisableEmployeeInput;
};


export type MutationenableTenderTimesheetsArgs = {
  data: EnableTenderTimesheetsInput;
};


export type MutationextendCandidateBookingArgs = {
  data: ExtendCandidateBookingInput;
};


export type MutationflagMessageArgs = {
  data: FlagMessageInput;
};


export type MutationforceSendAllPreparedJobApplicationsArgs = {
  market: Market;
};


export type MutationgenerateInitialOffersForAwaitingJobApplicationsArgs = {
  market: Market;
};


export type MutationgeneratePresentationArgs = {
  candidateId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};


export type MutationgenerateReplacementPresentationArgs = {
  candidateBookingId: Scalars['String']['input'];
  candidateId: Scalars['String']['input'];
};


export type MutationgenerateScheduleDraftArgs = {
  data: GenerateScheduleDraftInput;
};


export type MutationgenerateSignedUploadUrlArgs = {
  filePath: Scalars['String']['input'];
  publicRead: Scalars['Boolean']['input'];
};


export type MutationgetConsultantCredentialsArgs = {
  code: Scalars['String']['input'];
};


export type MutationgetConsultantInviteLinkArgs = {
  candidateBookingId: Scalars['String']['input'];
};


export type MutationignoreJobApplicationArgs = {
  data: ignoreJobApplicationInput;
};


export type MutationimportUnitsArgs = {
  organizationIds: Array<Scalars['String']['input']>;
  triggeredManually?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationinviteEmployeeArgs = {
  data: InviteEmployeeInput;
};


export type MutationinviteEmployeesArgs = {
  data: InviteEmployeesInput;
};


export type MutationinviteOrgMemberArgs = {
  data: InviteOrgMemberInput;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationinvitePriceGroupFrameworkParticipantArgs = {
  data: InvitePriceGroupFrameworkParticipantInput;
};


export type MutationinviteReferenceArgs = {
  input: InviteReferenceInput;
};


export type MutationinviteSuppliersToTenderArgs = {
  data: InviteSuppliersToTenderInput;
};


export type MutationinviteTestEmployeesArgs = {
  data: InviteTestEmployeesInput;
};


export type MutationjoinConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationleaveConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationmarkAsReadyToSendJobApplicationsArgs = {
  market: Market;
};


export type MutationmarkAsViewedArgs = {
  filter: EventFilter;
};


export type MutationmarkCandidateAsAbsentArgs = {
  shiftBookingId: Scalars['String']['input'];
};


export type MutationmarkConversationAsViewedArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationmarkJobApplicationReadyToSendArgs = {
  data: MarkReadyToSendInput;
};


export type MutationmarkMessageAsViewedArgs = {
  messageId: Scalars['String']['input'];
};


export type MutationmarkPresentationAsReadyForReviewArgs = {
  presentationId: Scalars['String']['input'];
};


export type MutationmarkScheduleSlotAsSeenArgs = {
  id: Scalars['String']['input'];
};


export type MutationmarkScheduleSlotAsUninterestingArgs = {
  id: Scalars['String']['input'];
};


export type MutationmarkShiftAsAcknowledgedArgs = {
  shiftBookingId: Scalars['String']['input'];
};


export type MutationmarkTenderAsFilledArgs = {
  id: Scalars['String']['input'];
};


export type MutationmarkTenderAsUrgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationmarkTenderReadyToPublishArgs = {
  id: Scalars['String']['input'];
};


export type MutationopenUpPresentationForRevisionArgs = {
  id: Scalars['String']['input'];
};


export type MutationpublishJobPostingsArgs = {
  data: PublishJobPostingsInput;
};


export type MutationpublishJobPostingsWithoutTemplateArgs = {
  input: CreateJobPostingsInput;
};


export type MutationpublishShiftsArgs = {
  data: Array<PublishShiftInput>;
};


export type MutationpublishTenderArgs = {
  data: PublishTenderInput;
};


export type MutationreadContactRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationrefreshTenderScopeArgs = {
  tenderId: Scalars['String']['input'];
};


export type MutationrefreshTenderVacanciesArgs = {
  id: Scalars['String']['input'];
};


export type MutationrefundConnectionArgs = {
  connectionId: Scalars['String']['input'];
};


export type MutationregisterAttachmentArgs = {
  data: RegisterAttachmentInput;
};


export type MutationregisterEventArgs = {
  data: RegisterEventInput;
};


export type MutationregisterFileUploadArgs = {
  data: RegisterFileUploadInput;
};


export type MutationregisterProfessionalArgs = {
  data: RegisterProfessionalInput;
};


export type MutationrejectContactRequestArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['String']['input'];
  reason?: InputMaybe<ContactRequestRejectionReason>;
};


export type MutationrejectOffersArgs = {
  offers: Array<HandleOfferInput>;
};


export type MutationrejectPresentationArgs = {
  input: RejectPresentationInput;
};


export type MutationrejectTenderWaiverArgs = {
  id: Scalars['String']['input'];
  reviewComment: Scalars['String']['input'];
};


export type MutationreopenTenderArgs = {
  data: ReopenTenderInput;
};


export type MutationreopenTenderWaiverArgs = {
  id: Scalars['String']['input'];
};


export type MutationreportJobApplicationCallArgs = {
  data: ReportJobApplicationCallInput;
};


export type MutationreportResourceAvailabilityArgs = {
  data: Array<ReportResourceAvailabilityInput>;
};


export type MutationreportTimeArgs = {
  data: ReportTimeInput;
};


export type MutationreportTimesArgs = {
  data: Array<ReportTimeInput>;
};


export type MutationrequestEmailResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationrescoreSupplierArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tenderId: Scalars['String']['input'];
};


export type MutationrescoreTenderArgs = {
  tenderId: Scalars['String']['input'];
};


export type MutationresetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationrespondToShiftApplicationArgs = {
  data: RespondToShiftApplicationInput;
};


export type MutationrespondToShiftSuggestionArgs = {
  data: RespondToShiftSuggestionInput;
};


export type MutationrespondToShiftSuggestionsArgs = {
  data: RespondToShiftSuggestionsInput;
};


export type MutationretryPublishingPlatsbankenJobPostingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationreturnTimesheetArgs = {
  data: ReturnTimesheetInput;
};


export type MutationreturnTimesheetsArgs = {
  data: Array<ReturnTimesheetInput>;
};


export type MutationreviewPresentationArgs = {
  input: ReviewPresentationInput;
};


export type MutationrevokePresentationArgs = {
  id: Scalars['String']['input'];
};


export type MutationsendConfirmationReminderArgs = {
  id: Scalars['String']['input'];
};


export type MutationsendContactRequestArgs = {
  identityId: Scalars['String']['input'];
  noteFromEmployer?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsendContactRequestRemindersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: FindContactRequestsFilter;
};


export type MutationsendJobApplicationArgs = {
  data: SendInput;
};


export type MutationsendMessageArgs = {
  conversationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationsendPresentationArgs = {
  id: Scalars['String']['input'];
};


export type MutationsetCustomClaimsArgs = {
  data: SetCustomClaimsInput;
};


export type MutationsetJobApplicationOffersArgs = {
  data: SetJobApplicationOffersInput;
};


export type MutationsetJobApplicationOffersBulkArgs = {
  ids: Array<Scalars['String']['input']>;
  offers: Array<OfferInput>;
};


export type MutationsetRolesArgs = {
  customRoles: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationsignReferenceArgs = {
  data: SignReferenceInput;
};


export type MutationsnoozeJobApplicationUntilDateArgs = {
  data: SnoozeJobApplicationUntilDateInput;
};


export type MutationstartExternalConversationArgs = {
  data: CreateExternalConversationInput;
};


export type MutationstartInternalConversationArgs = {
  data: CreateInternalConversationInput;
};


export type MutationsubmitDataPurgeRequestArgs = {
  content: Scalars['String']['input'];
};


export type MutationsubscribeToNewsletterArgs = {
  data: SubscribeToNewsletterInput;
};


export type MutationsuggestShiftArgs = {
  data: SuggestShiftInput;
};


export type MutationsuggestShiftsArgs = {
  data: SuggestShiftsInput;
};


export type MutationtenderShiftsArgs = {
  data: TenderShiftsInput;
};


export type MutationupdateAttachmentArgs = {
  data: UpdateAttachmentInput;
  id: Scalars['String']['input'];
};


export type MutationupdateBillingInformationArgs = {
  data: UpdateBillingInformationInput;
  id: Scalars['String']['input'];
};


export type MutationupdateBroadcastMessageArgs = {
  data: UpdateBroadcastMessageInput;
};


export type MutationupdateCandidateArgs = {
  id: Scalars['String']['input'];
  updates: UpdateCandidateInput;
};


export type MutationupdateCandidateBookingManagersArgs = {
  data: UpdateCandidateBookingManagersInput;
};


export type MutationupdateCandidatePersonalIdentityNumberArgs = {
  id: Scalars['String']['input'];
  personalIdentityNumber: Scalars['String']['input'];
};


export type MutationupdateCandidatesArgs = {
  data: UpdateCandidatesInput;
};


export type MutationupdateCompanyRankingsArgs = {
  market: Market;
};


export type MutationupdateCompensationModelArgs = {
  data: UpdateCompensationModelInput;
};


export type MutationupdateConnectionArgs = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  connectionId: Scalars['String']['input'];
  contactStatus?: InputMaybe<ConnectionContactStatus>;
};


export type MutationupdateContactPreferencesArgs = {
  data: UpdateContactPreferencesInput;
};


export type MutationupdateCustomRoleArgs = {
  id: Scalars['String']['input'];
  updates: UpdateCustomRoleInput;
};


export type MutationupdateDayDemandsArgs = {
  data: UpdateSchedulingPeriodDayDemandsInput;
};


export type MutationupdateDelegationArgs = {
  id: Scalars['String']['input'];
  updates: UpdateDelegationInput;
};


export type MutationupdateEmploymentArgs = {
  data: UpdateEmploymentInput;
};


export type MutationupdateEmploymentsArgs = {
  data: UpdateEmploymentsInput;
};


export type MutationupdateFileUploadArgs = {
  data: EditFileUploadInput;
};


export type MutationupdateGraphicProfileArgs = {
  updates: GraphicProfileInput;
};


export type MutationupdateJobApplicationAnsweredStatusArgs = {
  data: UpdateAnsweredStatusInput;
};


export type MutationupdateJobApplicationContactedStatusArgs = {
  data: UpdateContactedStatusInput;
};


export type MutationupdateJobApplicationSlotsArgs = {
  data: UpdateSlotsInput;
};


export type MutationupdateJobApplicationStageArgs = {
  data: UpdateJobApplicationStageInput;
};


export type MutationupdateJobPostingTemplateArgs = {
  data: UpdateJobPostingTemplateInput;
};


export type MutationupdateNoteArgs = {
  data: UpdateNoteInput;
  id: Scalars['String']['input'];
};


export type MutationupdateNotificationInterestsArgs = {
  data: UpdateNotificationInterestsInput;
};


export type MutationupdateOrgMemberArgs = {
  data: UpdateOrgMemberInput;
};


export type MutationupdateOrganizationArgs = {
  id: Scalars['String']['input'];
  updates: UpdateOrganizationInput;
};


export type MutationupdateOrganizationFeaturesArgs = {
  employerId: Scalars['String']['input'];
  toAdd: Array<EmployerFeatures>;
  toRemove: Array<EmployerFeatures>;
};


export type MutationupdatePoolArgs = {
  input: UpdatePoolInput;
};


export type MutationupdatePresentationArgs = {
  id: Scalars['String']['input'];
  updates: UpdatePresentationInput;
};


export type MutationupdatePresentedAvailabilityArgs = {
  data: UpdatePresentedAvailabilitiesInput;
};


export type MutationupdatePriceZoneArgs = {
  data: UpdatePriceZoneInput;
};


export type MutationupdateRankedCompanyArgs = {
  data: UpdateRankedCompanyInput;
  id: Scalars['String']['input'];
};


export type MutationupdateReferenceArgs = {
  data: UpdateReferenceInput;
};


export type MutationupdateReferenceAnswersArgs = {
  data: UpdateReferenceAnswersInput;
};


export type MutationupdateReferenceStatusArgs = {
  data: UpdateReferenceStatusInput;
};


export type MutationupdateRequirementFulfillmentForPresentationArgs = {
  presentationId: Scalars['String']['input'];
  update: UpdateRequirementFulfillmentInput;
};


export type MutationupdateResourceAvailabilityArgs = {
  data: Array<UpdateResourceAvailabilityInput>;
};


export type MutationupdateScheduleDraftArgs = {
  data: UpdateScheduleDraftInput;
};


export type MutationupdateScheduleResourceArgs = {
  data: UpdateScheduleResourceInput;
};


export type MutationupdateSchedulingPeriodArgs = {
  data: UpdateSchedulingPeriodInput;
};


export type MutationupdateSchedulingPeriodActivityArgs = {
  data: UpdateSchedulingPeriodActivityInput;
};


export type MutationupdateSchedulingPeriodConfigurationArgs = {
  data: UpdateSchedulingPeriodConfigurationInput;
};


export type MutationupdateSchedulingPeriodPromptsArgs = {
  data: UpdateSchedulingPeriodPromptsInput;
};


export type MutationupdateSchedulingPeriodResourceConfigurationsArgs = {
  data: UpdateManySchedulingPeriodResourceConfigurationInput;
};


export type MutationupdateShiftArgs = {
  data: UpdateShiftInput;
};


export type MutationupdateShiftDemandsArgs = {
  data: UpdateSchedulingPeriodShiftDemandsInput;
};


export type MutationupdateShiftsArgs = {
  data: Array<UpdateShiftInput>;
};


export type MutationupdateTenderArgs = {
  id: Scalars['String']['input'];
  input: UpdateTenderInput;
};


export type MutationupdateTenderPriceGroupArgs = {
  id: Scalars['String']['input'];
  input: UpdateTenderPriceGroupInput;
};


export type MutationupdateTenderPriceGroupCompensationModelArgs = {
  data: UpdateTenderPriceGroupCompensationModelInput;
};


export type MutationupdateTenderRequirementsArgs = {
  input: UpdateRequirementsInput;
  tenderId: Scalars['String']['input'];
};


export type MutationupdateTenderShiftsScheduleArgs = {
  data: UpdateTenderShiftsScheduleInput;
};


export type MutationupdateTenderSupplierDecisionArgs = {
  data: UpdateTenderSupplierDecisionInput;
};


export type MutationupdateTenderTemplateArgs = {
  id: Scalars['String']['input'];
  input: UpdateTenderTemplateInput;
};


export type MutationupdateTenderTemplateRequirementsArgs = {
  input: UpdateRequirementsInput;
  tenderTemplateId: Scalars['String']['input'];
};


export type MutationupdateTenderWaiverArgs = {
  data: UpdateTenderWaiverInput;
  id: Scalars['String']['input'];
};


export type MutationupdateTenderedAvailabilityArgs = {
  data: UpdateTenderedAvailabilitiesInput;
};


export type MutationupdateTendersConfigurationArgs = {
  added?: InputMaybe<UpdateTendersConfigurationRecipientsInput>;
  removed?: InputMaybe<UpdateTendersConfigurationRecipientsInput>;
  updates?: InputMaybe<UpdateTendersConfigurationInput>;
};


export type MutationupdateUnitArgs = {
  id: Scalars['String']['input'];
  input: UpdateUnitInput;
  organizationIdOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadSchedulerOutputArgs = {
  output: Scalars['String']['input'];
  scheduleDraftId: Scalars['String']['input'];
};


export type MutationviewPresentationArgs = {
  id: Scalars['String']['input'];
};


export type MutationviewVacancyArgs = {
  id: Scalars['String']['input'];
};


export type MutationwithdrawPresentationArgs = {
  id: Scalars['String']['input'];
};


export type MutationwithdrawPresentationAcceptanceArgs = {
  id: Scalars['String']['input'];
};


export type MutationwithdrawShiftApplicationArgs = {
  data: WithdrawShiftApplicationInput;
};


export type MutationwithdrawTenderWaiverRejectionArgs = {
  id: Scalars['String']['input'];
};

export type Note = {
  __typename?: 'Note';
  author?: Maybe<Identity>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  topicId: Scalars['String']['output'];
  topicType: TopicType;
  updatedAt: Scalars['Int']['output'];
  vacancy?: Maybe<Vacancy>;
};

export type NotesFilterInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  topicType?: InputMaybe<TopicType>;
};

export type NotificationInterests = {
  __typename?: 'NotificationInterests';
  countries: Array<Country>;
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  professions: Array<Profession>;
  regions: Array<WhichRegionAlternative>;
  specializations: Array<Specialization>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  description: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  /** @deprecated Not applicable, rely on description */
  name?: Maybe<Scalars['String']['output']>;
};

export type NullableBooleanComparator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type NullableDateComparator = {
  /** In unix time (seconds) */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** In unix time (seconds) */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  neq?: InputMaybe<Scalars['Int']['input']>;
  /** In unix time (seconds) */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NullableIdComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NullableShiftHoursComparator = {
  eq?: InputMaybe<ShiftHours>;
  in?: InputMaybe<Array<ShiftHours>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<ShiftHours>;
  nin?: InputMaybe<Array<ShiftHours>>;
};

export enum NullsOrder {
  FIRST = 'FIRST',
  LAST = 'LAST'
}

export type NumberComparator = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NurseOptions = {
  __typename?: 'NurseOptions';
  country: Country;
  region?: Maybe<Region>;
  specialization: NurseSpecialization;
};

export { NurseSpecialization };

export type Offer = {
  __typename?: 'Offer';
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  /** @deprecated Use vacancyIds instead */
  jobPostingIds: Array<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['Int']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status: OfferStatus;
  updatedAt: Scalars['Int']['output'];
  vacancyIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type OfferInput = {
  employerId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  vacancyIds: Array<Scalars['String']['input']>;
};

export type OfferOptions = {
  employerId: Scalars['String']['input'];
  status: OfferStatus;
};

export enum OfferStatus {
  ACCEPTED = 'ACCEPTED',
  ARCHIVED = 'ARCHIVED',
  MISSED = 'MISSED',
  PREPARED = 'PREPARED',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED',
  SENT = 'SENT',
  TIMED_OUT = 'TIMED_OUT'
}

export type OnCallDisturbance = {
  __typename?: 'OnCallDisturbance';
  comment: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  startDateTime: Scalars['Date']['output'];
};

export type OnCallDisturbanceInput = {
  comment: Scalars['String']['input'];
  endDateTime: Scalars['Date']['input'];
  startDateTime: Scalars['Date']['input'];
};

export type OnCallTime = {
  __typename?: 'OnCallTime';
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  type: OnCallType;
};

export type OnCallTimeInput = {
  endDateTime: Scalars['Date']['input'];
  startDateTime: Scalars['Date']['input'];
  type: OnCallType;
};

export enum OnCallType {
  NON_RESIDENT = 'NON_RESIDENT',
  RESIDENT = 'RESIDENT'
}

export enum OrderByDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OrgMembership = {
  __typename?: 'OrgMembership';
  customRoles?: Maybe<Array<Scalars['String']['output']>>;
  markets?: Maybe<Array<Market>>;
  organizationId: Scalars['String']['output'];
  organizationKeys?: Maybe<Array<Scalars['String']['output']>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  companyRating: CompanyRating;
  configuredJobPostingIntegrations: Array<JobPostingIntegration>;
  customRoles?: Maybe<Array<CustomRole>>;
  defaultLocale: Scalars['String']['output'];
  defaultPricing?: Maybe<Pricing>;
  displayName: Scalars['String']['output'];
  features?: Maybe<Array<EmployerFeatures>>;
  graphicProfile?: Maybe<GraphicProfile>;
  id: Scalars['String']['output'];
  interest?: Maybe<Interest>;
  jobPostingTemplates?: Maybe<Array<JobPostingTemplate>>;
  jobTypes: Array<JobType>;
  labeledFeatures?: Maybe<Array<RbacFeature>>;
  limit?: Maybe<Scalars['Int']['output']>;
  markets: Array<Market>;
  members?: Maybe<Array<Identity>>;
  organization: Organization;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  /** Markets the organization recruits in. E.g. should it show up on bemlo.se? */
  recruitsIn: Array<Market>;
  requiresPersonalIdentityNumber: Scalars['Boolean']['output'];
  reviews: Array<CompanyReview>;
  roles?: Maybe<Array<RbacRole>>;
  schedulingPeriodConfiguration?: Maybe<SchedulingPeriodConfiguration>;
  /** Max timeout in seconds for user inactivity. Log out user who is inactive for longer period of time */
  sessionMaxTimeout?: Maybe<Scalars['Int']['output']>;
  ssoEnabled: Scalars['Boolean']['output'];
  tendersConfiguration: TendersConfiguration;
  type: OrganizationType;
  units: Array<Unit>;
};


export type OrganizationcompanyRatingArgs = {
  markets: Array<Market>;
};


export type OrganizationreviewsArgs = {
  markets: Array<Market>;
};

export enum OrganizationType {
  HEALTH_PROVIDER = 'HEALTH_PROVIDER',
  STAFFING_COMPANY = 'STAFFING_COMPANY'
}

export type OrganizationsFilter = {
  hasDirectAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasJobPostings?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OverlappingShiftsViolation = ConflictingShiftsViolation & {
  __typename?: 'OverlappingShiftsViolation';
  shiftId: Scalars['String']['output'];
  type: SchedulingViolationsType;
  violatingShift?: Maybe<CandidateInformationShift>;
  violatingShiftId: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  __typename?: 'Period';
  endsAt: Scalars['Date']['output'];
  startsAt: Scalars['Date']['output'];
};

export enum Perk {
  COLLECTIVE_AGREEMENT = 'COLLECTIVE_AGREEMENT',
  HOUSING_ALLOWANCE = 'HOUSING_ALLOWANCE',
  OTHER = 'OTHER',
  TRAVEL_EXPENSES = 'TRAVEL_EXPENSES',
  WELLNESS_ALLOWANCE = 'WELLNESS_ALLOWANCE'
}

export enum PersonalIdentityNumberSource {
  ADMIN_MANUAL_INPUT = 'ADMIN_MANUAL_INPUT',
  BANK_ID = 'BANK_ID'
}

export type PersonalIdentityNumberSourceComparator = {
  eq?: InputMaybe<PersonalIdentityNumberSource>;
  in?: InputMaybe<Array<PersonalIdentityNumberSource>>;
  neq?: InputMaybe<PersonalIdentityNumberSource>;
  nin?: InputMaybe<Array<PersonalIdentityNumberSource>>;
};

export type Pool = {
  __typename?: 'Pool';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unitIds: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PresentableScheduleRow = {
  __typename?: 'PresentableScheduleRow';
  activity: ShiftActivity;
  breakTime: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  onCallTime?: Maybe<OnCallTime>;
  presentationId: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  tags: Array<Tag>;
  tenderShiftIds: Array<Scalars['String']['output']>;
};

export type Presentation = {
  __typename?: 'Presentation';
  acceptedAt?: Maybe<Scalars['Int']['output']>;
  acceptedAvailabilities: Array<AcceptedAvailability>;
  acceptedFillRate?: Maybe<Scalars['Int']['output']>;
  allShiftsForCandidate: Array<ShiftBooking>;
  attachments: Array<Attachment>;
  attributionCriterionScoring: Array<AttributionCriterionScoring>;
  basePay: Scalars['Float']['output'];
  candidate: DisplayProfile;
  candidateBooking?: Maybe<CandidateBooking>;
  candidateDescription: Scalars['String']['output'];
  candidateId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Identity>;
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  currency: Currency;
  email?: Maybe<Scalars['String']['output']>;
  employerId: Scalars['String']['output'];
  fulfilledRequirements: Array<Scalars['String']['output']>;
  graduatedAt?: Maybe<Scalars['Float']['output']>;
  handledBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isReadyForReview: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  markedAsReadyForReviewAt?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  openedForRevisionAt?: Maybe<Scalars['Date']['output']>;
  personalIdentityNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  presentableSchedule?: Maybe<Array<PresentableScheduleRow>>;
  presentationShiftFor?: Maybe<PresentationShift>;
  presentedAvailabilities: Array<PresentedAvailability>;
  presentedScope?: Maybe<Scalars['Int']['output']>;
  priceGroup?: Maybe<AvailableTenderPriceGroup>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  profession: Profession;
  rejectedAt?: Maybe<Scalars['Int']['output']>;
  remindedAt?: Maybe<Scalars['Int']['output']>;
  replacementForCandidateBooking?: Maybe<CandidateBooking>;
  replacementForCandidateBookingId?: Maybe<Scalars['String']['output']>;
  requirementFulfillments: Array<RequirementFulfillment>;
  reviewers?: Maybe<Array<PresentationReviewer>>;
  reviews?: Maybe<Array<PresentationReview>>;
  revisedAt?: Maybe<Scalars['Date']['output']>;
  revokedAt?: Maybe<Scalars['Date']['output']>;
  schedule?: Maybe<Array<PresentationScheduleShift>>;
  score?: Maybe<Scalars['Float']['output']>;
  scoredAt?: Maybe<Scalars['Date']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  shiftBookingReplacingIds: Array<Scalars['String']['output']>;
  shifts: Array<PresentationShift>;
  specializations: Array<Specialization>;
  status: PresentationStatus;
  supplier: Organization;
  tender: Tender;
  tenderId: Scalars['String']['output'];
  textBasedScheduleFulfillmentDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
  vacancy: Vacancy;
  vacancyId: Scalars['String']['output'];
  viewedBy: Array<Scalars['String']['output']>;
};


export type PresentationpresentationShiftForArgs = {
  shiftId: Scalars['String']['input'];
};

export type PresentationEdge = {
  __typename?: 'PresentationEdge';
  cursor: Scalars['String']['output'];
  node: Presentation;
};

export type PresentationFilter = {
  AND?: InputMaybe<Array<PresentationFilter>>;
  NOT?: InputMaybe<Array<PresentationFilter>>;
  OR?: InputMaybe<Array<PresentationFilter>>;
  acceptedAt?: InputMaybe<DateComparator>;
  basePay?: InputMaybe<NumberComparator>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateBookingId?: InputMaybe<IdComparator>;
  candidateDescription?: InputMaybe<StringComparator>;
  candidateId?: InputMaybe<IdComparator>;
  comment?: InputMaybe<StringComparator>;
  createdAt?: InputMaybe<DateComparator>;
  createdBy?: InputMaybe<IdComparator>;
  employerId?: InputMaybe<IdComparator>;
  graduatedAt?: InputMaybe<DateComparator>;
  handledBy?: InputMaybe<NullableIdComparator>;
  id?: InputMaybe<IdComparator>;
  name?: InputMaybe<StringComparator>;
  personalIdentityNumber?: InputMaybe<IdComparator>;
  priceGroupId?: InputMaybe<NullableIdComparator>;
  profession?: InputMaybe<ProfessionComparator>;
  rejectedAt?: InputMaybe<DateComparator>;
  remindedAt?: InputMaybe<DateComparator>;
  replacementForCandidateBookingId?: InputMaybe<NullableIdComparator>;
  sentAt?: InputMaybe<NullableDateComparator>;
  specializations?: InputMaybe<SpecializationArrayComparator>;
  status?: InputMaybe<PresentationStatusComparator>;
  tender?: InputMaybe<TenderFilter>;
  tenderId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
  vacancy?: InputMaybe<VacancyFilter>;
  vacancyId?: InputMaybe<IdComparator>;
  viewedBy?: InputMaybe<IdArrayComparator>;
};

export type PresentationReview = {
  __typename?: 'PresentationReview';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  presentation: Presentation;
  presentationId: Scalars['String']['output'];
  reviewer?: Maybe<Identity>;
  reviewerId: Scalars['String']['output'];
  verdict?: Maybe<PresentationReviewVerdict>;
};

export enum PresentationReviewVerdict {
  ACCEPTED = 'ACCEPTED',
  COMMENT = 'COMMENT',
  REJECTED = 'REJECTED'
}

export type PresentationReviewer = {
  __typename?: 'PresentationReviewer';
  id: Scalars['String']['output'];
  reviewer?: Maybe<Identity>;
  reviewerId: Scalars['String']['output'];
  reviews: Array<PresentationReview>;
  verdict?: Maybe<PresentationReviewVerdict>;
};

export type PresentationScheduleShift = {
  __typename?: 'PresentationScheduleShift';
  activity: ShiftActivity;
  breakTime: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  onCallTime?: Maybe<OnCallTime>;
  presentationShiftId?: Maybe<Scalars['String']['output']>;
  shiftId?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  status: PresentationScheduleShiftStatus;
  tags: Array<Tag>;
  tenderShift?: Maybe<TenderShift>;
  tenderShiftId?: Maybe<Scalars['String']['output']>;
};

export enum PresentationScheduleShiftStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  OCCUPIED = 'OCCUPIED',
  PRESENTED = 'PRESENTED',
  REJECTED = 'REJECTED',
  REPLACING = 'REPLACING'
}

export type PresentationShift = {
  __typename?: 'PresentationShift';
  /** The allowed break in minutes */
  breakTime: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** A date string, e.g. "2022-10-06" */
  date: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  presentation: Presentation;
  presentationId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  status: PresentationShiftStatus;
  tenderId: Scalars['String']['output'];
  tenderShift: TenderShift;
  tenderShiftId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum PresentationShiftStatus {
  ACCEPTED = 'ACCEPTED',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  NOT_PRESENTED = 'NOT_PRESENTED',
  PRESENTED = 'PRESENTED',
  REJECTED = 'REJECTED'
}

export enum PresentationStatus {
  ACCEPTED = 'ACCEPTED',
  ARCHIVED = 'ARCHIVED',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  OPEN_FOR_REVISION = 'OPEN_FOR_REVISION',
  REJECTED = 'REJECTED',
  REVOKED = 'REVOKED',
  SENT = 'SENT',
  WITHDRAWN = 'WITHDRAWN'
}

export type PresentationStatusComparator = {
  eq?: InputMaybe<PresentationStatus>;
  in?: InputMaybe<Array<PresentationStatus>>;
  neq?: InputMaybe<PresentationStatus>;
  nin?: InputMaybe<Array<PresentationStatus>>;
};

export type PresentationsCursorSearchResult = {
  __typename?: 'PresentationsCursorSearchResult';
  edges: Array<PresentationEdge>;
  pageInfo: PageInfo;
};

export type PresentedAvailability = {
  __typename?: 'PresentedAvailability';
  acceptedAvailability?: Maybe<AcceptedAvailability>;
  days: Array<PresentedDay>;
  id: Scalars['String']['output'];
  scope: AvailabilityScope;
};

export type PresentedDay = {
  __typename?: 'PresentedDay';
  acceptedDay?: Maybe<AcceptedDay>;
  id: Scalars['String']['output'];
};

export type PriceZone = {
  __typename?: 'PriceZone';
  articlePrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  municipalities: Array<Municipality>;
  organizationId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Pricing = {
  __typename?: 'Pricing';
  assistantNurseFactor: Scalars['Float']['output'];
  highTier: Scalars['Int']['output'];
  lessThanOneMonth: Scalars['Int']['output'];
  lessThanSixMonths: Scalars['Int']['output'];
  lessThanThreeMonths: Scalars['Int']['output'];
  longer: Scalars['Int']['output'];
  lowTier: Scalars['Int']['output'];
  mediumTier: Scalars['Int']['output'];
  parttimeFactor: Scalars['Float']['output'];
};

export type PricingInput = {
  assistantNurseFactor: Scalars['Float']['input'];
  highTier: Scalars['Int']['input'];
  lessThanOneMonth: Scalars['Int']['input'];
  lessThanSixMonths: Scalars['Int']['input'];
  lessThanThreeMonths: Scalars['Int']['input'];
  longer: Scalars['Int']['input'];
  lowTier: Scalars['Int']['input'];
  mediumTier: Scalars['Int']['input'];
  parttimeFactor: Scalars['Float']['input'];
};

export { Profession };

export type ProfessionArrayComparator = {
  all?: InputMaybe<Array<Profession>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<Profession>>;
  has?: InputMaybe<Profession>;
  some?: InputMaybe<Array<Profession>>;
};

export type ProfessionComparator = {
  eq?: InputMaybe<Profession>;
  in?: InputMaybe<Array<Profession>>;
  neq?: InputMaybe<Profession>;
  nin?: InputMaybe<Array<Profession>>;
};

export type Profile = {
  __typename?: 'Profile';
  authorization?: Maybe<Scalars['String']['output']>;
  candidate: Candidate;
  connections: Array<AbstractConnection>;
  createdAt: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  employersInContactWith: Array<Scalars['String']['output']>;
  employersToAvoidContactWith: Array<Scalars['String']['output']>;
  employersWithContactRequests: Array<Scalars['String']['output']>;
  employersWithRefundedConnections: Array<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isInterestedInContact: Scalars['Boolean']['output'];
  isInterestedInMatchingVacancies?: Maybe<Scalars['Boolean']['output']>;
  isRegistered: Scalars['Boolean']['output'];
  jobApplications: Array<JobApplication>;
  market: Market;
  noteFromBemlo?: Maybe<Scalars['String']['output']>;
  personalIdentityNumber?: Maybe<Scalars['String']['output']>;
  personalIdentityNumberUpdatedAt?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  profileInformation: ProfileInformation;
  referenceCount: Scalars['Int']['output'];
  references: Array<Reference>;
  summary?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedInterestedInContactAt: Scalars['Int']['output'];
  utmData: UtmData;
  vacanciesAppliedTo: Array<Scalars['String']['output']>;
  vacancyApplications: Array<VacancyApplication>;
};

export enum ProfileConnectionStatus {
  CONNECTED = 'CONNECTED',
  CONNECTION_REQUESTED = 'CONNECTION_REQUESTED',
  PRESENTED = 'PRESENTED',
  UNCONNECTED = 'UNCONNECTED'
}

export type ProfileInformation = {
  __typename?: 'ProfileInformation';
  availabilityFreeText?: Maybe<Scalars['String']['output']>;
  currentEmploymentStatus?: Maybe<CurrentEmploymentStatus>;
  driversLicenses?: Maybe<Array<DriversLicense>>;
  homeMunicipality?: Maybe<Scalars['String']['output']>;
  homeMunicipalityFreeText?: Maybe<Scalars['String']['output']>;
  howLongTemporaryDetailed?: Maybe<Scalars['String']['output']>;
  howMuchExperience?: Maybe<HowMuchExperienceAlternative>;
  howMuchExperienceFreeText?: Maybe<Scalars['String']['output']>;
  howMuchWork?: Maybe<HowMuchWorkAlternative>;
  howMuchWorkParttimeDetailed?: Maybe<Scalars['String']['output']>;
  norwegianLicenseStatus?: Maybe<LicenseStatus>;
  shortConsultantBiography?: Maybe<Scalars['String']['output']>;
  swedishLicenseStatus?: Maybe<LicenseStatus>;
  weekInterests?: Maybe<Array<Scalars['String']['output']>>;
  whenToStartJobExactDate?: Maybe<Scalars['Int']['output']>;
  whichCountries?: Maybe<Array<Country>>;
  whichDepartmentToWorkIn?: Maybe<Array<WhichDepartmentToWorkInAlternative>>;
  whichDepartmentToWorkInFreeText?: Maybe<Scalars['String']['output']>;
  whichDialysisMachinesFreeText?: Maybe<Scalars['String']['output']>;
  whichJobTypes?: Maybe<Array<JobType>>;
  whichJournalSystems?: Maybe<Array<JournalSystem>>;
  whichJournalSystemsFreeText?: Maybe<Scalars['String']['output']>;
  whichProfession?: Maybe<Profession>;
  whichRegionsAffectedByKarens?: Maybe<Array<WhichRegionAlternative>>;
  whichRegionsAffectedByKarensFreeText?: Maybe<Scalars['String']['output']>;
  whichRegionsToWorkIn?: Maybe<Array<WhichRegionAlternative>>;
  whichRegionsToWorkInFreeText?: Maybe<Scalars['String']['output']>;
  whichSpecialization?: Maybe<Array<Specialization>>;
  whichSpecializationFreeText?: Maybe<Scalars['String']['output']>;
  whichWorkForm?: Maybe<WorkForm>;
  whichXRayMachinesFreeText?: Maybe<Scalars['String']['output']>;
};

export type ProfileInformationInput = {
  availabilityFreeText?: InputMaybe<Scalars['String']['input']>;
  currentEmploymentStatus?: InputMaybe<CurrentEmploymentStatus>;
  driversLicenses?: InputMaybe<Array<DriversLicense>>;
  homeMunicipality?: InputMaybe<Scalars['String']['input']>;
  homeMunicipalityFreeText?: InputMaybe<Scalars['String']['input']>;
  howLongTemporaryDetailed?: InputMaybe<Scalars['String']['input']>;
  howMuchExperience?: InputMaybe<HowMuchExperienceAlternative>;
  howMuchExperienceFreeText?: InputMaybe<Scalars['String']['input']>;
  howMuchWork?: InputMaybe<HowMuchWorkAlternative>;
  howMuchWorkParttimeDetailed?: InputMaybe<Scalars['String']['input']>;
  norwegianLicenseStatus?: InputMaybe<LicenseStatus>;
  shortConsultantBiography?: InputMaybe<Scalars['String']['input']>;
  swedishLicenseStatus?: InputMaybe<LicenseStatus>;
  weekInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  whenToStartJobExactDate?: InputMaybe<Scalars['Int']['input']>;
  whichCountries?: InputMaybe<Array<Country>>;
  whichDepartmentToWorkIn?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  whichDepartmentToWorkInFreeText?: InputMaybe<Scalars['String']['input']>;
  whichDialysisMachinesFreeText?: InputMaybe<Scalars['String']['input']>;
  whichJobTypes?: InputMaybe<Array<JobType>>;
  whichJournalSystems?: InputMaybe<Array<JournalSystem>>;
  whichJournalSystemsFreeText?: InputMaybe<Scalars['String']['input']>;
  whichProfession?: InputMaybe<Profession>;
  whichRegionsAffectedByKarens?: InputMaybe<Array<WhichRegionAlternative>>;
  whichRegionsAffectedByKarensFreeText?: InputMaybe<Scalars['String']['input']>;
  whichRegionsToWorkIn?: InputMaybe<Array<WhichRegionAlternative>>;
  whichRegionsToWorkInFreeText?: InputMaybe<Scalars['String']['input']>;
  whichSpecialization?: InputMaybe<Array<Specialization>>;
  whichSpecializationFreeText?: InputMaybe<Scalars['String']['input']>;
  whichWorkForm?: InputMaybe<WorkForm>;
  whichXRayMachinesFreeText?: InputMaybe<Scalars['String']['input']>;
};

export enum ProfileSource {
  COLD = 'COLD',
  CONNECTED = 'CONNECTED',
  DATABASE = 'DATABASE',
  MANAGED = 'MANAGED',
  TENDER = 'TENDER'
}

export type ProfilesFilter = {
  /** Ignored for users that only have access to assigned candidates */
  assignedTo?: InputMaybe<Array<Scalars['String']['input']>>;
  contactStatus?: InputMaybe<Array<ConnectionContactStatus>>;
  countries?: InputMaybe<Array<Country>>;
  departments?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  homeRegions?: InputMaybe<Array<WhichRegionAlternative>>;
  isConnected?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInContact?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInMatchingVacancies?: InputMaybe<Scalars['Boolean']['input']>;
  jobTypes?: InputMaybe<Array<JobType>>;
  location?: InputMaybe<AlgoliaLocationInput>;
  norwegianLicenseStatus?: InputMaybe<Array<LicenseStatus>>;
  professions?: InputMaybe<Array<Profession>>;
  regions?: InputMaybe<Array<WhichRegionAlternative>>;
  specializations?: InputMaybe<Array<Specialization>>;
};

export type ProfilesPagedResult = {
  __typename?: 'ProfilesPagedResult';
  hits: Array<Profile>;
  hitsPerPage: Scalars['Float']['output'];
  nbHits: Scalars['Float']['output'];
  nbPages: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
};

export type PublishJobPostingsInput = {
  integrations: Array<JobPostingIntegration>;
  vacancyIds: Array<Scalars['String']['input']>;
};

export type PublishShiftInput = {
  poolIds: Array<Scalars['String']['input']>;
  shiftId: Scalars['String']['input'];
};

export type PublishTenderInput = {
  id: Scalars['String']['input'];
  /** Price groups to send tender to */
  priceGroups: Array<PublishToTenderPriceGroupInput>;
  pricing: TenderPricing;
  publishOnBemlo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Supplier ids to send tender to from the supplier database */
  supplierIds: Array<Scalars['String']['input']>;
};

export type PublishToTenderPriceGroupInput = {
  priceGroupId: Scalars['String']['input'];
  specializations: Array<Specialization>;
  /** Selects a subset of suppliers in price group */
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Query = {
  __typename?: 'Query';
  allApplicants: DisplayProfilesPagedResult;
  allBillingInformation: Array<BillingInformation>;
  allBroadcastMessages: Array<BroadcastMessage>;
  allCandidateBookings: CandidateBookingsCursorSearchResult;
  allCandidates: CandidateCursorSearchResult;
  allCompensationModels: Array<CompensationModel>;
  allConversations: ConversationsCursorSearchResult;
  allDisplayCandidates: DisplayProfileCursorSearchResult;
  allNotes: Array<Note>;
  allPools: Array<Pool>;
  allPresentations: PresentationsCursorSearchResult;
  allProfiles: ProfilesPagedResult;
  allRecruitingOrganizations: Array<Organization>;
  allResourceAvailabilities: Array<ResourceAvailability>;
  allScheduleResources: Array<ScheduleResource>;
  allScheduleSlots: Array<ScheduleSlot>;
  allSchedulingPeriods: Array<SchedulingPeriod>;
  allShiftApplications: Array<ShiftApplication>;
  allShiftBookings: Array<ShiftBooking>;
  allShiftSuggestions: Array<ShiftSuggestion>;
  allShifts: Array<Shift>;
  allSupplierDeviations: SupplierDeviationsCursorSearchResult;
  allTags: Array<Tag>;
  allTenderInvoices: TenderInvoicesCursorSearchResult;
  allTenderPriceGroups: Array<TenderPriceGroup>;
  allTenderSuppliers: Array<Organization>;
  allTenderWaivers: TenderWaiversCursorSearchResult;
  allTenders: TendersCursorSearchResult;
  allTimesheets: Array<Timesheet>;
  allUnits: UnitCursorSearchResult;
  allVacancies: VacanciesCursorSearchResult;
  allVacancyApplications: VacancyApplicationsCursorSearchResult;
  broadcastMessage: BroadcastMessage;
  candidateBooking: CandidateBooking;
  candidateBookingPdf: Scalars['String']['output'];
  comments: Array<Comment>;
  /** @deprecated Use rankedCompany instead. */
  company: RankedCompany;
  companyReviews: Array<CompanyReview>;
  connectionsByEmployer: Array<AbstractConnection>;
  contactRequests: Array<ContactRequest>;
  conversation: Conversation;
  customRole: CustomRole;
  delegation: Delegation;
  departmentAlternatives: Array<DepartmentAlternative>;
  displayJobPosting: DisplayJobPosting;
  displayJobPostingDepartments: Array<DepartmentAlternative>;
  /** Returns Swedish regions */
  displayJobPostingRegions: Array<RegionAlternative>;
  displayJobPostingSpecializations: Array<SpecializationAlternative>;
  displayJobPostings: Array<DisplayJobPosting>;
  displayProfile: DisplayProfile;
  employerApplication: EmployerApplication;
  events: Array<Event>;
  fetchReportedSalaries: Array<Salary>;
  findAggregatedSalariesGroup: AggregatedSalaryGroup;
  findBankIdTransaction: BankIdTransaction;
  getAttachmentsForPresentation: Array<Attachment>;
  getFlowStatistics: FlowStatistics;
  getRequirementFulfillmentForPresentation: Array<RequirementFulfillment>;
  getStatistics: Statistics;
  isAdmin: Scalars['Boolean']['output'];
  jobApplication: JobApplication;
  jobApplications: Array<JobApplication>;
  jobPostingOptions: JobPostingOptions;
  jobPostingsById: Array<JobPosting>;
  lookupHpr: HprPerson;
  me: Identity;
  municipalityAlternatives: Array<MunicipalityAlternative>;
  myBroadcastMessages: Array<BroadcastMessage>;
  myPriceZones: Array<PriceZone>;
  myReferences: Array<Reference>;
  /** @deprecated Use allShiftBookings instead */
  myShiftBookings: Array<ShiftBooking>;
  myTags: Array<Tag>;
  myTenderOrderers: Array<Organization>;
  myTenderSuppliers: Array<Organization>;
  myTenderTemplates: Array<TenderTemplate>;
  myUnits: Array<Unit>;
  notes: Array<Note>;
  orgMember: Identity;
  organizations: Array<Organization>;
  populatedTemplateString: Scalars['String']['output'];
  populatedTemplateStrings: Array<Scalars['String']['output']>;
  presentation: Presentation;
  priceZone: PriceZone;
  profile: Profile;
  rankedCompany: RankedCompany;
  receiptsByEmployer: Array<Receipt>;
  reference: Reference;
  /** Returns Swedish regions */
  regionAlternatives: Array<RegionAlternative>;
  salariesMetadata: AggregatedSalariesMetadata;
  salaryStatisics: SalaryStatisticsGroups;
  scheduleSlot: ScheduleSlot;
  schedulerInput: Scalars['String']['output'];
  schedulingModelVersions: Array<Scalars['String']['output']>;
  schedulingPeriod: SchedulingPeriod;
  searchHpr: HprPerson;
  shift: Shift;
  shifts: Array<Shift>;
  specializationAlternatives: Array<SpecializationAlternative>;
  tender: Tender;
  tenderPriceGroup: TenderPriceGroup;
  tenderShift?: Maybe<TenderShift>;
  tenderWaiver: TenderWaiver;
  unhandledReceipts: Array<Receipt>;
  unhandledReceiptsByEmployer: Array<Receipt>;
  unit: Unit;
  unreadConversationsCount: Scalars['Float']['output'];
  unreadNotificationsCount: Scalars['Int']['output'];
  vacanciesByIds: Array<Vacancy>;
  vacancy: Vacancy;
};


export type QueryallApplicantsArgs = {
  hitsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<ApplicationSource>;
};


export type QueryallCandidateBookingsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CandidateBookingFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallCandidatesArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CandidateFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallConversationsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ConversationFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallDisplayCandidatesArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CandidateFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallNotesArgs = {
  filter: NotesFilterInput;
};


export type QueryallPresentationsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PresentationFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallProfilesArgs = {
  filter: ProfilesFilter;
  hitsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryallRecruitingOrganizationsArgs = {
  recruitsIn: Array<Market>;
};


export type QueryallResourceAvailabilitiesArgs = {
  filter?: InputMaybe<ResourceAvailabilityFilter>;
};


export type QueryallScheduleResourcesArgs = {
  data: ScheduleResourceFilter;
};


export type QueryallScheduleSlotsArgs = {
  data?: InputMaybe<ScheduleSlotFilter>;
};


export type QueryallShiftApplicationsArgs = {
  data: ShiftApplicationFilter;
};


export type QueryallShiftBookingsArgs = {
  filter: ShiftBookingFilter;
};


export type QueryallShiftSuggestionsArgs = {
  filter?: InputMaybe<ShiftSuggestionFilter>;
};


export type QueryallShiftsArgs = {
  data: ShiftFilter;
};


export type QueryallSupplierDeviationsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierDeviationFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallTenderInvoicesArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenderInvoiceFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallTenderSuppliersArgs = {
  filter?: InputMaybe<AllTenderSuppliersFilterArgs>;
};


export type QueryallTenderWaiversArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenderWaiverFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallTendersArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenderFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallTimesheetsArgs = {
  data: TimesheetsFilter;
};


export type QueryallUnitsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UnitFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallVacanciesArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<VacancyFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QueryallVacancyApplicationsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<VacancyApplicationFilter>;
  orderBy: Scalars['String']['input'];
  orderDir: OrderByDirection;
  orderNulls?: InputMaybe<NullsOrder>;
  take: Scalars['Int']['input'];
};


export type QuerybroadcastMessageArgs = {
  id: Scalars['String']['input'];
};


export type QuerycandidateBookingArgs = {
  id: Scalars['String']['input'];
};


export type QuerycandidateBookingPdfArgs = {
  id: Scalars['String']['input'];
};


export type QuerycommentsArgs = {
  blogPostSlug: Scalars['String']['input'];
};


export type QuerycompanyArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
};


export type QuerycompanyReviewsArgs = {
  employerId: Scalars['String']['input'];
  markets: Array<Market>;
};


export type QueryconnectionsByEmployerArgs = {
  employerId: Scalars['String']['input'];
  status: ConnectionStatus;
};


export type QuerycontactRequestsArgs = {
  filter: FindContactRequestsFilter;
};


export type QueryconversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type QuerycustomRoleArgs = {
  id: Scalars['String']['input'];
};


export type QuerydelegationArgs = {
  id: Scalars['String']['input'];
};


export type QuerydepartmentAlternativesArgs = {
  includeOpenForAll?: InputMaybe<Scalars['Boolean']['input']>;
  overCategories?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
};


export type QuerydisplayJobPostingArgs = {
  apiKey: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QuerydisplayJobPostingDepartmentsArgs = {
  apiKey: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
};


export type QuerydisplayJobPostingRegionsArgs = {
  apiKey: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
};


export type QuerydisplayJobPostingSpecializationsArgs = {
  apiKey: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  profession: Profession;
};


export type QuerydisplayJobPostingsArgs = {
  apiKey: Scalars['String']['input'];
  department?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  employerId: Scalars['String']['input'];
  profession: Profession;
  region?: InputMaybe<WhichRegionAlternative>;
  specialization?: InputMaybe<Specialization>;
};


export type QuerydisplayProfileArgs = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['String']['input'];
};


export type QueryemployerApplicationArgs = {
  employerApplicationId: Scalars['String']['input'];
};


export type QueryeventsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventFilter>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryfindAggregatedSalariesGroupArgs = {
  findAggregatedSalaryGroupData: FindSalaryGroupInput;
};


export type QueryfindBankIdTransactionArgs = {
  orderRef: Scalars['String']['input'];
};


export type QuerygetAttachmentsForPresentationArgs = {
  presentationId: Scalars['String']['input'];
};


export type QuerygetFlowStatisticsArgs = {
  data: GetFlowStatisticsInput;
};


export type QuerygetRequirementFulfillmentForPresentationArgs = {
  presentationId: Scalars['String']['input'];
};


export type QuerygetStatisticsArgs = {
  data: GetStatisticsInput;
};


export type QueryjobApplicationArgs = {
  jobApplicationId: Scalars['String']['input'];
};


export type QueryjobApplicationsArgs = {
  jobApplicationsFilter: JobApplicationsFilter;
};


export type QueryjobPostingsByIdArgs = {
  data: JobPostingsByIdInput;
};


export type QuerylookupHprArgs = {
  number: Scalars['String']['input'];
};


export type QuerymunicipalityAlternativesArgs = {
  includeDefaultsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  regions?: InputMaybe<Array<WhichRegionAlternative>>;
};


export type QuerymyShiftBookingsArgs = {
  data: ShiftBookingFilter;
};


export type QuerynotesArgs = {
  topicId: Scalars['String']['input'];
};


export type QueryorgMemberArgs = {
  id: Scalars['String']['input'];
};


export type QueryorganizationsArgs = {
  filter: OrganizationsFilter;
};


export type QuerypopulatedTemplateStringArgs = {
  data: BatscriptInterpreterInput;
};


export type QuerypopulatedTemplateStringsArgs = {
  data: Array<BatscriptInterpreterInput>;
};


export type QuerypresentationArgs = {
  id: Scalars['String']['input'];
};


export type QuerypriceZoneArgs = {
  id: Scalars['String']['input'];
};


export type QueryprofileArgs = {
  id: Scalars['String']['input'];
};


export type QueryrankedCompanyArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryreceiptsByEmployerArgs = {
  data: FindReceiptsByEmployerInput;
};


export type QueryreferenceArgs = {
  id: Scalars['String']['input'];
};


export type QueryregionAlternativesArgs = {
  includeAllOfTheAbove?: InputMaybe<Scalars['Boolean']['input']>;
  includeNoneOfTheAbove?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerysalaryStatisicsArgs = {
  fetchSalaryStatistics: FetchSalaryStatisticsInput;
};


export type QueryscheduleSlotArgs = {
  id: Scalars['String']['input'];
};


export type QueryschedulerInputArgs = {
  scheduleDraftId: Scalars['String']['input'];
};


export type QueryschedulingModelVersionsArgs = {
  data: SchedulingModelVersionsInput;
};


export type QueryschedulingPeriodArgs = {
  id: Scalars['String']['input'];
};


export type QuerysearchHprArgs = {
  birthDate: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type QueryshiftArgs = {
  id: Scalars['String']['input'];
};


export type QueryshiftsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryspecializationAlternativesArgs = {
  includeGenerics?: InputMaybe<Scalars['Boolean']['input']>;
  includeNone?: InputMaybe<Scalars['Boolean']['input']>;
  professions?: InputMaybe<Array<Profession>>;
};


export type QuerytenderArgs = {
  id: Scalars['String']['input'];
};


export type QuerytenderPriceGroupArgs = {
  id: Scalars['String']['input'];
};


export type QuerytenderShiftArgs = {
  id: Scalars['String']['input'];
};


export type QuerytenderWaiverArgs = {
  id: Scalars['String']['input'];
};


export type QueryunhandledReceiptsArgs = {
  data: FindUnhandledReceiptsInput;
};


export type QueryunhandledReceiptsByEmployerArgs = {
  data: FindUnhandledReceiptsByEmployerInput;
};


export type QueryunitArgs = {
  id: Scalars['String']['input'];
};


export type QueryvacanciesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryvacancyArgs = {
  id: Scalars['String']['input'];
};

export type RankedCompany = {
  __typename?: 'RankedCompany';
  alternativeMarketIds?: Maybe<Array<Scalars['String']['output']>>;
  averageRating: Scalars['Float']['output'];
  bayesScore: Scalars['Float']['output'];
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  market: Market;
  reviewCount: Scalars['Int']['output'];
  reviews: Array<CompanyReview>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type RbacFeature = {
  __typename?: 'RbacFeature';
  description?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RbacRole = {
  __typename?: 'RbacRole';
  description: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  inheritedBy?: Maybe<Array<Scalars['String']['output']>>;
};

export type Receipt = {
  __typename?: 'Receipt';
  articleInfo: Scalars['String']['output'];
  articleName: Scalars['String']['output'];
  billingStatus: BillingStatus;
  connection?: Maybe<AbstractConnection>;
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

export type Reference = {
  __typename?: 'Reference';
  answers?: Maybe<ReferenceAnswers>;
  attachments: Array<Attachment>;
  completedAt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  displayProfile: DisplayProfile;
  email?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  information: Array<ReferenceInformation>;
  isSigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referentId: Scalars['String']['output'];
  referentName?: Maybe<Scalars['String']['output']>;
  referentType: ReferentType;
  rejectedAt?: Maybe<Scalars['Int']['output']>;
  remindedAt?: Maybe<Scalars['Int']['output']>;
  type: ReferenceType;
  updatedAt: Scalars['Int']['output'];
};

export type ReferenceAnswers = {
  __typename?: 'ReferenceAnswers';
  absenceDescription?: Maybe<Scalars['String']['output']>;
  clientTreatmentDescription?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  competenceDescription?: Maybe<Scalars['String']['output']>;
  documentationDescription?: Maybe<Scalars['String']['output']>;
  personalityDescription?: Maybe<Scalars['String']['output']>;
  socialSkillsDescription?: Maybe<Scalars['String']['output']>;
  workPlaceRelationshipToApplicant?: Maybe<WorkPlaceRelationshipToApplicant>;
  wouldRecommend?: Maybe<WouldRecommend>;
};

export type ReferenceAnswersInput = {
  absenceDescription?: InputMaybe<Scalars['String']['input']>;
  clientTreatmentDescription?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  competenceDescription?: InputMaybe<Scalars['String']['input']>;
  documentationDescription?: InputMaybe<Scalars['String']['input']>;
  personalityDescription?: InputMaybe<Scalars['String']['input']>;
  socialSkillsDescription?: InputMaybe<Scalars['String']['input']>;
  workPlaceRelationshipToApplicant?: InputMaybe<WorkPlaceRelationshipToApplicant>;
  wouldRecommend?: InputMaybe<WouldRecommend>;
};

export type ReferenceInformation = {
  __typename?: 'ReferenceInformation';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ReferenceType {
  INVITED = 'INVITED',
  MANAGED = 'MANAGED'
}

export enum ReferentType {
  CANDIDATE = 'CANDIDATE',
  PROFILE = 'PROFILE'
}

export enum Region {
  ALL = 'ALL',
  BLEKINGE = 'BLEKINGE',
  DALARNA = 'DALARNA',
  GAVLEBORG = 'GAVLEBORG',
  GOTLAND = 'GOTLAND',
  HALLAND = 'HALLAND',
  JAMTLAND_HARJEDALEN = 'JAMTLAND_HARJEDALEN',
  JONKOPING = 'JONKOPING',
  KALMAR = 'KALMAR',
  KRONOBERG = 'KRONOBERG',
  NONE = 'NONE',
  NORRBOTTEN = 'NORRBOTTEN',
  OREBRO = 'OREBRO',
  OSTERGOTLAND = 'OSTERGOTLAND',
  SKANE = 'SKANE',
  SORMLAND = 'SORMLAND',
  STOCKHOLM = 'STOCKHOLM',
  UPPSALA = 'UPPSALA',
  VARMLAND = 'VARMLAND',
  VASTERBOTTEN = 'VASTERBOTTEN',
  VASTERNORRLAND = 'VASTERNORRLAND',
  VASTMANLAND = 'VASTMANLAND',
  VASTRAGOTALAND = 'VASTRAGOTALAND'
}

export type RegionAlternative = {
  __typename?: 'RegionAlternative';
  defaultMunicipality: MunicipalityAlternative;
  label: Scalars['String']['output'];
  longLabel: Scalars['String']['output'];
  municipalities: Array<MunicipalityAlternative>;
  value: WhichRegionAlternative;
};


export type RegionAlternativemunicipalitiesArgs = {
  includeDefaultsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  regions?: InputMaybe<Array<WhichRegionAlternative>>;
};

export type RegionArrayComparator = {
  all?: InputMaybe<Array<WhichRegionAlternative>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<WhichRegionAlternative>>;
  has?: InputMaybe<WhichRegionAlternative>;
  some?: InputMaybe<Array<WhichRegionAlternative>>;
};

export type RegionComparator = {
  eq?: InputMaybe<WhichRegionAlternative>;
  in?: InputMaybe<Array<WhichRegionAlternative>>;
  neq?: InputMaybe<WhichRegionAlternative>;
  nin?: InputMaybe<Array<WhichRegionAlternative>>;
};

export type RegionOptionOptions = {
  __typename?: 'RegionOptionOptions';
  labels: Array<Scalars['String']['output']>;
  values: Array<WhichRegionAlternative>;
};

export type RegisterAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: AttachmentParentType;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterEventInput = {
  action: EventAction;
  identityId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  objectType: EventObjectType;
  scope: EventScope;
};

export type RegisterFileUploadInput = {
  /** Inferred for profile uploads, otherwise required */
  candidateId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: InputMaybe<Scalars['Int']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  referenceUrl?: InputMaybe<Scalars['String']['input']>;
  uploadType: FileUploadType;
};

export type RegisterProfessionalInput = {
  candidateInput: UpdateCandidateInput;
  comments: Array<CreateCandidateCommentInput>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  market: Market;
  phoneNumber: Scalars['String']['input'];
  profession: Profession;
  utmData: UtmDataInput;
};

export type RejectPresentationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  presentationId: Scalars['String']['input'];
};

export type ReopenTenderInput = {
  id: Scalars['String']['input'];
  lastPresentationDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Reply = {
  __typename?: 'Reply';
  createdAt: Scalars['Float']['output'];
  freeText: Scalars['String']['output'];
};

export type ReportJobApplicationCallInput = {
  hasAnswered?: InputMaybe<Scalars['Boolean']['input']>;
  jobApplicationId: Scalars['String']['input'];
};

export type ReportResourceAvailabilityInput = {
  candidateId: Scalars['String']['input'];
  endDateTime: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  /** If false the candidate will be marked as unavailable. */
  isAvailable?: Scalars['Boolean']['input'];
  shiftHours?: InputMaybe<ShiftHours>;
  startDateTime: Scalars['Date']['input'];
};

export type ReportTimeInput = {
  breakTime: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Date']['input'];
  onCallDisturbances?: InputMaybe<Array<OnCallDisturbanceInput>>;
  shiftBookingId: Scalars['String']['input'];
  startDateTime: Scalars['Date']['input'];
};

export type RequirementFulfillment = {
  __typename?: 'RequirementFulfillment';
  attachmentIds: Array<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  comment: Scalars['String']['output'];
  /** Only applicable for IVO | HOSP */
  fetchedAt?: Maybe<Scalars['Int']['output']>;
  fulfillmentStatus: RequirementFulfillmentStatus;
  id: Scalars['String']['output'];
  isInProgress?: Maybe<Scalars['Boolean']['output']>;
  presentationId: Scalars['String']['output'];
  requirementId: Scalars['String']['output'];
  type: CandidateRequirementType;
};

export enum RequirementFulfillmentStatus {
  FULFILLED = 'FULFILLED',
  NOT_FULFILLED = 'NOT_FULFILLED',
  NOT_SET = 'NOT_SET'
}

export type Requirements = {
  __typename?: 'Requirements';
  customRequirements?: Maybe<Array<CustomRequirement>>;
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  driversLicenseRequirements?: Maybe<Array<DriversLicenseRequirement>>;
  experienceRequirements?: Maybe<Array<ExperienceRequirement>>;
  id: Scalars['String']['output'];
  journalSystemRequirements?: Maybe<Array<JournalSystemRequirement>>;
  specializationsRequirements?: Maybe<Array<SpecializationsRequirement>>;
};

export type RequirementsInput = {
  customRequirements?: InputMaybe<Array<CustomRequirementInput>>;
  documentRequirements?: InputMaybe<Array<DocumentRequirementInput>>;
  driversLicenseRequirements?: InputMaybe<Array<DriversLicenseRequirementInput>>;
  experienceRequirements?: InputMaybe<Array<ExperienceRequirementInput>>;
  journalSystemRequirements?: InputMaybe<Array<JournalSystemRequirementInput>>;
  specializationsRequirements?: InputMaybe<Array<SpecializationsRequirementInput>>;
};

export type ResourceAvailability = {
  __typename?: 'ResourceAvailability';
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  filledAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  identityId?: Maybe<Scalars['String']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  shiftHours?: Maybe<ShiftHours>;
  source: ResourceAvailabilitySource;
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ResourceAvailabilityFilter = {
  AND?: InputMaybe<Array<ResourceAvailabilityFilter>>;
  NOT?: InputMaybe<Array<ResourceAvailabilityFilter>>;
  OR?: InputMaybe<Array<ResourceAvailabilityFilter>>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  createdBy?: InputMaybe<NullableIdComparator>;
  endDateTime?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<NullableIdComparator>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  shiftHours?: InputMaybe<NullableShiftHoursComparator>;
  source?: InputMaybe<ResourceAvailabilitySourceComparator>;
  startDateTime?: InputMaybe<DateComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export type ResourceAvailabilityListRelationComparator = {
  every?: InputMaybe<ResourceAvailabilityFilter>;
  none?: InputMaybe<ResourceAvailabilityFilter>;
  some?: InputMaybe<ResourceAvailabilityFilter>;
};

export enum ResourceAvailabilitySource {
  PREFERENCE = 'PREFERENCE',
  SCHEDULE = 'SCHEDULE',
  TENDER = 'TENDER',
  VACATION = 'VACATION'
}

export type ResourceAvailabilitySourceComparator = {
  eq?: InputMaybe<ResourceAvailabilitySource>;
  in?: InputMaybe<Array<ResourceAvailabilitySource>>;
  neq?: InputMaybe<ResourceAvailabilitySource>;
  nin?: InputMaybe<Array<ResourceAvailabilitySource>>;
};

export type RespondToShiftApplicationInput = {
  accepted: Scalars['Boolean']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  shiftApplicationId: Scalars['String']['input'];
};

export type RespondToShiftSuggestionInput = {
  accepted: Scalars['Boolean']['input'];
  shiftSuggestionId: Scalars['String']['input'];
};

export type RespondToShiftSuggestionsInput = {
  responses: Array<RespondToShiftSuggestionInput>;
};

export type RestTimeBetweenShiftsViolation = ConflictingShiftsViolation & {
  __typename?: 'RestTimeBetweenShiftsViolation';
  shiftId: Scalars['String']['output'];
  type: SchedulingViolationsType;
  violatingShift?: Maybe<CandidateInformationShift>;
  violatingShiftId: Scalars['String']['output'];
};

export type ReturnTimesheetInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  timesheetId: Scalars['String']['input'];
};

export type ReviewPresentationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  presentationId: Scalars['String']['input'];
  verdict?: InputMaybe<PresentationReviewVerdict>;
};

export enum Role {
  ADMIN = 'ADMIN',
  ADMIN_DOCUMENTS = 'ADMIN_DOCUMENTS',
  ALL = 'ALL'
}

export type SalariesOptionsMap = {
  __typename?: 'SalariesOptionsMap';
  DOCTOR: Array<DoctorOptions>;
  NURSE: Array<NurseOptions>;
};

export type Salary = {
  __typename?: 'Salary';
  age?: Maybe<Scalars['Int']['output']>;
  baseSalary: Scalars['Int']['output'];
  company: Scalars['String']['output'];
  country: Country;
  createdAt: Scalars['Int']['output'];
  documentId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  hasPerks: Scalars['Boolean']['output'];
  ip: Scalars['String']['output'];
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  jobType: JobType;
  ob: Scalars['Boolean']['output'];
  obEvening?: Maybe<Scalars['Int']['output']>;
  obLongWeekend?: Maybe<Scalars['Int']['output']>;
  obNight?: Maybe<Scalars['Int']['output']>;
  obWeekend?: Maybe<Scalars['Int']['output']>;
  otherPerk?: Maybe<Scalars['String']['output']>;
  perks?: Maybe<Array<Perk>>;
  profession: Profession;
  region?: Maybe<Region>;
  specialization?: Maybe<Specialization>;
  summerJob?: Maybe<Scalars['Boolean']['output']>;
  tjanstePension: Scalars['Boolean']['output'];
  vacationIncluded: Scalars['Boolean']['output'];
  workForm: WorkForm;
  workplace: Scalars['String']['output'];
};

export type SalaryStatisticsGroups = {
  __typename?: 'SalaryStatisticsGroups';
  genericSpecializationSalaryGroup?: Maybe<AggregatedSalaryGroup>;
  noSpecializationSalaryGroup?: Maybe<AggregatedSalaryGroup>;
};

export type ScheduleDraft = {
  __typename?: 'ScheduleDraft';
  baseSchedule?: Maybe<BaseSchedule>;
  basedOnScheduleDraftId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  draftResources: Array<ScheduleDraftResource>;
  draftShifts: Array<ScheduleDraftShift>;
  fromBaseSchedule?: Maybe<BaseSchedule>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  objectiveScore?: Maybe<Scalars['Int']['output']>;
  penalities?: Maybe<Scalars['JSON']['output']>;
  schedulingPeriod: SchedulingPeriod;
  schedulingPeriodId: Scalars['String']['output'];
  status: ScheduleDraftStatus;
  version: Scalars['Int']['output'];
};

export type ScheduleDraftResource = {
  __typename?: 'ScheduleDraftResource';
  dayBreak: Scalars['String']['output'];
  id: Scalars['String']['output'];
  resourceConfiguration?: Maybe<SchedulingPeriodResourceConfiguration>;
  resourceConfigurationId?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  scheduleDraftId: Scalars['String']['output'];
  unitId: Scalars['String']['output'];
  weekBreak: Scalars['String']['output'];
};

export type ScheduleDraftResourceInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  dayBreak: Scalars['String']['input'];
  unitId: Scalars['String']['input'];
  weekBreak: Scalars['String']['input'];
};

export type ScheduleDraftShift = {
  __typename?: 'ScheduleDraftShift';
  activity: ShiftActivity;
  assignedTo?: Maybe<Scalars['Int']['output']>;
  breakTime: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  onCallTime?: Maybe<OnCallTime>;
  scheduleDraftId: Scalars['String']['output'];
  scheduleResourceId: Scalars['String']['output'];
  schedulingPeriodId: Scalars['String']['output'];
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  tags: Array<Tag>;
  type: ShiftType;
  unitId: Scalars['String']['output'];
};

export enum ScheduleDraftStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  GENERATING = 'GENERATING',
  REJECTED = 'REJECTED'
}

export type ScheduleResource = {
  __typename?: 'ScheduleResource';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isMedsTrained: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  professions: Array<Profession>;
  requirementsId: Scalars['String']['output'];
  shiftPresets: Array<ShiftPreset>;
  tags: Array<Tag>;
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ScheduleResourceFilter = {
  AND?: InputMaybe<Array<ScheduleResourceFilter>>;
  NOT?: InputMaybe<Array<ScheduleResourceFilter>>;
  OR?: InputMaybe<Array<ScheduleResourceFilter>>;
  id?: InputMaybe<IdComparator>;
  professions?: InputMaybe<ProfessionArrayComparator>;
  tags?: InputMaybe<IdArrayComparator>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
};

export type ScheduleSlot = {
  __typename?: 'ScheduleSlot';
  activity: ShiftActivity;
  applications: Array<ShiftApplication>;
  breakTime: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSeen: Scalars['Boolean']['output'];
  isUninteresting: Scalars['Boolean']['output'];
  myMostRecentApplication?: Maybe<ShiftApplication>;
  myMostRecentBooking?: Maybe<ShiftBooking>;
  scheduleResource: ScheduleResource;
  scheduleResourceId: Scalars['String']['output'];
  seenCount: Scalars['Int']['output'];
  shifts: Array<Shift>;
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  suggestions: Array<ShiftSuggestion>;
  tags: Array<Tag>;
  uninterestingCount: Scalars['Int']['output'];
  unit: Unit;
  unitId: Scalars['String']['output'];
};

export type ScheduleSlotFilter = {
  AND?: InputMaybe<Array<ScheduleSlotFilter>>;
  NOT?: InputMaybe<Array<ScheduleSlotFilter>>;
  OR?: InputMaybe<Array<ScheduleSlotFilter>>;
  createdAt?: InputMaybe<DateComparator>;
  endDateTime?: InputMaybe<DateComparator>;
  hasApplications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdComparator>;
  scheduleResource?: InputMaybe<ScheduleResourceFilter>;
  scheduleResourceId?: InputMaybe<IdComparator>;
  shifts?: InputMaybe<ShiftListRelationComparator>;
  startDateTime?: InputMaybe<DateComparator>;
  /** Filters out slots with tags that are not among the provided values */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export enum SchedulingModelVersionType {
  ALL = 'ALL',
  EXPERIMENTAL = 'EXPERIMENTAL',
  STABLE = 'STABLE'
}

export type SchedulingModelVersionsInput = {
  type?: InputMaybe<SchedulingModelVersionType>;
};

export type SchedulingPeriod = {
  __typename?: 'SchedulingPeriod';
  activities: Array<SchedulingPeriodActivity>;
  allowedShifts: Array<SchedulingPeriodAllowedShift>;
  baseSchedules: Array<BaseSchedule>;
  canBe: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  dayDemands: Array<SchedulingPeriodDayDemand>;
  endsAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  preferencesDeadline: Scalars['Date']['output'];
  prompts: Array<SchedulingPeriodPrompt>;
  resourceAvailabilities: Array<ResourceAvailability>;
  resourceConfigurations: Array<SchedulingPeriodResourceConfiguration>;
  resourceDemandType: SchedulingPeriodResourceDemandType;
  resourceShifts: Array<Shift>;
  rules: Scalars['JSON']['output'];
  scheduleAsFlex: Scalars['Boolean']['output'];
  scheduleDraft?: Maybe<ScheduleDraft>;
  scheduleDrafts: Array<ScheduleDraft>;
  schedulingDeadline: Scalars['Date']['output'];
  shiftDemands: Array<SchedulingPeriodShiftDemand>;
  shiftPresets: Array<ShiftPreset>;
  startsAt: Scalars['Date']['output'];
  status: SchedulingPeriodStatus;
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type SchedulingPeriodcanBeArgs = {
  action: Scalars['String']['input'];
};


export type SchedulingPeriodscheduleDraftArgs = {
  draftId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SchedulingPeriodActivity = {
  __typename?: 'SchedulingPeriodActivity';
  activity: ShiftActivity;
  breakTime: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  day?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** In minutes */
  length: Scalars['Int']['output'];
  participants: Array<Scalars['String']['output']>;
  scheduleResourceId: Scalars['String']['output'];
  schedulingPeriod: SchedulingPeriod;
  schedulingPeriodId: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  type: ShiftType;
  updatedAt: Scalars['Date']['output'];
};

export type SchedulingPeriodAllowedShift = {
  __typename?: 'SchedulingPeriodAllowedShift';
  breakTime: Scalars['Int']['output'];
  day: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  scheduleResourceId: Scalars['String']['output'];
  schedulingPeriodId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type SchedulingPeriodConfiguration = {
  __typename?: 'SchedulingPeriodConfiguration';
  createdAt: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  organizationKey?: Maybe<Scalars['String']['output']>;
  preferencesDeadlineDaysPrior: Scalars['Int']['output'];
  rules: Scalars['JSON']['output'];
  schedulingDeadlineDaysPrior: Scalars['Int']['output'];
  startsOnDay: Day;
  updatedAt: Scalars['Date']['output'];
};

export type SchedulingPeriodDayDemand = {
  __typename?: 'SchedulingPeriodDayDemand';
  day: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  max: Array<Scalars['Int']['output']>;
  min: Array<Scalars['Int']['output']>;
  scheduleResourceId: Scalars['String']['output'];
  schedulingPeriodId: Scalars['String']['output'];
};

export type SchedulingPeriodPrompt = {
  __typename?: 'SchedulingPeriodPrompt';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isPersonal: Scalars['Boolean']['output'];
  prompt: Scalars['String']['output'];
  resourceConfigurationIds: Array<Scalars['String']['output']>;
  schedulingPeriodId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SchedulingPeriodResourceConfiguration = {
  __typename?: 'SchedulingPeriodResourceConfiguration';
  candidate?: Maybe<Candidate>;
  candidateId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crossPeriodId: Scalars['String']['output'];
  dayBreak: Scalars['String']['output'];
  fullTimeWeekly: Scalars['Float']['output'];
  hoursBalance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isIncluded: Scalars['Boolean']['output'];
  requiredDays: Array<Scalars['Int']['output']>;
  schedulingPeriodId: Scalars['String']['output'];
  serviceLevel: Scalars['Float']['output'];
  shiftHours: Array<ShiftHours>;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  weekBreak: Scalars['String']['output'];
  weekendFrequency?: Maybe<Scalars['String']['output']>;
};

export enum SchedulingPeriodResourceDemandType {
  QUARTERS = 'QUARTERS',
  SHIFTS = 'SHIFTS'
}

export type SchedulingPeriodShiftDemand = {
  __typename?: 'SchedulingPeriodShiftDemand';
  day: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  shiftPresetId: Scalars['String']['output'];
};

export enum SchedulingPeriodStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  PLANNED = 'PLANNED',
  SCHEDULED = 'SCHEDULED'
}

export type SchedulingViolations = {
  __typename?: 'SchedulingViolations';
  overlappingShiftsViolations: Array<OverlappingShiftsViolation>;
  restTimeBetweenShiftsViolations: Array<RestTimeBetweenShiftsViolation>;
  uninterruptedRestTimeViolations: Array<UninterruptedRestTimeViolation>;
};

export enum SchedulingViolationsType {
  EU_MAX_HOURS_PER_28_DAYS_EXCEEDED = 'EU_MAX_HOURS_PER_28_DAYS_EXCEEDED',
  EU_NO_COMPENSATING_REST = 'EU_NO_COMPENSATING_REST',
  EU_NO_DAILY_REST = 'EU_NO_DAILY_REST',
  EU_NO_WEEKLY_REST = 'EU_NO_WEEKLY_REST',
  EU_REDUCED_DAILY_REST = 'EU_REDUCED_DAILY_REST',
  INSUFFICIENT_REST_BETWEEN_SHIFTS = 'INSUFFICIENT_REST_BETWEEN_SHIFTS',
  MAX_HOURS_PER_DAY_EXCEEDED = 'MAX_HOURS_PER_DAY_EXCEEDED',
  MAX_HOURS_PER_PERIOD_EXCEEDED = 'MAX_HOURS_PER_PERIOD_EXCEEDED',
  OVERLAPPING_SHIFTS = 'OVERLAPPING_SHIFTS',
  SHORT_DAY_WORKED = 'SHORT_DAY_WORKED'
}

export type SendContactRequestRemindersResult = {
  __typename?: 'SendContactRequestRemindersResult';
  /** Returns all identities for whom the reminder failed. */
  failed: Array<Identity>;
  /** Returns whether the reminder was actually sent. Returns `false` if `dryRun: true`. */
  sent: Scalars['Boolean']['output'];
  /** If an array of identity IDs was provided, this returns all identities for whom the reminder was not sent, due to filtering settings. */
  skipped: Array<Scalars['String']['output']>;
  /** Returns all identities for whom the reminder succeeded. */
  succeeded: Array<Identity>;
};

export type SendInput = {
  jobApplicationId: Scalars['String']['input'];
  offers: Array<OfferInput>;
};

export type SetCustomClaimsInput = {
  customClaims: CustomClaims;
  userId: Scalars['String']['input'];
};

export type SetJobApplicationOffersInput = {
  jobApplicationId: Scalars['String']['input'];
  offers: Array<OfferInput>;
};

export type Shift = {
  __typename?: 'Shift';
  activity: ShiftActivity;
  applications: Array<ShiftApplication>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  booked: Scalars['Boolean']['output'];
  booking?: Maybe<ShiftBooking>;
  bookings: Array<ShiftBooking>;
  /** The allowed break in minutes */
  breakTime: Scalars['Int']['output'];
  canceledComment?: Maybe<Scalars['String']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** A date string, e.g. "2022-10-06" */
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  isPublishedToPool: Scalars['Boolean']['output'];
  isTendered: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  onCallTime?: Maybe<OnCallTime>;
  scheduleResource: ScheduleResource;
  scheduleResourceId: Scalars['String']['output'];
  scheduleSlot: ScheduleSlot;
  scheduleSlotId: Scalars['String']['output'];
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  suggestions: Array<ShiftSuggestion>;
  tags: Array<Tag>;
  tenderShifts: Array<TenderShift>;
  type: ShiftType;
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type ShiftapplicationsArgs = {
  filter?: InputMaybe<ShiftApplicationFilter>;
};

export enum ShiftActivity {
  FLEX = 'FLEX',
  INTRODUCTION = 'INTRODUCTION',
  OTHER = 'OTHER',
  TEAM_MEETING = 'TEAM_MEETING',
  TRAINING = 'TRAINING',
  WORK = 'WORK'
}

export type ShiftApplication = {
  __typename?: 'ShiftApplication';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  applicantScheduleInformation: AddShiftToCandidateScheduleInformation;
  candidate: Candidate;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  handledBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  scheduleSlot: ScheduleSlot;
  scheduleSlotId: Scalars['String']['output'];
  status: ShiftApplicationStatus;
  updatedAt: Scalars['Date']['output'];
  withdrawnAt?: Maybe<Scalars['Date']['output']>;
};

export type ShiftApplicationFilter = {
  AND?: InputMaybe<Array<ShiftApplicationFilter>>;
  NOT?: InputMaybe<Array<ShiftApplicationFilter>>;
  OR?: InputMaybe<Array<ShiftApplicationFilter>>;
  acceptedAt?: InputMaybe<NullableDateComparator>;
  canceledAt?: InputMaybe<NullableDateComparator>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  handledBy?: InputMaybe<NullableIdComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<IdComparator>;
  rejectedAt?: InputMaybe<NullableDateComparator>;
  rejectionReason?: InputMaybe<StringComparator>;
  scheduleSlot?: InputMaybe<ScheduleSlotFilter>;
  scheduleSlotId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
  withdrawnAt?: InputMaybe<NullableDateComparator>;
};

export enum ShiftApplicationStatus {
  ACCEPTED = 'ACCEPTED',
  APPLIED = 'APPLIED',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN'
}

export type ShiftApplicationsKpiData = {
  __typename?: 'ShiftApplicationsKpiData';
  meanResponseTime: Scalars['Float']['output'];
  percentageAnswered: Scalars['Float']['output'];
};

export enum ShiftAvailability {
  APPLIED_SIMILAR_SHIFT = 'APPLIED_SIMILAR_SHIFT',
  CONFLICTING_SHIFT = 'CONFLICTING_SHIFT',
  FULL_AVAILABILITY = 'FULL_AVAILABILITY',
  NO_DATA = 'NO_DATA',
  PARTIAL_AVAILABILITY = 'PARTIAL_AVAILABILITY',
  PREFERRED_UNAVAILABLE = 'PREFERRED_UNAVAILABLE',
  SCHEDULED_AVAILABILITY = 'SCHEDULED_AVAILABILITY',
  SCHEDULED_LEAVE = 'SCHEDULED_LEAVE',
  TENDERED_AVAILABILITY = 'TENDERED_AVAILABILITY'
}

export type ShiftBooking = {
  __typename?: 'ShiftBooking';
  canceledAt?: Maybe<Scalars['Date']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<ShiftBookingCancellationReason>;
  candidate: Candidate;
  candidateAcknowledgedAt?: Maybe<Scalars['Date']['output']>;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  identityId?: Maybe<Scalars['String']['output']>;
  markedAbsentAt?: Maybe<Scalars['Date']['output']>;
  presentationShiftId?: Maybe<Scalars['String']['output']>;
  resourceAvailabilityId?: Maybe<Scalars['String']['output']>;
  scheduleDraftShiftId?: Maybe<Scalars['String']['output']>;
  shift: Shift;
  shiftApplicationId?: Maybe<Scalars['String']['output']>;
  shiftId: Scalars['String']['output'];
  shiftSuggestionId?: Maybe<Scalars['String']['output']>;
  status: ShiftBookingStatus;
  timesheet?: Maybe<Timesheet>;
  updatedAt: Scalars['Date']['output'];
};

/** The reason why a shift booking was cancelled */
export enum ShiftBookingCancellationReason {
  CARE_OF_CHILD = 'CARE_OF_CHILD',
  NO_LONGER_NEEDED = 'NO_LONGER_NEEDED',
  PERSONAL_REASONS = 'PERSONAL_REASONS',
  SICKNESS = 'SICKNESS'
}

export type ShiftBookingFilter = {
  AND?: InputMaybe<Array<ShiftBookingFilter>>;
  NOT?: InputMaybe<Array<ShiftBookingFilter>>;
  OR?: InputMaybe<Array<ShiftBookingFilter>>;
  canceledAt?: InputMaybe<NullableDateComparator>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  createdBy?: InputMaybe<IdComparator>;
  id?: InputMaybe<IdComparator>;
  identity?: InputMaybe<IdentityFilter>;
  identityId?: InputMaybe<NullableIdComparator>;
  shift?: InputMaybe<ShiftFilter>;
  shiftId?: InputMaybe<IdComparator>;
  unattested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShiftBookingListRelationComparator = {
  every?: InputMaybe<ShiftBookingFilter>;
  none?: InputMaybe<ShiftBookingFilter>;
  some?: InputMaybe<ShiftBookingFilter>;
};

export enum ShiftBookingStatus {
  BOOKED = 'BOOKED',
  CANCELED = 'CANCELED'
}

export type ShiftFilter = {
  AND?: InputMaybe<Array<ShiftFilter>>;
  NOT?: InputMaybe<Array<ShiftFilter>>;
  OR?: InputMaybe<Array<ShiftFilter>>;
  booking?: InputMaybe<ShiftBookingFilter>;
  endDateTime?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  isBooked?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleResource?: InputMaybe<ScheduleResourceFilter>;
  scheduleResourceId?: InputMaybe<IdComparator>;
  scheduleSlot?: InputMaybe<ScheduleSlotFilter>;
  scheduleSlotId?: InputMaybe<IdComparator>;
  startDateTime?: InputMaybe<DateComparator>;
  tags?: InputMaybe<IdArrayComparator>;
  tenders?: InputMaybe<TenderListRelationComparator>;
  unitId?: InputMaybe<IdComparator>;
};

export enum ShiftHours {
  DAY = 'DAY',
  EVENING = 'EVENING',
  LONG = 'LONG',
  NIGHT = 'NIGHT'
}

export type ShiftHoursArrayComparator = {
  all?: InputMaybe<Array<ShiftHours>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<ShiftHours>>;
  has?: InputMaybe<ShiftHours>;
  some?: InputMaybe<Array<ShiftHours>>;
};

export type ShiftListRelationComparator = {
  every?: InputMaybe<ShiftFilter>;
  none?: InputMaybe<ShiftFilter>;
  some?: InputMaybe<ShiftFilter>;
};

export type ShiftPreset = {
  __typename?: 'ShiftPreset';
  activity: ShiftActivity;
  breakTime: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  onCallTime?: Maybe<ShiftPresetOnCallTime>;
  scheduleResourceId: Scalars['String']['output'];
  schedulingPeriodId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  tags: Array<Tag>;
  type: ShiftType;
};

export type ShiftPresetOnCallTime = {
  __typename?: 'ShiftPresetOnCallTime';
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  type: OnCallType;
};

export type ShiftStatistics = {
  __typename?: 'ShiftStatistics';
  applicationKpiData: ShiftApplicationsKpiData;
  shiftHoursStatistics: Array<GraphDataPoint>;
  shiftsCountStatistics: Array<GraphDataPoint>;
  shiftsData: Array<ShiftStatisticsDataPoint>;
  shiftsFillRateStatistics: Array<GraphDataPoint>;
  unitStatistics: Array<ShiftUnitStatistics>;
};

export type ShiftStatisticsDataPoint = {
  __typename?: 'ShiftStatisticsDataPoint';
  bookedHours: Scalars['Float']['output'];
  publishedHours: Scalars['Float']['output'];
  timestamp: Scalars['Date']['output'];
};

export type ShiftSuggestion = {
  __typename?: 'ShiftSuggestion';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  bookOnAccept: Scalars['Boolean']['output'];
  bookedAt?: Maybe<Scalars['Date']['output']>;
  canceledAt?: Maybe<Scalars['Date']['output']>;
  candidate: Candidate;
  candidateBooking?: Maybe<CandidateBooking>;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  identityId?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  respondedBy?: Maybe<Scalars['String']['output']>;
  scheduleSlot: ScheduleSlot;
  scheduleSlotId: Scalars['String']['output'];
  suggestedBy: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  vacantShift?: Maybe<Shift>;
};

export type ShiftSuggestionFilter = {
  AND?: InputMaybe<Array<ShiftSuggestionFilter>>;
  NOT?: InputMaybe<Array<ShiftSuggestionFilter>>;
  OR?: InputMaybe<Array<ShiftSuggestionFilter>>;
  acceptedAt?: InputMaybe<NullableDateComparator>;
  bookedAt?: InputMaybe<NullableDateComparator>;
  canceledAt?: InputMaybe<NullableDateComparator>;
  candidate?: InputMaybe<CandidateFilter>;
  candidateId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  identity?: InputMaybe<IdentityFilter>;
  identityId?: InputMaybe<NullableIdComparator>;
  rejectedAt?: InputMaybe<NullableDateComparator>;
  respondedBy?: InputMaybe<NullableIdComparator>;
  scheduleSlot?: InputMaybe<ScheduleSlotFilter>;
  scheduleSlotId?: InputMaybe<IdComparator>;
  suggestedBy?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export enum ShiftType {
  COMBINED = 'COMBINED',
  ON_CALL = 'ON_CALL',
  REGULAR = 'REGULAR'
}

export type ShiftUnitStatistics = {
  __typename?: 'ShiftUnitStatistics';
  bookedHours: Scalars['Float']['output'];
  bookedShiftsCount: Scalars['Int']['output'];
  requestedHours: Scalars['Float']['output'];
  shiftsCount: Scalars['Int']['output'];
  unitId: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
  vacantHours: Scalars['Float']['output'];
  vacantShiftsCount: Scalars['Int']['output'];
};

export type SignReferenceInput = {
  referenceId: Scalars['String']['input'];
};

export type SnoozeJobApplicationUntilDateInput = {
  jobApplicationId: Scalars['String']['input'];
  snoozeDate: Scalars['Int']['input'];
};

export { Specialization };

export type SpecializationAlternative = {
  __typename?: 'SpecializationAlternative';
  label: Scalars['String']['output'];
  profession: Profession;
  value: Specialization;
};

export type SpecializationArrayComparator = {
  all?: InputMaybe<Array<Specialization>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<Specialization>>;
  has?: InputMaybe<Specialization>;
  some?: InputMaybe<Array<Specialization>>;
};

export type SpecializationOptionOptions = {
  __typename?: 'SpecializationOptionOptions';
  labels: Array<Scalars['String']['output']>;
  values: Array<Specialization>;
};

export type SpecializationsRequirement = {
  __typename?: 'SpecializationsRequirement';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  specializations: Array<Specialization>;
};

export type SpecializationsRequirementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  specializations: Array<Specialization>;
};

export type Statistics = {
  __typename?: 'Statistics';
  crossOrgNetwork: CrossOrg;
  endDate: Scalars['Date']['output'];
  shiftStatistics: ShiftStatistics;
  startDate: Scalars['Date']['output'];
  timeUnit: StatisticsTimeUnit;
  unitBudgets: Array<UnitBudget>;
};


export type StatisticsshiftStatisticsArgs = {
  data: ScheduleSlotFilter;
};


export type StatisticsunitBudgetsArgs = {
  unitId: Scalars['String']['input'];
};

/** Series keys used in statistics. */
export enum StatisticsSeriesKey {
  APPLICATIONS_COUNT = 'APPLICATIONS_COUNT',
  APPLIED_HOURS = 'APPLIED_HOURS',
  APPROVED_HOURS = 'APPROVED_HOURS',
  BOOKED_HOURS = 'BOOKED_HOURS',
  BOOKINGS_COUNT = 'BOOKINGS_COUNT',
  COST = 'COST',
  FILL_RATE = 'FILL_RATE',
  NUMBER_OF_TENDERS = 'NUMBER_OF_TENDERS',
  REQUESTED_HOURS = 'REQUESTED_HOURS',
  SHIFTS_COUNT = 'SHIFTS_COUNT',
  UTILIZATION_RATE = 'UTILIZATION_RATE'
}

/** Unit of time for statistics used for grouping. */
export enum StatisticsTimeUnit {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type StringComparator = {
  contains?: InputMaybe<Scalars['String']['input']>;
  containsIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  endsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  neqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
  startsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeToNewsletterInput = {
  email: Scalars['String']['input'];
  market?: InputMaybe<Market>;
  origin: Scalars['String']['input'];
  profession?: InputMaybe<Profession>;
};

export type SuggestShiftInput = {
  bookOnAccept?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId: Scalars['String']['input'];
  scheduleSlotId: Scalars['String']['input'];
};

export type SuggestShiftsInput = {
  suggestions: Array<SuggestShiftInput>;
};

export type SupplierDeviation = {
  __typename?: 'SupplierDeviation';
  action: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  orderer: Organization;
  ordererId: Scalars['String']['output'];
  previousDeviation?: Maybe<SupplierDeviation>;
  supplier: Organization;
  supplierId: Scalars['String']['output'];
  type: SupplierDeviationType;
  updatedAt: Scalars['Date']['output'];
};

export type SupplierDeviationEdge = {
  __typename?: 'SupplierDeviationEdge';
  cursor: Scalars['String']['output'];
  node: SupplierDeviation;
};

export type SupplierDeviationFilter = {
  AND?: InputMaybe<Array<SupplierDeviationFilter>>;
  NOT?: InputMaybe<Array<SupplierDeviationFilter>>;
  OR?: InputMaybe<Array<SupplierDeviationFilter>>;
  action?: InputMaybe<StringComparator>;
  comment?: InputMaybe<StringComparator>;
  createdAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  ordererId?: InputMaybe<IdComparator>;
  supplierId?: InputMaybe<IdComparator>;
  type?: InputMaybe<SupplierDeviationTypeComparator>;
};

export enum SupplierDeviationType {
  BLOCK = 'BLOCK',
  END_COOPERATION = 'END_COOPERATION',
  FINE = 'FINE',
  WARNING = 'WARNING'
}

export type SupplierDeviationTypeComparator = {
  eq?: InputMaybe<SupplierDeviationType>;
  in?: InputMaybe<Array<SupplierDeviationType>>;
  neq?: InputMaybe<SupplierDeviationType>;
  nin?: InputMaybe<Array<SupplierDeviationType>>;
};

export type SupplierDeviationsCursorSearchResult = {
  __typename?: 'SupplierDeviationsCursorSearchResult';
  edges: Array<SupplierDeviationEdge>;
  pageInfo: PageInfo;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type Tender = {
  __typename?: 'Tender';
  announcedAt?: Maybe<Scalars['Date']['output']>;
  areStrictRequirementsEnforced: Scalars['Boolean']['output'];
  assignedAt?: Maybe<Scalars['Date']['output']>;
  attachments: Array<Attachment>;
  attributionCriteria: Array<AttributionCriterion>;
  availablePriceGroups: Array<AvailableTenderPriceGroup>;
  billingInformation?: Maybe<BillingInformation>;
  billingInformationId?: Maybe<Scalars['String']['output']>;
  candidateBookings?: Maybe<Array<CandidateBooking>>;
  candidateDescription: Scalars['String']['output'];
  closedAt?: Maybe<Scalars['Date']['output']>;
  contactPerson?: Maybe<Identity>;
  contactPersonUserId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  department: WhichDepartmentToWorkInAlternative;
  /** Only available for the tender owner */
  detailedFillRate?: Maybe<DetailedTenderFillRate>;
  doesAcceptPresentations: Scalars['Boolean']['output'];
  dynamicStatus: DynamicTenderStatus;
  endsAt: Scalars['Date']['output'];
  enforceRows: Scalars['Boolean']['output'];
  fillRate?: Maybe<Scalars['Int']['output']>;
  fromTenderTemplateId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDraft: Scalars['Boolean']['output'];
  isExtended: Scalars['Boolean']['output'];
  isTimeReportable?: Maybe<Scalars['Boolean']['output']>;
  lastPresentationDate?: Maybe<Scalars['Date']['output']>;
  managerIds: Array<Scalars['String']['output']>;
  markedReadyToPublishAt?: Maybe<Scalars['Date']['output']>;
  notesCount: Scalars['Int']['output'];
  openedBy: Array<Scalars['String']['output']>;
  orderer: Organization;
  organizationId: Scalars['String']['output'];
  presentationReviewerIds: Array<Scalars['String']['output']>;
  presentations: Array<Presentation>;
  priceGroups: Array<TenderedPriceGroup>;
  pricing: TenderPricing;
  profession: Profession;
  requirements: Requirements;
  rows: TenderRowType;
  scheduleDescription: Scalars['String']['output'];
  scheduleResource?: Maybe<ScheduleResource>;
  scheduleResourceId: Scalars['String']['output'];
  scheduleType: TenderScheduleType;
  scope: Scalars['Float']['output'];
  sentTo: Array<Scalars['String']['output']>;
  shifts: Array<TenderShift>;
  startsAt: Scalars['Date']['output'];
  status: TenderStatus;
  suppliers: Array<TenderSupplier>;
  templateData: TenderTemplateData;
  tenderedAvailabilities: Array<TenderedAvailability>;
  title: Scalars['String']['output'];
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  vacancy?: Maybe<Vacancy>;
  vacancyDescription: Scalars['String']['output'];
  vacantSchedule: Array<VacantTenderShift>;
  viewers: Array<Scalars['String']['output']>;
  waiver?: Maybe<TenderWaiver>;
  waiverId?: Maybe<Scalars['String']['output']>;
};


export type TendercandidateBookingsArgs = {
  filter?: InputMaybe<CandidateBookingFilter>;
};


export type TenderpresentationsArgs = {
  filter?: InputMaybe<PresentationFilter>;
};

export type TenderEdge = {
  __typename?: 'TenderEdge';
  cursor: Scalars['String']['output'];
  node: Tender;
};

export type TenderFilter = {
  AND?: InputMaybe<Array<TenderFilter>>;
  NOT?: InputMaybe<Array<TenderFilter>>;
  OR?: InputMaybe<Array<TenderFilter>>;
  announcedAt?: InputMaybe<DateComparator>;
  billingInformationId?: InputMaybe<IdComparator>;
  candidateDescription?: InputMaybe<StringComparator>;
  closedAt?: InputMaybe<DateComparator>;
  createdAt?: InputMaybe<DateComparator>;
  createdBy?: InputMaybe<IdComparator>;
  department?: InputMaybe<DepartmentComparator>;
  doesAcceptPresentations?: InputMaybe<Scalars['Boolean']['input']>;
  endsAt?: InputMaybe<DateComparator>;
  fromTenderTemplateId?: InputMaybe<IdComparator>;
  id?: InputMaybe<IdComparator>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isTimeReportable?: InputMaybe<Scalars['Boolean']['input']>;
  lastPresentationDate?: InputMaybe<NullableDateComparator>;
  managerIds?: InputMaybe<IdArrayComparator>;
  markedReadyToPublishAt?: InputMaybe<DateComparator>;
  openedBy?: InputMaybe<IdArrayComparator>;
  organizationId?: InputMaybe<IdComparator>;
  presentationReviewerIds?: InputMaybe<IdArrayComparator>;
  pricing?: InputMaybe<TenderPricingComparator>;
  profession?: InputMaybe<ProfessionComparator>;
  scheduleDescription?: InputMaybe<StringComparator>;
  scheduleType?: InputMaybe<TenderScheduleTypeComparator>;
  scope?: InputMaybe<NumberComparator>;
  sentTo?: InputMaybe<IdArrayComparator>;
  specializations?: InputMaybe<SpecializationArrayComparator>;
  startsAt?: InputMaybe<DateComparator>;
  status?: InputMaybe<TenderStatusComparator>;
  title?: InputMaybe<StringComparator>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
  vacancyDescription?: InputMaybe<StringComparator>;
  waiverId?: InputMaybe<IdComparator>;
};

export type TenderInvoice = {
  __typename?: 'TenderInvoice';
  amount: Scalars['Float']['output'];
  candidateBooking?: Maybe<CandidateBooking>;
  candidateBookingId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Currency;
  endsAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  orderer: Organization;
  ordererId: Scalars['String']['output'];
  referenceUrl: Scalars['String']['output'];
  startsAt: Scalars['Date']['output'];
  status: TenderInvoiceStatus;
  supplier: Organization;
  supplierId: Scalars['String']['output'];
  tenderId: Scalars['String']['output'];
  timesheets: Array<Timesheet>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TenderInvoiceEdge = {
  __typename?: 'TenderInvoiceEdge';
  cursor: Scalars['String']['output'];
  node: TenderInvoice;
};

export type TenderInvoiceFilter = {
  AND?: InputMaybe<Array<TenderInvoiceFilter>>;
  NOT?: InputMaybe<Array<TenderInvoiceFilter>>;
  OR?: InputMaybe<Array<TenderInvoiceFilter>>;
  amount?: InputMaybe<NumberComparator>;
  candidateBooking?: InputMaybe<CandidateBookingFilter>;
  candidateBookingId?: InputMaybe<IdComparator>;
  createdAt?: InputMaybe<DateComparator>;
  endsAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  ordererId?: InputMaybe<IdComparator>;
  startsAt?: InputMaybe<DateComparator>;
  supplierId?: InputMaybe<IdComparator>;
  tender?: InputMaybe<TenderFilter>;
  tenderId?: InputMaybe<IdComparator>;
  title?: InputMaybe<StringComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export enum TenderInvoiceStatus {
  CLOSED = 'CLOSED',
  CREATED = 'CREATED',
  PAID = 'PAID',
  SENT = 'SENT'
}

export type TenderInvoicesCursorSearchResult = {
  __typename?: 'TenderInvoicesCursorSearchResult';
  edges: Array<TenderInvoiceEdge>;
  pageInfo: PageInfo;
};

export type TenderListRelationComparator = {
  every?: InputMaybe<TenderFilter>;
  none?: InputMaybe<TenderFilter>;
  some?: InputMaybe<TenderFilter>;
};

export type TenderPriceGroup = {
  __typename?: 'TenderPriceGroup';
  autoSelect: Scalars['Boolean']['output'];
  compensationModel?: Maybe<CompensationModel>;
  compensationModelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  departments: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  participatingOrganizations?: Maybe<Array<Organization>>;
  pricing: TenderPricing;
  professions: Array<Profession>;
  specializations: Array<Specialization>;
  suppliers?: Maybe<Array<TenderPriceGroupSupplier>>;
  title: Scalars['String']['output'];
  type: TenderPriceGroupType;
  updatedAt: Scalars['Date']['output'];
  zone?: Maybe<PriceZone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type TenderPriceGroupSupplier = {
  __typename?: 'TenderPriceGroupSupplier';
  basePay: Scalars['Float']['output'];
  currency: Currency;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  priceGroupId: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  supplier: Organization;
  supplierId: Scalars['String']['output'];
};

export type TenderPriceGroupSupplierInput = {
  basePay: Scalars['Float']['input'];
  currency: Currency;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['String']['input'];
};

export enum TenderPriceGroupType {
  STAGGERED = 'STAGGERED',
  STANDARD = 'STANDARD'
}

export enum TenderPricing {
  FREE = 'FREE',
  PROCURED = 'PROCURED'
}

export type TenderPricingComparator = {
  eq?: InputMaybe<TenderPricing>;
  in?: InputMaybe<Array<TenderPricing>>;
  neq?: InputMaybe<TenderPricing>;
  nin?: InputMaybe<Array<TenderPricing>>;
};

export enum TenderRecipientType {
  BEMLO = 'BEMLO',
  DATABASE = 'DATABASE',
  PROCURED = 'PROCURED'
}

export enum TenderRowType {
  ENFORCED = 'ENFORCED',
  NONE = 'NONE',
  STRICT = 'STRICT'
}

export enum TenderScheduleType {
  AVAILABILITY = 'AVAILABILITY',
  NOT_SET = 'NOT_SET',
  SHIFTS = 'SHIFTS',
  TEXT = 'TEXT'
}

export type TenderScheduleTypeComparator = {
  eq?: InputMaybe<TenderScheduleType>;
  in?: InputMaybe<Array<TenderScheduleType>>;
  neq?: InputMaybe<TenderScheduleType>;
  nin?: InputMaybe<Array<TenderScheduleType>>;
};

export type TenderShift = {
  __typename?: 'TenderShift';
  id: Scalars['String']['output'];
  presentations: Array<Presentation>;
  row: Scalars['Int']['output'];
  shift: Shift;
  shiftId: Scalars['String']['output'];
  status: TenderShiftStatus;
  tender: Tender;
  tenderId: Scalars['String']['output'];
};


export type TenderShiftpresentationsArgs = {
  filter?: InputMaybe<PresentationFilter>;
};

export enum TenderShiftStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type TenderShiftsInput = {
  shiftIds: Array<Scalars['String']['input']>;
  tenderId: Scalars['String']['input'];
};

export type TenderStatisticsDataPoint = {
  __typename?: 'TenderStatisticsDataPoint';
  hours: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  profession: Profession;
  specializations: Array<Specialization>;
  tenderId: Scalars['String']['output'];
  tenderTitle: Scalars['String']['output'];
  timeUnit: StatisticsTimeUnit;
  timestamp: Scalars['Date']['output'];
  unitId: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
};

export { TenderStatus };

export type TenderStatusComparator = {
  eq?: InputMaybe<TenderStatus>;
  in?: InputMaybe<Array<TenderStatus>>;
  neq?: InputMaybe<TenderStatus>;
  nin?: InputMaybe<Array<TenderStatus>>;
};

export type TenderSupplier = {
  __typename?: 'TenderSupplier';
  decision?: Maybe<TenderSupplierDecision>;
  id: Scalars['String']['output'];
  numberOfPresentations?: Maybe<Scalars['Int']['output']>;
  presentations: Array<Presentation>;
  score?: Maybe<Scalars['Float']['output']>;
  scoredAt?: Maybe<Scalars['Date']['output']>;
  supplier: Organization;
  supplierId: Scalars['String']['output'];
  tenderId: Scalars['String']['output'];
};


export type TenderSupplierpresentationsArgs = {
  filter?: InputMaybe<PresentationFilter>;
};

export enum TenderSupplierDecision {
  ASSIGNED = 'ASSIGNED',
  DISQUALIFIED = 'DISQUALIFIED',
  NOT_SELECTED = 'NOT_SELECTED'
}

export type TenderTemplate = {
  __typename?: 'TenderTemplate';
  employerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profession: Profession;
  requirements: Requirements;
  requirementsId: Scalars['String']['output'];
};

export type TenderTemplateData = {
  __typename?: 'TenderTemplateData';
  billingInformationId?: Maybe<Scalars['String']['output']>;
  candidateDescription: Scalars['String']['output'];
  contactPersonUserId?: Maybe<Scalars['String']['output']>;
  department: WhichDepartmentToWorkInAlternative;
  managerIds: Array<Scalars['String']['output']>;
  presentationReviewerIds: Array<Scalars['String']['output']>;
  pricing: TenderPricing;
  profession: Profession;
  requirements: Requirements;
  scheduleDescription: Scalars['String']['output'];
  scope: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unitId: Scalars['String']['output'];
  vacancyDescription: Scalars['String']['output'];
};

export type TenderWaiver = {
  __typename?: 'TenderWaiver';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  department: WhichDepartmentToWorkInAlternative;
  endsAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  motivation: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  profession: Profession;
  remainingScope: Scalars['Float']['output'];
  reviewComment?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Date']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  reviewerIds: Array<Scalars['String']['output']>;
  reviewers: Array<Identity>;
  scheduleResourceId: Scalars['String']['output'];
  scope: Scalars['Int']['output'];
  specializations: Array<Specialization>;
  startsAt: Scalars['Date']['output'];
  status: TenderWaiverStatus;
  tenders: Array<Tender>;
  title: Scalars['String']['output'];
  unit: Unit;
  unitId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  vacancyDescription?: Maybe<Scalars['String']['output']>;
};

export type TenderWaiverEdge = {
  __typename?: 'TenderWaiverEdge';
  cursor: Scalars['String']['output'];
  node: TenderWaiver;
};

export type TenderWaiverFilter = {
  AND?: InputMaybe<Array<TenderWaiverFilter>>;
  NOT?: InputMaybe<Array<TenderWaiverFilter>>;
  OR?: InputMaybe<Array<TenderWaiverFilter>>;
  createdAt?: InputMaybe<DateComparator>;
  createdBy?: InputMaybe<IdComparator>;
  department?: InputMaybe<DepartmentComparator>;
  endsAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  motivation?: InputMaybe<StringComparator>;
  organizationId?: InputMaybe<IdComparator>;
  profession?: InputMaybe<ProfessionComparator>;
  reviewComment?: InputMaybe<StringComparator>;
  reviewedAt?: InputMaybe<DateComparator>;
  reviewedBy?: InputMaybe<IdComparator>;
  scheduleResource?: InputMaybe<ScheduleResourceFilter>;
  scheduleResourceId?: InputMaybe<IdComparator>;
  scope?: InputMaybe<NumberComparator>;
  specializations?: InputMaybe<SpecializationArrayComparator>;
  startsAt?: InputMaybe<DateComparator>;
  status?: InputMaybe<TenderWaiverStatusComparator>;
  tenderReviewerIds?: InputMaybe<IdArrayComparator>;
  title?: InputMaybe<StringComparator>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
  updatedAt?: InputMaybe<DateComparator>;
  vacancyDescription?: InputMaybe<StringComparator>;
};

export type TenderWaiverStatisticsDataPoint = {
  __typename?: 'TenderWaiverStatisticsDataPoint';
  approvedHours: Scalars['Float']['output'];
  bookedHours: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  profession: Profession;
  specializations: Array<Specialization>;
  timeUnit: StatisticsTimeUnit;
  timestamp: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  unitId: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
  waiverId: Scalars['String']['output'];
};

export enum TenderWaiverStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  USED = 'USED'
}

export type TenderWaiverStatusComparator = {
  eq?: InputMaybe<TenderWaiverStatus>;
  in?: InputMaybe<Array<TenderWaiverStatus>>;
  neq?: InputMaybe<TenderWaiverStatus>;
  nin?: InputMaybe<Array<TenderWaiverStatus>>;
};

export type TenderWaiversCursorSearchResult = {
  __typename?: 'TenderWaiversCursorSearchResult';
  edges: Array<TenderWaiverEdge>;
  pageInfo: PageInfo;
};

export type TenderedAvailability = {
  __typename?: 'TenderedAvailability';
  days: Array<TenderedDay>;
  id: Scalars['String']['output'];
  period: Period;
  presentedAvailabilities: Array<PresentedAvailability>;
  presentedAvailability?: Maybe<PresentedAvailability>;
  remainingScope: Scalars['Float']['output'];
  scope: AvailabilityScope;
};


export type TenderedAvailabilitypresentedAvailabilityArgs = {
  presentationId: Scalars['String']['input'];
};

export type TenderedDay = {
  __typename?: 'TenderedDay';
  date: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  presentedDay?: Maybe<PresentedDay>;
  presentedDays: Array<PresentedDay>;
};


export type TenderedDaypresentedDayArgs = {
  presentationId: Scalars['String']['input'];
};

export type TenderedPriceGroup = {
  __typename?: 'TenderedPriceGroup';
  autoSelect: Scalars['Boolean']['output'];
  compensationModel?: Maybe<CompensationModel>;
  compensationModelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  departments: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  participatingOrganizations?: Maybe<Array<Organization>>;
  pricing: TenderPricing;
  professions: Array<Profession>;
  specializations: Array<Specialization>;
  suppliers?: Maybe<Array<TenderPriceGroupSupplier>>;
  tenderId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TenderPriceGroupType;
  updatedAt: Scalars['Date']['output'];
  zone?: Maybe<PriceZone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type TendersConfiguration = {
  __typename?: 'TendersConfiguration';
  /** If disabled all free text comments on shifts, resources and other objects will be disabled */
  allowFreeText: Scalars['Boolean']['output'];
  /** The attribution criteria to use for new tenders */
  attributionCriteria: Array<AttributionCriterionType>;
  /** Staffing agencies blocked by the healthcare provider */
  blockedRecipients: Array<Scalars['String']['output']>;
  /** 0 if no custom configuration has been created */
  createdAt: Scalars['Date']['output'];
  /** If enabled shift suggestion will by default be set to auto book on accept */
  defaultBookOnAcceptedSuggestion: Scalars['Boolean']['output'];
  /** Default requirements when creating a tender */
  defaultCandidateRequirements: Array<CandidateRequirementType>;
  /** Default Tender template to use for new tenders */
  defaultTenderTemplateId?: Maybe<Scalars['String']['output']>;
  employerId: Scalars['String']['output'];
  /** If set, employees can communicate with the healthcare provider through the platform */
  enableEmployeeConversations: Scalars['Boolean']['output'];
  /** If set, employees can set their availability in the platform */
  enableReportAvailability: Scalars['Boolean']['output'];
  /** If set, shifts can be published and employees can apply for them */
  enableShiftApplications: Scalars['Boolean']['output'];
  /** If set, new tenders will have time reports enabled */
  enableTimeReports: Scalars['Boolean']['output'];
  /** If set, timesheets will be created for shifts and employees will be prompted to fill them out */
  enableTimesheets: Scalars['Boolean']['output'];
  /** If set, presentations must fulfill all requirements that are marked as required */
  enforceStrictRequirements: Scalars['Boolean']['output'];
  /** If true, tenders cannot be published if shifts would exceed approved hours */
  enforceStrictWaivers: Scalars['Boolean']['output'];
  /** Equal to employerId if no custom configuration has been created */
  id: Scalars['String']['output'];
  /** If set, presentations will be hidden until the last presentation date */
  lockPresentationsUntilLastPresentationDate: Scalars['Boolean']['output'];
  /** Allowed recipient groups the healthcare provider can opt to use when communicating a tender */
  recipientTypes: Array<TenderRecipientType>;
  /** If set, new tenders will be created as requests that must be approved */
  requiresWaiver: Scalars['Boolean']['output'];
  /** 0 if no custom configuration has been created */
  updatedAt: Scalars['Date']['output'];
};

export type TendersConfigurationInput = {
  /** If disabled all free text comments on shifts, resources and other objects will be disabled */
  allowFreeText: Scalars['Boolean']['input'];
  /** The attribution criteria to use for new tenders */
  attributionCriteria: Array<AttributionCriterionType>;
  /** Staffing agencies blocked by the healthcare provider */
  blockedRecipients: Array<Scalars['String']['input']>;
  /** 0 if no custom configuration has been created */
  createdAt: Scalars['Date']['input'];
  /** If enabled shift suggestion will by default be set to auto book on accept */
  defaultBookOnAcceptedSuggestion: Scalars['Boolean']['input'];
  /** Default requirements when creating a tender */
  defaultCandidateRequirements: Array<CandidateRequirementType>;
  /** Default Tender template to use for new tenders */
  defaultTenderTemplateId?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['String']['input'];
  /** If set, employees can communicate with the healthcare provider through the platform */
  enableEmployeeConversations: Scalars['Boolean']['input'];
  /** If set, employees can set their availability in the platform */
  enableReportAvailability: Scalars['Boolean']['input'];
  /** If set, shifts can be published and employees can apply for them */
  enableShiftApplications: Scalars['Boolean']['input'];
  /** If set, new tenders will have time reports enabled */
  enableTimeReports: Scalars['Boolean']['input'];
  /** If set, timesheets will be created for shifts and employees will be prompted to fill them out */
  enableTimesheets: Scalars['Boolean']['input'];
  /** If set, presentations must fulfill all requirements that are marked as required */
  enforceStrictRequirements: Scalars['Boolean']['input'];
  /** If true, tenders cannot be published if shifts would exceed approved hours */
  enforceStrictWaivers: Scalars['Boolean']['input'];
  /** Equal to employerId if no custom configuration has been created */
  id: Scalars['String']['input'];
  /** If set, presentations will be hidden until the last presentation date */
  lockPresentationsUntilLastPresentationDate: Scalars['Boolean']['input'];
  /** Allowed recipient groups the healthcare provider can opt to use when communicating a tender */
  recipientTypes: Array<TenderRecipientType>;
  /** If set, new tenders will be created as requests that must be approved */
  requiresWaiver: Scalars['Boolean']['input'];
  /** 0 if no custom configuration has been created */
  updatedAt: Scalars['Date']['input'];
};

export type TendersCursorSearchResult = {
  __typename?: 'TendersCursorSearchResult';
  edges: Array<TenderEdge>;
  pageInfo: PageInfo;
};

export type TimeReport = {
  __typename?: 'TimeReport';
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  onCallDisturbances: Array<OnCallDisturbance>;
  reportedBreakTime: Scalars['Float']['output'];
  reportedBy: Scalars['String']['output'];
  reportedEndDateTime: Scalars['Date']['output'];
  reportedStartDateTime: Scalars['Date']['output'];
  reporter?: Maybe<Identity>;
  source: TimeReportSource;
  status: TimeReportStatus;
  timesheetId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum TimeReportSource {
  CANDIDATE = 'CANDIDATE',
  ORDERER = 'ORDERER',
  SUPPLIER = 'SUPPLIER'
}

export enum TimeReportStatus {
  ARCHIVED = 'ARCHIVED',
  ATTESTED = 'ATTESTED',
  CLOCKED_IN = 'CLOCKED_IN',
  CREATED = 'CREATED',
  REPORTED = 'REPORTED',
  RETURNED = 'RETURNED'
}

export type Timesheet = {
  __typename?: 'Timesheet';
  attestedAt?: Maybe<Scalars['Date']['output']>;
  attestedBy?: Maybe<Scalars['String']['output']>;
  /** Confirmed break time in minutes */
  breakTime?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Confirmed end datetime */
  endDateTime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Confirmed on-call disturbances */
  onCallDisturbances?: Maybe<Array<OnCallDisturbance>>;
  reports: Array<TimeReport>;
  shift?: Maybe<Shift>;
  shiftBooking?: Maybe<ShiftBooking>;
  shiftBookingId: Scalars['String']['output'];
  /** Confirmed start datetime */
  startDateTime?: Maybe<Scalars['Date']['output']>;
  status: TimeReportStatus;
  tenderInvoice?: Maybe<TenderInvoice>;
  updatedAt: Scalars['Date']['output'];
};

export type TimesheetsFilter = {
  identityId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export enum TopicType {
  CANDIDATE = 'CANDIDATE',
  TENDER = 'TENDER',
  VACANCY = 'VACANCY'
}

export type UninterruptedRestTimeViolation = {
  __typename?: 'UninterruptedRestTimeViolation';
  end: Scalars['Date']['output'];
  requiredRestTimeInMinutes: Scalars['Int']['output'];
  start: Scalars['Date']['output'];
};

export type Unit = {
  __typename?: 'Unit';
  address: Scalars['String']['output'];
  children: Array<Unit>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contactRole?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['Date']['output'];
  dayBudgets: Array<DayBudget>;
  defaultBillingInformationId?: Maybe<Scalars['String']['output']>;
  /** Departments this unit can tender */
  departments: Array<WhichDepartmentToWorkInAlternative>;
  description: Scalars['String']['output'];
  fillRate?: Maybe<Scalars['Int']['output']>;
  forecastPeriods: Array<SchedulingPeriod>;
  hasOnCall: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Abstract units are not selectable in the UI when creating tenders etc. but serves to allow grouping. */
  isAbstract: Scalars['Boolean']['output'];
  managerIds: Array<Scalars['String']['output']>;
  municipality: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextSchedulingPeriodIndex: Scalars['Int']['output'];
  numberOfEmployees: Scalars['Int']['output'];
  openingHours: Array<UnitOpeningHours>;
  /** Name of the organization owner of the unit */
  organizationId: Scalars['String']['output'];
  /** Place in the organization chart. ex. region/hospital/department/ */
  organizationKey: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  parentIds: Array<Scalars['String']['output']>;
  parents: Array<Unit>;
  pendingApplicationsCount?: Maybe<Scalars['Int']['output']>;
  pools: Array<Pool>;
  professions: Array<Profession>;
  region: WhichRegionAlternative;
  relation: UnitRelation;
  schedulingPeriod: SchedulingPeriod;
  schedulingPeriodConfiguration?: Maybe<SchedulingPeriodConfiguration>;
  schedulingPeriods: Array<SchedulingPeriod>;
  schedulingResources: Array<ScheduleResource>;
  shiftContactEmail?: Maybe<Scalars['String']['output']>;
  shiftContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  /** Only applicable to teams, direct relation to the units site parent */
  siteUnitId?: Maybe<Scalars['String']['output']>;
  staffingManagerIds: Array<Scalars['String']['output']>;
  teams?: Maybe<Array<Unit>>;
  tenderManagerIds: Array<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  type: UnitType;
  updatedAt: Scalars['Date']['output'];
  urgentVacantShiftsCount?: Maybe<Scalars['Int']['output']>;
};


export type UnitdayBudgetsArgs = {
  period?: InputMaybe<DayBudgetsPeriodInput>;
};


export type UnitforecastPeriodsArgs = {
  count: Scalars['Int']['input'];
};


export type UnitschedulingPeriodArgs = {
  index: Scalars['Int']['input'];
};

export type UnitBudget = {
  __typename?: 'UnitBudget';
  budget: Scalars['Int']['output'];
  planned: UnitBudgetPlanned;
  result: UnitBudgetResult;
  timeUnit: Scalars['String']['output'];
  timestamp: Scalars['Date']['output'];
};

export type UnitBudgetPlanned = {
  __typename?: 'UnitBudgetPlanned';
  maxPlanned: Scalars['Float']['output'];
  minPlanned: Scalars['Float']['output'];
};

export type UnitBudgetResult = {
  __typename?: 'UnitBudgetResult';
  absence: Scalars['Float']['output'];
  booked: Scalars['Float']['output'];
  external: Scalars['Float']['output'];
  unusedFlex: Scalars['Float']['output'];
  usedFlex: Scalars['Float']['output'];
  vacancies: Scalars['Float']['output'];
};

export type UnitCursorSearchResult = {
  __typename?: 'UnitCursorSearchResult';
  edges: Array<UnitEdge>;
  pageInfo: PageInfo;
};

export type UnitEdge = {
  __typename?: 'UnitEdge';
  cursor: Scalars['String']['output'];
  node: Unit;
};

export type UnitFilter = {
  AND?: InputMaybe<Array<UnitFilter>>;
  NOT?: InputMaybe<Array<UnitFilter>>;
  OR?: InputMaybe<Array<UnitFilter>>;
  address?: InputMaybe<StringComparator>;
  country?: InputMaybe<CountryComparator>;
  createdAt?: InputMaybe<DateComparator>;
  defaultBillingInformationId?: InputMaybe<IdComparator>;
  departments?: InputMaybe<DepartmentArrayComparator>;
  description?: InputMaybe<StringComparator>;
  hasUrgentShifts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdComparator>;
  isAbstract?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<IdArrayComparator>;
  municipality?: InputMaybe<MunicipalityComparator>;
  name?: InputMaybe<StringComparator>;
  organizationId?: InputMaybe<IdComparator>;
  organizationKey?: InputMaybe<StringComparator>;
  region?: InputMaybe<RegionComparator>;
  shortCode?: InputMaybe<StringComparator>;
  siteUnit?: InputMaybe<UnitFilter>;
  siteUnitId?: InputMaybe<NullableIdComparator>;
  tenderManagerIds?: InputMaybe<IdArrayComparator>;
  updatedAt?: InputMaybe<DateComparator>;
};

export type UnitOpeningHours = {
  __typename?: 'UnitOpeningHours';
  closingHours?: Maybe<Scalars['String']['output']>;
  day: Day;
  id: Scalars['String']['output'];
  openingHours?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['String']['output'];
};

export enum UnitRelation {
  CROSS_ORG = 'CROSS_ORG',
  CROSS_UNIT = 'CROSS_UNIT',
  HOME_UNIT = 'HOME_UNIT'
}

export enum UnitType {
  SITE = 'SITE',
  STRUCTURE = 'STRUCTURE',
  TEAM = 'TEAM'
}

export type UpdateAnsweredStatusInput = {
  hasAnswered: Scalars['Boolean']['input'];
  jobApplicationId: Scalars['String']['input'];
};

export type UpdateAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAttributionCriteriaInput = {
  id: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type UpdateAttributionCriterionScoringInput = {
  id: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpdateAvailabilityScopeInput = {
  scope?: InputMaybe<Scalars['Int']['input']>;
  shiftHours?: InputMaybe<Array<ShiftHours>>;
};

export type UpdateBillingInformationInput = {
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressPlace?: InputMaybe<Scalars['String']['input']>;
  billingAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingAddressStreet1?: InputMaybe<Scalars['String']['input']>;
  billingAddressStreet2?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingReference?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBroadcastMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  recipientGroups?: InputMaybe<Array<BroadcastMessageRecipientGroup>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateBookingManagersInput = {
  id: Scalars['String']['input'];
  managerIds: Array<Scalars['String']['input']>;
};

export type UpdateCandidateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bornAt?: InputMaybe<Scalars['Int']['input']>;
  contract?: InputMaybe<CandidateContractInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['Int']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  graduatedAt?: InputMaybe<Scalars['Int']['input']>;
  homeCountry?: InputMaybe<Country>;
  homeMunicipality?: InputMaybe<Scalars['String']['input']>;
  homeRegion?: InputMaybe<WhichRegionAlternative>;
  hprNumber?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<CandidateInterestsInput>;
  /** Only exists for sovereign candidates right now */
  lead?: InputMaybe<CandidateLeadInput>;
  personalIdentityNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
  qualifications?: InputMaybe<CandidateQualificationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCandidatesInput = {
  candidates: Array<UpdateCandidatesInputWithId>;
};

export type UpdateCandidatesInputWithId = {
  address?: InputMaybe<Scalars['String']['input']>;
  bornAt?: InputMaybe<Scalars['Int']['input']>;
  contract?: InputMaybe<CandidateContractInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['Int']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  graduatedAt?: InputMaybe<Scalars['Int']['input']>;
  homeCountry?: InputMaybe<Country>;
  homeMunicipality?: InputMaybe<Scalars['String']['input']>;
  homeRegion?: InputMaybe<WhichRegionAlternative>;
  hprNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  interests?: InputMaybe<CandidateInterestsInput>;
  /** Only exists for sovereign candidates right now */
  lead?: InputMaybe<CandidateLeadInput>;
  personalIdentityNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
  qualifications?: InputMaybe<CandidateQualificationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCompensationIntervalInput = {
  activity?: InputMaybe<CompensationIntervalActivity>;
  articleId?: InputMaybe<Scalars['String']['input']>;
  compensationValue?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isAdditive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  modifier?: InputMaybe<CompensationModifier>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validDays?: InputMaybe<Array<CompensationModelDay>>;
};

export type UpdateCompensationModelInput = {
  country?: InputMaybe<Country>;
  createdIntervals?: InputMaybe<Array<CreateCompensationIntervalInput>>;
  deletedIntervals?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedIntervals?: InputMaybe<Array<UpdateCompensationIntervalInput>>;
};

export type UpdateContactPreferencesInput = {
  isInterestedInContact?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInMatchingVacancies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContactedStatusInput = {
  isContacted: Scalars['Boolean']['input'];
  jobApplicationId: Scalars['String']['input'];
};

export type UpdateCustomRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDailyShiftDemandsInput = {
  day: Scalars['Int']['input'];
  demands: Array<UpdateShiftDemandInput>;
};

export type UpdateDayDemandInput = {
  allowedShifts: Array<AllowedShiftInput>;
  day: Scalars['Int']['input'];
  max: Array<Scalars['Int']['input']>;
  min: Array<Scalars['Int']['input']>;
  scheduleResourceId: Scalars['String']['input'];
};

export type UpdateDelegationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateEmploymentInput = {
  employeeId: Scalars['String']['input'];
};

export type UpdateEmploymentsInput = {
  employments: Array<UpdateEmploymentInput>;
};

export type UpdateJobApplicationStageInput = {
  jobApplicationId: Scalars['String']['input'];
  stage: JobApplicationStage;
};

export type UpdateJobPostingTemplateInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  descriptionTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  integration?: InputMaybe<JobPostingIntegration>;
  locale?: InputMaybe<Locale>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManySchedulingPeriodResourceConfigurationInput = {
  deleted: Array<Scalars['String']['input']>;
  schedulingPeriodId: Scalars['String']['input'];
  updated: Array<UpdateSchedulingPeriodResourceConfigurationInput>;
};

export type UpdateNoteInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationInterestsInput = {
  countries?: InputMaybe<Array<Country>>;
  professions?: InputMaybe<Array<Profession>>;
  regions?: InputMaybe<Array<WhichRegionAlternative>>;
  specializations?: InputMaybe<Array<Specialization>>;
};

export type UpdateOrgMemberInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledNotifications?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  org?: InputMaybe<UpdateOrgMembershipInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrgMembershipInput = {
  customRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  defaultPricing?: InputMaybe<PricingInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<EmployerFeatures>>;
  graphicProfile?: InputMaybe<GraphicProfileInput>;
  interest?: InputMaybe<InterestInput>;
  jobTypes?: InputMaybe<Array<JobType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  markets?: InputMaybe<Array<Market>>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Markets the organization recruits in. E.g. should it show up on bemlo.se? */
  recruitsIn?: InputMaybe<Array<Market>>;
  type?: InputMaybe<OrganizationType>;
};

export type UpdatePoolInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  unitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePresentationInput = {
  attributionCriterionScoring?: InputMaybe<Array<UpdateAttributionCriterionScoringInput>>;
  basePay?: InputMaybe<Scalars['Float']['input']>;
  candidateDescription?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  email?: InputMaybe<Scalars['String']['input']>;
  graduatedAt?: InputMaybe<Scalars['Float']['input']>;
  personalIdentityNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  presentedScope?: InputMaybe<Scalars['Int']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  requirementFulfillments?: InputMaybe<Array<UpdateRequirementFulfillmentInput>>;
  shiftBookingReplacingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tender shift ids */
  shifts?: InputMaybe<Array<Scalars['String']['input']>>;
  specializations?: InputMaybe<Array<Specialization>>;
  textBasedScheduleFulfillmentDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePresentedAvailabilitiesInput = {
  delete?: InputMaybe<Array<DeletePresentedAvailabilityInput>>;
  presentationId: Scalars['String']['input'];
  update?: InputMaybe<Array<UpdatePresentedAvailabilityInput>>;
};

export type UpdatePresentedAvailabilityInput = {
  days?: InputMaybe<UpdatePresentedDaysInput>;
  id: Scalars['String']['input'];
  scope?: InputMaybe<UpdateAvailabilityScopeInput>;
};

export type UpdatePresentedDaysInput = {
  create?: InputMaybe<Array<CreatePresentedDayInput>>;
  delete?: InputMaybe<Array<DeletePresentedDayInput>>;
};

export type UpdatePriceZoneInput = {
  articlePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  municipalities?: InputMaybe<Array<Municipality>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRankedCompanyInput = {
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  bayesianAverage?: InputMaybe<Scalars['Float']['input']>;
  employerId?: InputMaybe<Scalars['String']['input']>;
  ratingCount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateReferenceAnswersInput = {
  answers: ReferenceAnswersInput;
  referenceId: Scalars['String']['input'];
};

export type UpdateReferenceInput = {
  answers?: InputMaybe<ReferenceAnswersInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['String']['input'];
};

export type UpdateReferenceStatusInput = {
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isRejectedByReferer?: InputMaybe<Scalars['Boolean']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['String']['input'];
};

export type UpdateRequirementFulfillmentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for IVO | HOSP */
  fetchedAt?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentStatus?: InputMaybe<RequirementFulfillmentStatus>;
  id: Scalars['String']['input'];
  isInProgress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRequirementsInput = {
  createdRequirements?: InputMaybe<RequirementsInput>;
  deletedRequirements?: InputMaybe<RequirementsInput>;
  updatedRequirements?: InputMaybe<RequirementsInput>;
};

export type UpdateResourceAvailabilityInput = {
  endDateTime?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateScheduleDraftInput = {
  createdShifts?: InputMaybe<Array<CreateScheduleDraftShiftInput>>;
  deletedShifts?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleDraftId: Scalars['String']['input'];
  updatedResources?: InputMaybe<Array<UpdateScheduleDraftResourceInput>>;
  updatedShifts?: InputMaybe<Array<UpdateScheduleDraftShiftInput>>;
};

export type UpdateScheduleDraftResourceInput = {
  dayBreak?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  resourceConfigurationId?: InputMaybe<Scalars['String']['input']>;
  weekBreak?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduleDraftShiftInput = {
  activity?: InputMaybe<ShiftActivity>;
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  breakTime?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  onCallTime?: InputMaybe<OnCallTimeInput>;
  scheduleResourceId?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateScheduleResourceInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSchedulingPeriodActivityInput = {
  activity?: InputMaybe<ShiftActivity>;
  breakTime?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSchedulingPeriodConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Int']['input']>;
  preferencesDeadlineDaysPrior?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  schedulingDeadlineDaysPrior?: InputMaybe<Scalars['Int']['input']>;
  startsOnDay?: InputMaybe<Day>;
};

export type UpdateSchedulingPeriodDayDemandsInput = {
  days: Array<UpdateDayDemandInput>;
  schedulingPeriodId: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingPeriodInput = {
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  preferencesDeadline?: InputMaybe<Scalars['Date']['input']>;
  resourceDemandType?: InputMaybe<SchedulingPeriodResourceDemandType>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  scheduleAsFlex?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingDeadline?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateSchedulingPeriodPromptInput = {
  id: Scalars['String']['input'];
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  resourceConfigurationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSchedulingPeriodPromptsInput = {
  created: Array<CreateSchedulingPeriodPromptInput>;
  deleted: Array<Scalars['String']['input']>;
  schedulingPeriodId: Scalars['String']['input'];
  updated: Array<UpdateSchedulingPeriodPromptInput>;
};

export type UpdateSchedulingPeriodResourceConfigurationInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  dayBreak?: InputMaybe<Scalars['String']['input']>;
  fullTimeWeekly?: InputMaybe<Scalars['Float']['input']>;
  hoursBalance?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  requiredDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  serviceLevel?: InputMaybe<Scalars['Float']['input']>;
  shiftHours?: InputMaybe<Array<ShiftHours>>;
  weekBreak?: InputMaybe<Scalars['String']['input']>;
  weekendFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingPeriodShiftDemandsInput = {
  days: Array<UpdateDailyShiftDemandsInput>;
  schedulingPeriodId: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShiftDemandInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  shiftPresetId: Scalars['String']['input'];
};

export type UpdateShiftInput = {
  activity?: InputMaybe<ShiftActivity>;
  breakTime?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  onCallTime?: InputMaybe<OnCallTimeInput>;
  startDateTime?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSlotsInput = {
  jobApplicationId: Scalars['String']['input'];
  remainingSlots: Scalars['Int']['input'];
};

export type UpdateTenderInput = {
  attributionCriteria?: InputMaybe<Array<UpdateAttributionCriteriaInput>>;
  billingInformationId?: InputMaybe<Scalars['String']['input']>;
  candidateDescription?: InputMaybe<Scalars['String']['input']>;
  contactPersonUserId?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  fromTenderTemplateId?: InputMaybe<Scalars['String']['input']>;
  lastPresentationDate?: InputMaybe<Scalars['Date']['input']>;
  managerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  presentationReviewerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pricing?: InputMaybe<TenderPricing>;
  profession?: InputMaybe<Profession>;
  rows?: InputMaybe<TenderRowType>;
  scheduleDescription?: InputMaybe<Scalars['String']['input']>;
  scheduleType?: InputMaybe<TenderScheduleType>;
  scope?: InputMaybe<Scalars['Int']['input']>;
  setupRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  shiftIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt?: InputMaybe<Scalars['Date']['input']>;
  vacancyDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenderPriceGroupCompensationModelInput = {
  compensationModelId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateTenderPriceGroupInput = {
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  pricing?: InputMaybe<TenderPricing>;
  professions?: InputMaybe<Array<Profession>>;
  specializations?: InputMaybe<Array<Specialization>>;
  /** ProcuredCompany array, if not defined nothing will be changed, otherwise rewritten */
  suppliers?: InputMaybe<Array<TenderPriceGroupSupplierInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TenderPriceGroupType>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenderShiftsScheduleInput = {
  created?: InputMaybe<Array<CreateTenderedShiftInput>>;
  deleted?: InputMaybe<Array<Scalars['String']['input']>>;
  tenderId: Scalars['String']['input'];
  tendered?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTenderSupplierDecisionInput = {
  decision: TenderSupplierDecision;
  supplierId: Scalars['String']['input'];
  tenderId: Scalars['String']['input'];
};

export type UpdateTenderTemplateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
};

export type UpdateTenderWaiverInput = {
  department?: InputMaybe<WhichDepartmentToWorkInAlternative>;
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
  reviewerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleResourceId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['Int']['input']>;
  specializations?: InputMaybe<Array<Specialization>>;
  startsAt?: InputMaybe<Scalars['Date']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
  vacancyDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenderedAvailabilitiesInput = {
  delete?: InputMaybe<Array<DeleteTenderedAvailabilityInput>>;
  tenderId: Scalars['String']['input'];
  update?: InputMaybe<Array<UpdateTenderedAvailabilityInput>>;
};

export type UpdateTenderedAvailabilityInput = {
  days?: InputMaybe<UpdateTenderedDaysInput>;
  id: Scalars['String']['input'];
  scope?: InputMaybe<UpdateAvailabilityScopeInput>;
};

export type UpdateTenderedDaysInput = {
  create?: InputMaybe<Array<CreateTenderedDayInput>>;
  delete?: InputMaybe<Array<DeleteTenderedDayInput>>;
};

export type UpdateTendersConfigurationInput = {
  /** If disabled all free text comments on shifts, resources and other objects will be disabled */
  allowFreeText?: InputMaybe<Scalars['Boolean']['input']>;
  /** The attribution criteria to use for new tenders */
  attributionCriteria?: InputMaybe<Array<AttributionCriterionType>>;
  /** Staffing agencies blocked by the healthcare provider */
  blockedRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If enabled shift suggestion will by default be set to auto book on accept */
  defaultBookOnAcceptedSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default requirements when creating a tender */
  defaultCandidateRequirements?: InputMaybe<Array<CandidateRequirementType>>;
  /** Default Tender template to use for new tenders */
  defaultTenderTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** If set, employees can communicate with the healthcare provider through the platform */
  enableEmployeeConversations?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, employees can set their availability in the platform */
  enableReportAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, shifts can be published and employees can apply for them */
  enableShiftApplications?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, new tenders will have time reports enabled */
  enableTimeReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, timesheets will be created for shifts and employees will be prompted to fill them out */
  enableTimesheets?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, presentations must fulfill all requirements that are marked as required */
  enforceStrictRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, tenders cannot be published if shifts would exceed approved hours */
  enforceStrictWaivers?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, presentations will be hidden until the last presentation date */
  lockPresentationsUntilLastPresentationDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed recipient groups the healthcare provider can opt to use when communicating a tender */
  recipientTypes?: InputMaybe<Array<TenderRecipientType>>;
  /** If set, new tenders will be created as requests that must be approved */
  requiresWaiver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTendersConfigurationRecipientsInput = {
  blockedRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUnitInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  contactRole?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  defaultBillingInformationId?: InputMaybe<Scalars['String']['input']>;
  /** Departments this unit can tender */
  departments?: InputMaybe<Array<WhichDepartmentToWorkInAlternative>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasOnCall?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours: Array<UpsertUnitOpeningHoursInput>;
  /** Use own id to remove current parent */
  parentUnitId?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<WhichRegionAlternative>;
  shiftContactEmail?: InputMaybe<Scalars['String']['input']>;
  shiftContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  staffingManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenderManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Turns abstract units into usable units */
  turnReal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertUnitOpeningHoursInput = {
  closingHours?: InputMaybe<Scalars['String']['input']>;
  day: Day;
  openingHours?: InputMaybe<Scalars['String']['input']>;
};

export type UtmData = {
  __typename?: 'UtmData';
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type UtmDataInput = {
  campaign: Scalars['String']['input'];
  content: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type VacanciesCursorSearchResult = {
  __typename?: 'VacanciesCursorSearchResult';
  edges: Array<VacancyEdge>;
  pageInfo: PageInfo;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  alternativeEmployerIds?: Maybe<Array<Scalars['String']['output']>>;
  assignedTo: Array<Scalars['String']['output']>;
  bemloJobPosting?: Maybe<JobPosting>;
  country: Country;
  createdAt: Scalars['Int']['output'];
  department: WhichDepartmentToWorkInAlternative;
  description?: Maybe<Scalars['String']['output']>;
  driversLicenseRequirements: DriversLicense;
  employerId: Scalars['String']['output'];
  /** Cached calculation of vacancy salary. Assumes includeHolidayPay is true. Estimate updated on vacancy review. No additional reads required. */
  expectedCompensation?: Maybe<VacancyEstimatedCompensation>;
  experienceRequired?: Maybe<HowMuchExperienceAlternative>;
  freeTextRequirements?: Maybe<Scalars['String']['output']>;
  hasLastApplicationDate: Scalars['Boolean']['output'];
  howMuchWork?: Maybe<HowMuchWorkAlternative>;
  id: Scalars['String']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isSpecializationRequired: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  jobEndsAt?: Maybe<Scalars['Int']['output']>;
  jobPostings: Array<JobPosting>;
  jobStartsAt?: Maybe<Scalars['Int']['output']>;
  jobType: JobType;
  journalSystems: Array<JournalSystem>;
  lastApplicationDate?: Maybe<Scalars['Date']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  notes: Array<Note>;
  numberOfPublishedJobPostings: Scalars['Int']['output'];
  numberOfResources: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  origin: VacancyOrigin;
  procuredAmount?: Maybe<Scalars['Float']['output']>;
  procuredAmountCurrency?: Maybe<Currency>;
  profession: Profession;
  region: WhichRegionAlternative;
  reviewStatus: VacancyReviewStatus;
  specializations: Array<Specialization>;
  /** Staffing agencies open to receiving applications for this call request. Only available on Bemlo vacancies. */
  staffingAgencies?: Maybe<Array<Organization>>;
  status?: Maybe<VacancyStatus>;
  summary: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  tender?: Maybe<Tender>;
  tenderId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['String']['output']>;
  viewedBy?: Maybe<Array<Scalars['String']['output']>>;
  workHours: Array<WorkHours>;
};

export type VacancyApplication = {
  __typename?: 'VacancyApplication';
  acceptedAt?: Maybe<Scalars['Int']['output']>;
  announced: Scalars['Boolean']['output'];
  appliedToVacancy?: Maybe<AppliedToVacancyWrapper>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  employerId: Scalars['String']['output'];
  handledBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identityId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  rejectedAt?: Maybe<Scalars['Int']['output']>;
  status: VacancyApplicationStatus;
  vacancyId: Scalars['String']['output'];
};

export type VacancyApplicationEdge = {
  __typename?: 'VacancyApplicationEdge';
  cursor: Scalars['String']['output'];
  node: VacancyApplication;
};

export type VacancyApplicationFilter = {
  AND?: InputMaybe<Array<VacancyApplicationFilter>>;
  NOT?: InputMaybe<Array<VacancyApplicationFilter>>;
  OR?: InputMaybe<Array<VacancyApplicationFilter>>;
  candidate?: InputMaybe<CandidateFilter>;
  createdAt?: InputMaybe<DateComparator>;
  id?: InputMaybe<IdComparator>;
  identityId?: InputMaybe<IdComparator>;
  vacancy?: InputMaybe<VacancyFilter>;
  vacancyId?: InputMaybe<IdComparator>;
};

export enum VacancyApplicationStatus {
  AWAITING_REVIEW = 'AWAITING_REVIEW',
  COMPLETED = 'COMPLETED',
  IGNORED = 'IGNORED',
  NEW = 'NEW',
  SENT = 'SENT',
  TIMED_OUT = 'TIMED_OUT'
}

export type VacancyApplicationsCursorSearchResult = {
  __typename?: 'VacancyApplicationsCursorSearchResult';
  edges: Array<VacancyApplicationEdge>;
  pageInfo: PageInfo;
};

export type VacancyEdge = {
  __typename?: 'VacancyEdge';
  cursor: Scalars['String']['output'];
  node: Vacancy;
};

export type VacancyEstimatedCompensation = {
  __typename?: 'VacancyEstimatedCompensation';
  high: Scalars['Float']['output'];
  low: Scalars['Float']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type VacancyFilter = {
  AND?: InputMaybe<Array<VacancyFilter>>;
  NOT?: InputMaybe<Array<VacancyFilter>>;
  OR?: InputMaybe<Array<VacancyFilter>>;
  assignedTo?: InputMaybe<IdArrayComparator>;
  country?: InputMaybe<CountryComparator>;
  createdAt?: InputMaybe<DateComparator>;
  department?: InputMaybe<DepartmentComparator>;
  description?: InputMaybe<StringComparator>;
  driversLicenseRequirements?: InputMaybe<DriversLicenseComparator>;
  freeTextRequirements?: InputMaybe<StringComparator>;
  hasJobPostingsOn?: InputMaybe<JobPostingIntegrationArrayComparator>;
  hasLastApplicationDate?: InputMaybe<Scalars['Boolean']['input']>;
  howMuchWork?: InputMaybe<HowMuchWorkComparator>;
  id?: InputMaybe<IdComparator>;
  information?: InputMaybe<StringComparator>;
  internalComment?: InputMaybe<StringComparator>;
  isSpecializationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  jobEndsAt?: InputMaybe<DateComparator>;
  jobStartsAt?: InputMaybe<DateComparator>;
  jobType?: InputMaybe<JobTypeComparator>;
  journalSystems?: InputMaybe<JournalSystemArrayComparator>;
  lastApplicationDate?: InputMaybe<NullableDateComparator>;
  municipality?: InputMaybe<MunicipalityComparator>;
  numberOfResources?: InputMaybe<NumberComparator>;
  origin?: InputMaybe<VacancyOriginComparator>;
  partialId?: InputMaybe<StringComparator>;
  procuredAmount?: InputMaybe<NumberComparator>;
  profession?: InputMaybe<ProfessionComparator>;
  region?: InputMaybe<RegionComparator>;
  reviewStatus?: InputMaybe<VacancyReviewStatusComparator>;
  specializations?: InputMaybe<SpecializationArrayComparator>;
  status?: InputMaybe<VacancyStatusComparator>;
  tender?: InputMaybe<TenderFilter>;
  tenderId?: InputMaybe<IdComparator>;
  title?: InputMaybe<StringComparator>;
  unit?: InputMaybe<UnitFilter>;
  unitId?: InputMaybe<IdComparator>;
  viewedBy?: InputMaybe<IdArrayComparator>;
  workHours?: InputMaybe<WorkHoursArrayComparator>;
};

export enum VacancyOrigin {
  CALL_REQUEST = 'CALL_REQUEST',
  MANUAL = 'MANUAL',
  TENDER = 'TENDER'
}

export type VacancyOriginComparator = {
  eq?: InputMaybe<VacancyOrigin>;
  in?: InputMaybe<Array<VacancyOrigin>>;
  neq?: InputMaybe<VacancyOrigin>;
  nin?: InputMaybe<Array<VacancyOrigin>>;
};

export enum VacancyReviewStatus {
  APPROVED = 'APPROVED',
  AUTO_APPROVED = 'AUTO_APPROVED',
  IN_REVIEW = 'IN_REVIEW',
  REJECTED = 'REJECTED'
}

export type VacancyReviewStatusComparator = {
  eq?: InputMaybe<VacancyReviewStatus>;
  in?: InputMaybe<Array<VacancyReviewStatus>>;
  neq?: InputMaybe<VacancyReviewStatus>;
  nin?: InputMaybe<Array<VacancyReviewStatus>>;
};

export enum VacancyStatus {
  CLOSED = 'CLOSED',
  FILLED = 'FILLED',
  OPEN = 'OPEN',
  UNKNOWN = 'UNKNOWN'
}

export type VacancyStatusComparator = {
  eq?: InputMaybe<VacancyStatus>;
  in?: InputMaybe<Array<VacancyStatus>>;
  neq?: InputMaybe<VacancyStatus>;
  nin?: InputMaybe<Array<VacancyStatus>>;
};

export type VacantShiftPresentations = {
  __typename?: 'VacantShiftPresentations';
  id: Scalars['String']['output'];
  presentationId: Scalars['String']['output'];
};

export type VacantTenderShift = {
  __typename?: 'VacantTenderShift';
  activity: ShiftActivity;
  breakTime: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['String']['output'];
  endDateTime: Scalars['Date']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  onCallTime?: Maybe<OnCallTime>;
  presentationShifts: Array<VacantShiftPresentations>;
  row: Scalars['Int']['output'];
  scheduleResourceId: Scalars['String']['output'];
  scheduleSlotId: Scalars['String']['output'];
  shiftIds: Array<Scalars['String']['output']>;
  startDateTime: Scalars['Date']['output'];
  startTime: Scalars['String']['output'];
  status: VacantTenderShiftStatus;
  tags: Array<Tag>;
  tenderId: Scalars['String']['output'];
  tenderShiftIds: Array<Scalars['String']['output']>;
};

export enum VacantTenderShiftStatus {
  DRAFT = 'DRAFT',
  PRESENTED = 'PRESENTED',
  VACANT = 'VACANT'
}

export enum WhichDepartmentToWorkInAlternative {
  AKUTSJUKVARD = 'AKUTSJUKVARD',
  AMBULANS = 'AMBULANS',
  ASIH = 'ASIH',
  BARNMEDICIN = 'BARNMEDICIN',
  BARNONKOLOGEN = 'BARNONKOLOGEN',
  BARN_OCH_UNGDOM = 'BARN_OCH_UNGDOM',
  BAVA = 'BAVA',
  CENTER = 'CENTER',
  DEMENS = 'DEMENS',
  DEPARTMENT = 'DEPARTMENT',
  DIALYSMOTTAGNING = 'DIALYSMOTTAGNING',
  FORLOSSNING = 'FORLOSSNING',
  GASTROAVDELNING = 'GASTROAVDELNING',
  GERIATRIK = 'GERIATRIK',
  GYNEKOLOGDEPARTMENT = 'GYNEKOLOGDEPARTMENT',
  HALSOCENTRAL = 'HALSOCENTRAL',
  HEMSJUKVARD = 'HEMSJUKVARD',
  HIA = 'HIA',
  HJARTAVDELNING = 'HJARTAVDELNING',
  INFEKTION = 'INFEKTION',
  IVA = 'IVA',
  JOURCENTRAL = 'JOURCENTRAL',
  KIRURGI = 'KIRURGI',
  KVINNOKLINIK = 'KVINNOKLINIK',
  LUNGAVDELNING = 'LUNGAVDELNING',
  MAMMOGRAFI = 'MAMMOGRAFI',
  MAVA = 'MAVA',
  MEDICIN = 'MEDICIN',
  MUNICIPAL = 'MUNICIPAL',
  NARAKUT = 'NARAKUT',
  NEONATAL = 'NEONATAL',
  NEUROLOGI = 'NEUROLOGI',
  NJURAVDELNING = 'NJURAVDELNING',
  ONH_MOTTAGNING = 'ONH_MOTTAGNING',
  ONKOLOGEN = 'ONKOLOGEN',
  OPEN_FOR_ANYTHING = 'OPEN_FOR_ANYTHING',
  OPERATION = 'OPERATION',
  ORTOPEDEN = 'ORTOPEDEN',
  POSTOPERATION = 'POSTOPERATION',
  PSYKIATRI = 'PSYKIATRI',
  RADIOLOGEN = 'RADIOLOGEN',
  REHABILITERING = 'REHABILITERING',
  REUMATOLOGI = 'REUMATOLOGI',
  SABO = 'SABO',
  SJUKSTUGA = 'SJUKSTUGA',
  SKOLSJUKVARD = 'SKOLSJUKVARD',
  TELEFONRADGIVNING = 'TELEFONRADGIVNING',
  THORAXKIRURGEN = 'THORAXKIRURGEN',
  VACCINERING = 'VACCINERING',
  VARDCENTRAL = 'VARDCENTRAL'
}

export enum WhichRegionAlternative {
  AGDER = 'AGDER',
  ALL = 'ALL',
  BLEKINGE = 'BLEKINGE',
  DALARNA = 'DALARNA',
  GAVLEBORG = 'GAVLEBORG',
  GOTLAND = 'GOTLAND',
  HALLAND = 'HALLAND',
  INNLANDET = 'INNLANDET',
  JAMTLAND_HARJEDALEN = 'JAMTLAND_HARJEDALEN',
  JONKOPING = 'JONKOPING',
  KALMAR = 'KALMAR',
  KRONOBERG = 'KRONOBERG',
  MORE_OG_ROMSDAL = 'MORE_OG_ROMSDAL',
  NONE = 'NONE',
  NORDLAND = 'NORDLAND',
  NORRBOTTEN = 'NORRBOTTEN',
  OREBRO = 'OREBRO',
  OSLO = 'OSLO',
  OSTERGOTLAND = 'OSTERGOTLAND',
  ROGALAND = 'ROGALAND',
  SKANE = 'SKANE',
  SORMLAND = 'SORMLAND',
  SOUTH_WEST_ENGLAND = 'SOUTH_WEST_ENGLAND',
  STOCKHOLM = 'STOCKHOLM',
  TROMS_OG_FINNMARK = 'TROMS_OG_FINNMARK',
  TRONDELAG = 'TRONDELAG',
  UPPSALA = 'UPPSALA',
  VARMLAND = 'VARMLAND',
  VASTERBOTTEN = 'VASTERBOTTEN',
  VASTERNORRLAND = 'VASTERNORRLAND',
  VASTMANLAND = 'VASTMANLAND',
  VASTRAGOTALAND = 'VASTRAGOTALAND',
  VESTFOLD_OG_TELEMARK = 'VESTFOLD_OG_TELEMARK',
  VESTLAND = 'VESTLAND',
  VIKEN = 'VIKEN'
}

export type WithdrawShiftApplicationInput = {
  shiftApplicationId: Scalars['String']['input'];
};

export enum WorkForm {
  ENTREPRENEUR = 'ENTREPRENEUR',
  HOURLY_WORKER = 'HOURLY_WORKER',
  OPEN_TO_BOTH = 'OPEN_TO_BOTH'
}

export type WorkFormArrayComparator = {
  all?: InputMaybe<Array<WorkForm>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<WorkForm>>;
  has?: InputMaybe<WorkForm>;
  some?: InputMaybe<Array<WorkForm>>;
};

export { WorkHours };

export type WorkHoursArrayComparator = {
  all?: InputMaybe<Array<WorkHours>>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Array<WorkHours>>;
  has?: InputMaybe<WorkHours>;
  some?: InputMaybe<Array<WorkHours>>;
};

export enum WorkPlaceRelationshipToApplicant {
  COWORKER = 'COWORKER',
  SUBORDINATE = 'SUBORDINATE',
  SUPERIOR = 'SUPERIOR'
}

export enum WouldRecommend {
  NO = 'NO',
  YES = 'YES'
}

export type ignoreJobApplicationInput = {
  jobApplicationId: Scalars['String']['input'];
};

export type SenderFragment = { __typename?: 'Identity', id: string, fullName: string, email: string };

export type ContactRequestFragment = { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null };

export type ConnectionFragment = { __typename?: 'AbstractConnection', id: string, createdAt: number, employerId: string, status: ConnectionStatus, contactRequest?: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } | null, organization: { __typename?: 'Organization', id: string, displayName: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null }, company?: { __typename?: 'RankedCompany', id: string, market: Market, averageRating: number, reviewCount: number } | null };

export type ReadContactRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadContactRequestMutation = { __typename?: 'Mutation', readContactRequest: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } };

export type ContextCompanyFragment = { __typename?: 'Organization', id: string, companyRating: { __typename?: 'CompanyRating', averageRating: number, bayesScore: number, reviewCount: number } };

export type GetContextCompaniesQueryVariables = Exact<{
  markets: Array<Market> | Market;
  reviewsFrom: Array<Market> | Market;
}>;


export type GetContextCompaniesQuery = { __typename?: 'Query', allRecruitingOrganizations: Array<{ __typename?: 'Organization', id: string, companyRating: { __typename?: 'CompanyRating', averageRating: number, bayesScore: number, reviewCount: number } }> };

export type GetContextCompaniesWithReviewsQueryVariables = Exact<{
  markets: Array<Market> | Market;
  reviewsFrom: Array<Market> | Market;
}>;


export type GetContextCompaniesWithReviewsQuery = { __typename?: 'Query', allRecruitingOrganizations: Array<{ __typename?: 'Organization', id: string, reviews: Array<{ __typename?: 'CompanyReview', createdAt: number, freeText: string, id: string, isSpam?: boolean | null, market: Market, name?: string | null, profession: Profession, rating?: number | null, companyReply?: { __typename?: 'Reply', createdAt: number, freeText: string } | null }>, companyRating: { __typename?: 'CompanyRating', averageRating: number, bayesScore: number, reviewCount: number } }> };

export type BaseJobPostingFragment = { __typename?: 'JobPosting', id: string, descriptionHtml: string, description: string, title: string };

export type ContactOnJobPostingMutationVariables = Exact<{
  input: ContactOnJobPostingInput;
}>;


export type ContactOnJobPostingMutation = { __typename?: 'Mutation', contactOnJobPosting: boolean };

export type GetCommentsQueryVariables = Exact<{
  blogPostSlug: Scalars['String']['input'];
}>;


export type GetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, name: string, isModerator: boolean, createdAt: number, profession?: Profession | null, freeText: string, parentCommentId?: string | null }> };

export type GetBankIdTransactionQueryVariables = Exact<{
  orderRef: Scalars['String']['input'];
}>;


export type GetBankIdTransactionQuery = { __typename?: 'Query', findBankIdTransaction: { __typename?: 'BankIdTransaction', orderRef: string, status: BankIdTransactionStatus, hintCode?: string | null } };

export type SalaryMetadataOptionsFragment = { __typename?: 'AggregatedSalariesMetadata', options: { __typename?: 'SalariesOptionsMap', NURSE: Array<{ __typename?: 'NurseOptions', specialization: NurseSpecialization, country: Country, region?: Region | null }>, DOCTOR: Array<{ __typename?: 'DoctorOptions', specialization: DoctorSpecialization, country: Country, region?: Region | null }> } };

export type GetAggregatedSalaryMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAggregatedSalaryMetadataQuery = { __typename?: 'Query', salariesMetadata: { __typename?: 'AggregatedSalariesMetadata', aggregatedAt: number, numberOfReportedSalaries: number, options: { __typename?: 'SalariesOptionsMap', NURSE: Array<{ __typename?: 'NurseOptions', specialization: NurseSpecialization, country: Country, region?: Region | null }>, DOCTOR: Array<{ __typename?: 'DoctorOptions', specialization: DoctorSpecialization, country: Country, region?: Region | null }> } } };

export type GetNumberOfReportedSalariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNumberOfReportedSalariesQuery = { __typename?: 'Query', salariesMetadata: { __typename?: 'AggregatedSalariesMetadata', numberOfReportedSalaries: number } };

export type FetchSalaryDataQueryVariables = Exact<{
  profession: Profession;
  country: Country;
  region: Region;
}>;


export type FetchSalaryDataQuery = { __typename?: 'Query', salaryStatisics: { __typename?: 'SalaryStatisticsGroups', noSpecializationSalaryGroup?: { __typename?: 'AggregatedSalaryGroup', values: Array<number> } | null, genericSpecializationSalaryGroup?: { __typename?: 'AggregatedSalaryGroup', values: Array<number> } | null } };

export type AcceptContactRequestMutationVariables = Exact<{
  employerId: Scalars['String']['input'];
}>;


export type AcceptContactRequestMutation = { __typename?: 'Mutation', acceptContactRequest: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, connection: { __typename?: 'AbstractConnection', id: string, createdAt: number, employerId: string, status: ConnectionStatus, contactRequest?: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } | null, organization: { __typename?: 'Organization', id: string, displayName: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null }, company?: { __typename?: 'RankedCompany', id: string, market: Market, averageRating: number, reviewCount: number } | null }, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } };

export type RejectContactRequestMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['String']['input'];
  reason?: InputMaybe<ContactRequestRejectionReason>;
}>;


export type RejectContactRequestMutation = { __typename?: 'Mutation', rejectContactRequest: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } };

export type CreateCommentMutationVariables = Exact<{
  blogPostSlug: Scalars['String']['input'];
  freeText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: string };

export type CreateReplyMutationVariables = Exact<{
  blogPostSlug: Scalars['String']['input'];
  freeText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCommentId: Scalars['String']['input'];
}>;


export type CreateReplyMutation = { __typename?: 'Mutation', createReply: string };

export type CreateSalaryMutationVariables = Exact<{
  jobType: JobType;
  gender?: InputMaybe<Gender>;
  age?: InputMaybe<Scalars['Int']['input']>;
  profession: Profession;
  specialization?: InputMaybe<Specialization>;
  experience: Scalars['String']['input'];
  country: Country;
  region?: InputMaybe<Region>;
  company: Scalars['String']['input'];
  workplace: Scalars['String']['input'];
  workForm: WorkForm;
  baseSalary: Scalars['Int']['input'];
  ob: Scalars['Boolean']['input'];
  obEvening?: InputMaybe<Scalars['Int']['input']>;
  obNight?: InputMaybe<Scalars['Int']['input']>;
  obWeekend?: InputMaybe<Scalars['Int']['input']>;
  obLongWeekend?: InputMaybe<Scalars['Int']['input']>;
  vacationIncluded: Scalars['Boolean']['input'];
  tjanstePension: Scalars['Boolean']['input'];
  summerJob?: InputMaybe<Scalars['Boolean']['input']>;
  hasPerks: Scalars['Boolean']['input'];
  perks?: InputMaybe<Array<Perk> | Perk>;
  otherPerk?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSalaryMutation = { __typename?: 'Mutation', createSalary: { __typename?: 'Salary', documentId?: string | null } };

export type SubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  profession: Profession;
  origin: Scalars['String']['input'];
  market: Market;
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'Mutation', subscribeToNewsletter: boolean };

export type CurrentJobApplicationFragment = { __typename?: 'JobApplication', createdAt: number, firstSentAt?: number | null, status: JobApplicationStatus };

export type FileUploadFragment = { __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType };

export type CandidateCommentFragment = { __typename?: 'CandidateComment', id: string, field?: string | null, comment: string };

export type MyInterestsFragment = { __typename?: 'CandidateInterests', countries?: Array<Country> | null, departments?: Array<WhichDepartmentToWorkInAlternative> | null, jobTypes?: Array<JobType> | null, municipalities?: Array<Municipality> | null, regions?: Array<WhichRegionAlternative> | null, weekInterests?: Array<string> | null, workForms?: Array<WorkForm> | null };

export type MyQualificationsFragment = { __typename?: 'CandidateQualifications', specializations?: Array<Specialization> | null, journalSystems?: Array<JournalSystem> | null, driversLicenses?: Array<DriversLicense> | null, swedishLicenseStatus?: LicenseStatus | null, norwegianLicenseStatus?: LicenseStatus | null };

export type MyLeadFragment = { __typename?: 'CandidateLead', employmentStatus?: CurrentEmploymentStatus | null, extent?: HowMuchWorkAlternative | null, startDate?: number | null, karens?: Array<WhichRegionAlternative> | null };

export type MyCandidateBaseFragment = { __typename?: 'Candidate', address?: string | null, description?: string | null, email?: string | null, fullName: string, homeCountry?: Country | null, homeMunicipality?: string | null, homeRegion?: WhichRegionAlternative | null, phoneNumber?: string | null, profession: Profession, experience?: number | null, hprNumber?: string | null };

export type MyCandidateFragment = { __typename?: 'Candidate', id: string, updatedAt: number, personalIdentityNumberUpdatedAt?: number | null, personalIdentityNumberSource?: string | null, address?: string | null, description?: string | null, email?: string | null, fullName: string, homeCountry?: Country | null, homeMunicipality?: string | null, homeRegion?: WhichRegionAlternative | null, phoneNumber?: string | null, profession: Profession, experience?: number | null, hprNumber?: string | null, interests: { __typename?: 'CandidateInterests', countries?: Array<Country> | null, departments?: Array<WhichDepartmentToWorkInAlternative> | null, jobTypes?: Array<JobType> | null, municipalities?: Array<Municipality> | null, regions?: Array<WhichRegionAlternative> | null, weekInterests?: Array<string> | null, workForms?: Array<WorkForm> | null }, qualifications: { __typename?: 'CandidateQualifications', specializations?: Array<Specialization> | null, journalSystems?: Array<JournalSystem> | null, driversLicenses?: Array<DriversLicense> | null, swedishLicenseStatus?: LicenseStatus | null, norwegianLicenseStatus?: LicenseStatus | null }, lead?: { __typename?: 'CandidateLead', employmentStatus?: CurrentEmploymentStatus | null, extent?: HowMuchWorkAlternative | null, startDate?: number | null, karens?: Array<WhichRegionAlternative> | null } | null, comments?: Array<{ __typename?: 'CandidateComment', id: string, field?: string | null, comment: string }> | null, fileUploads: Array<{ __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType }> };

export type ContactPreferencesFragment = { __typename?: 'ContactPreferences', isInterestedInContact: boolean, isInterestedInMatchingVacancies?: boolean | null };

export type ProfessionalIdentityFragment = { __typename?: 'Identity', id: string, createdAt: any, updatedAt: any, email: string, fullName: string, phoneNumber?: string | null, contactPreferences?: { __typename?: 'ContactPreferences', isInterestedInContact: boolean, isInterestedInMatchingVacancies?: boolean | null } | null, candidate?: { __typename?: 'Candidate', id: string, updatedAt: number, personalIdentityNumberUpdatedAt?: number | null, personalIdentityNumberSource?: string | null, address?: string | null, description?: string | null, email?: string | null, fullName: string, homeCountry?: Country | null, homeMunicipality?: string | null, homeRegion?: WhichRegionAlternative | null, phoneNumber?: string | null, profession: Profession, experience?: number | null, hprNumber?: string | null, interests: { __typename?: 'CandidateInterests', countries?: Array<Country> | null, departments?: Array<WhichDepartmentToWorkInAlternative> | null, jobTypes?: Array<JobType> | null, municipalities?: Array<Municipality> | null, regions?: Array<WhichRegionAlternative> | null, weekInterests?: Array<string> | null, workForms?: Array<WorkForm> | null }, qualifications: { __typename?: 'CandidateQualifications', specializations?: Array<Specialization> | null, journalSystems?: Array<JournalSystem> | null, driversLicenses?: Array<DriversLicense> | null, swedishLicenseStatus?: LicenseStatus | null, norwegianLicenseStatus?: LicenseStatus | null }, lead?: { __typename?: 'CandidateLead', employmentStatus?: CurrentEmploymentStatus | null, extent?: HowMuchWorkAlternative | null, startDate?: number | null, karens?: Array<WhichRegionAlternative> | null } | null, comments?: Array<{ __typename?: 'CandidateComment', id: string, field?: string | null, comment: string }> | null, fileUploads: Array<{ __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType }> } | null, connections: Array<{ __typename?: 'AbstractConnection', id: string, createdAt: number, employerId: string, status: ConnectionStatus, contactRequest?: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } | null, organization: { __typename?: 'Organization', id: string, displayName: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null }, company?: { __typename?: 'RankedCompany', id: string, market: Market, averageRating: number, reviewCount: number } | null }>, jobApplications: Array<{ __typename?: 'JobApplication', createdAt: number, firstSentAt?: number | null, status: JobApplicationStatus }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Identity', id: string, createdAt: any, updatedAt: any, email: string, fullName: string, phoneNumber?: string | null, contactPreferences?: { __typename?: 'ContactPreferences', isInterestedInContact: boolean, isInterestedInMatchingVacancies?: boolean | null } | null, candidate?: { __typename?: 'Candidate', id: string, updatedAt: number, personalIdentityNumberUpdatedAt?: number | null, personalIdentityNumberSource?: string | null, address?: string | null, description?: string | null, email?: string | null, fullName: string, homeCountry?: Country | null, homeMunicipality?: string | null, homeRegion?: WhichRegionAlternative | null, phoneNumber?: string | null, profession: Profession, experience?: number | null, hprNumber?: string | null, interests: { __typename?: 'CandidateInterests', countries?: Array<Country> | null, departments?: Array<WhichDepartmentToWorkInAlternative> | null, jobTypes?: Array<JobType> | null, municipalities?: Array<Municipality> | null, regions?: Array<WhichRegionAlternative> | null, weekInterests?: Array<string> | null, workForms?: Array<WorkForm> | null }, qualifications: { __typename?: 'CandidateQualifications', specializations?: Array<Specialization> | null, journalSystems?: Array<JournalSystem> | null, driversLicenses?: Array<DriversLicense> | null, swedishLicenseStatus?: LicenseStatus | null, norwegianLicenseStatus?: LicenseStatus | null }, lead?: { __typename?: 'CandidateLead', employmentStatus?: CurrentEmploymentStatus | null, extent?: HowMuchWorkAlternative | null, startDate?: number | null, karens?: Array<WhichRegionAlternative> | null } | null, comments?: Array<{ __typename?: 'CandidateComment', id: string, field?: string | null, comment: string }> | null, fileUploads: Array<{ __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType }> } | null, connections: Array<{ __typename?: 'AbstractConnection', id: string, createdAt: number, employerId: string, status: ConnectionStatus, contactRequest?: { __typename?: 'ContactRequest', id: string, createdBy: string, createdAt: number, acceptedAt?: number | null, contactRequestOpenedAt?: number | null, emailSentAt?: number | null, employerId: string, noteFromEmployer?: string | null, profileId: string, rejectedAt?: number | null, rejectionComment?: string | null, rejectionReason?: ContactRequestRejectionReason | null, sentBy: string, status: ContactRequestStatus, textSentAt?: number | null, vacancyIds?: Array<string> | null, numberOfMatchingVacancies: number, sender?: { __typename?: 'Identity', id: string, fullName: string, email: string } | null } | null, organization: { __typename?: 'Organization', id: string, displayName: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null }, company?: { __typename?: 'RankedCompany', id: string, market: Market, averageRating: number, reviewCount: number } | null }>, jobApplications: Array<{ __typename?: 'JobApplication', createdAt: number, firstSentAt?: number | null, status: JobApplicationStatus }> } };

export type RegisterMutationVariables = Exact<{
  input: RegisterProfessionalInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', registerProfessional: string };

export type RegisterFileUploadMutationVariables = Exact<{
  uploadType: FileUploadType;
  referenceUrl: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterFileUploadMutation = { __typename?: 'Mutation', registerFileUpload: { __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType } };

export type UpdateFileUploadMutationVariables = Exact<{
  fileUploadId: Scalars['String']['input'];
  referenceUrl: Scalars['String']['input'];
}>;


export type UpdateFileUploadMutation = { __typename?: 'Mutation', updateFileUpload: { __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType } };

export type DeleteFileUploadMutationVariables = Exact<{
  fileUploadId: Scalars['String']['input'];
}>;


export type DeleteFileUploadMutation = { __typename?: 'Mutation', deleteFileUpload: boolean };

export type RequestMoreContactsMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestMoreContactsMutation = { __typename?: 'Mutation', requestMoreContacts: boolean };

export type ApplyToEmployerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApplyToEmployerMutation = { __typename?: 'Mutation', applyToEmployer: boolean };

export type CreateJobApplicationMutationVariables = Exact<{
  employerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobApplicationMutation = { __typename?: 'Mutation', createJobApplication: string };

export type AuthenticateProfileWithBankIdMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateProfileWithBankIdMutation = { __typename?: 'Mutation', authenticateWithBankId: { __typename?: 'BankIdOrder', orderRef: string, autoStartToken: string } };

export type DeleteProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteProfileMutation = { __typename?: 'Mutation', deleteOwnProfile: string };

export type CreateReferenceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReferenceMutation = { __typename?: 'Mutation', inviteReference: { __typename?: 'Reference', id: string } };

export type UpdateReferenceMutationVariables = Exact<{
  referenceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdateReferenceMutation = { __typename?: 'Mutation', updateReference: { __typename?: 'Reference', id: string } };

export type UpdateReferenceStatusMutationVariables = Exact<{
  referenceId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  isOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRejectedByReferer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReferenceStatusMutation = { __typename?: 'Mutation', updateReferenceStatus: { __typename?: 'Reference', id: string } };

export type DeleteReferenceMutationVariables = Exact<{
  referenceId: Scalars['String']['input'];
}>;


export type DeleteReferenceMutation = { __typename?: 'Mutation', deleteReference: boolean };

export type GetReferencesByProfileIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferencesByProfileIdQuery = { __typename?: 'Query', myReferences: Array<{ __typename?: 'Reference', id: string, name: string, createdAt: number, completedAt?: number | null }> };

export type GetReferenceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetReferenceByIdQuery = { __typename?: 'Query', reference: { __typename?: 'Reference', id: string, referentId: string, name: string, email?: string | null, phoneNumber?: string | null, createdAt: number, completedAt?: number | null, referentName?: string | null, answers?: { __typename?: 'ReferenceAnswers', workPlaceRelationshipToApplicant?: WorkPlaceRelationshipToApplicant | null, wouldRecommend?: WouldRecommend | null } | null } };

export type UpdateReferenceAnswersMutationVariables = Exact<{
  referenceAnswersInput: ReferenceAnswersInput;
  id: Scalars['String']['input'];
}>;


export type UpdateReferenceAnswersMutation = { __typename?: 'Mutation', updateReferenceAnswers: { __typename?: 'Reference', id: string } };

export type ReviewFragment = { __typename?: 'CompanyReview', createdAt: number, freeText: string, id: string, isSpam?: boolean | null, market: Market, name?: string | null, profession: Profession, rating?: number | null, companyReply?: { __typename?: 'Reply', createdAt: number, freeText: string } | null };

export type GetReviewsQueryVariables = Exact<{
  employerId: Scalars['String']['input'];
  markets: Array<Market> | Market;
}>;


export type GetReviewsQuery = { __typename?: 'Query', reviews: Array<{ __typename?: 'CompanyReview', createdAt: number, freeText: string, id: string, isSpam?: boolean | null, market: Market, name?: string | null, profession: Profession, rating?: number | null, companyReply?: { __typename?: 'Reply', createdAt: number, freeText: string } | null }> };

export type CreateReviewMutationVariables = Exact<{
  data: CreateCompanyReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'BankIdOrder', autoStartToken: string, orderRef: string } };

export type CreateReviewWithoutBankIdMutationVariables = Exact<{
  data: CreateCompanyReviewInput;
}>;


export type CreateReviewWithoutBankIdMutation = { __typename?: 'Mutation', createReviewWithoutBankId: string };

export type UpdateCandidateInformationMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  comments: Array<CreateCandidateCommentInput> | CreateCandidateCommentInput;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['Int']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  homeMunicipality?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<CandidateInterestsInput>;
  lead?: InputMaybe<CandidateLeadInput>;
  personalIdentityNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Profession>;
  qualifications?: InputMaybe<CandidateQualificationsInput>;
  hprNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCandidateInformationMutation = { __typename?: 'Mutation', updateCandidate: { __typename?: 'Candidate', id: string, updatedAt: number, personalIdentityNumberUpdatedAt?: number | null, personalIdentityNumberSource?: string | null, address?: string | null, description?: string | null, email?: string | null, fullName: string, homeCountry?: Country | null, homeMunicipality?: string | null, homeRegion?: WhichRegionAlternative | null, phoneNumber?: string | null, profession: Profession, experience?: number | null, hprNumber?: string | null, interests: { __typename?: 'CandidateInterests', countries?: Array<Country> | null, departments?: Array<WhichDepartmentToWorkInAlternative> | null, jobTypes?: Array<JobType> | null, municipalities?: Array<Municipality> | null, regions?: Array<WhichRegionAlternative> | null, weekInterests?: Array<string> | null, workForms?: Array<WorkForm> | null }, qualifications: { __typename?: 'CandidateQualifications', specializations?: Array<Specialization> | null, journalSystems?: Array<JournalSystem> | null, driversLicenses?: Array<DriversLicense> | null, swedishLicenseStatus?: LicenseStatus | null, norwegianLicenseStatus?: LicenseStatus | null }, lead?: { __typename?: 'CandidateLead', employmentStatus?: CurrentEmploymentStatus | null, extent?: HowMuchWorkAlternative | null, startDate?: number | null, karens?: Array<WhichRegionAlternative> | null } | null, comments?: Array<{ __typename?: 'CandidateComment', id: string, field?: string | null, comment: string }> | null, fileUploads: Array<{ __typename?: 'FileUpload', comment?: string | null, id: string, referenceUrl: string, uploadedAt: number, uploadType: FileUploadType }> }, createCandidateComments: Array<{ __typename?: 'CandidateComment', id: string, field?: string | null, comment: string }> };

export type UpdateContactPreferencesMutationVariables = Exact<{
  data: UpdateContactPreferencesInput;
}>;


export type UpdateContactPreferencesMutation = { __typename?: 'Mutation', updateContactPreferences: { __typename?: 'ContactPreferences', isInterestedInContact: boolean, isInterestedInMatchingVacancies?: boolean | null } };

export type VacancyFragment = { __typename?: 'Vacancy', createdAt: number, country: Country, department: WhichDepartmentToWorkInAlternative, employerId: string, howMuchWork?: HowMuchWorkAlternative | null, id: string, isSpecializationRequired: boolean, jobEndsAt?: number | null, jobStartsAt?: number | null, lastApplicationDate?: any | null, municipality?: string | null, profession: Profession, region: WhichRegionAlternative, specializations: Array<Specialization>, summary: string, bemloJobPosting?: { __typename?: 'JobPosting', id: string, descriptionHtml: string, description: string, title: string } | null, expectedCompensation?: { __typename?: 'VacancyEstimatedCompensation', high: number, low: number } | null, organization: { __typename?: 'Organization', id: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null } };

export type GetEmployersForVacancyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEmployersForVacancyQuery = { __typename?: 'Query', vacancy: { __typename?: 'Vacancy', id: string, profession: Profession, alternativeEmployerIds?: Array<string> | null, staffingAgencies?: Array<{ __typename?: 'Organization', id: string, displayName: string, graphicProfile?: { __typename?: 'GraphicProfile', logoUrl?: string | null } | null }> | null } };

export type ApplyToVacancyMutationVariables = Exact<{
  employerId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
}>;


export type ApplyToVacancyMutation = { __typename?: 'Mutation', applyToVacancy: { __typename?: 'VacancyApplication', id: string, employerId: string, identityId: string, status: VacancyApplicationStatus } };

export const ContextCompanyFragmentDoc = gql`
    fragment ContextCompany on Organization {
  id
  companyRating(markets: $reviewsFrom) {
    averageRating
    bayesScore
    reviewCount
  }
}
    `;
export const SalaryMetadataOptionsFragmentDoc = gql`
    fragment SalaryMetadataOptions on AggregatedSalariesMetadata {
  options {
    NURSE {
      specialization
      country
      region
    }
    DOCTOR {
      specialization
      country
      region
    }
  }
}
    `;
export const ContactPreferencesFragmentDoc = gql`
    fragment ContactPreferences on ContactPreferences {
  isInterestedInContact
  isInterestedInMatchingVacancies
}
    `;
export const MyCandidateBaseFragmentDoc = gql`
    fragment MyCandidateBase on Candidate {
  address
  description
  email
  fullName
  homeCountry
  homeMunicipality
  homeRegion
  phoneNumber
  profession
  experience
  hprNumber
}
    `;
export const MyInterestsFragmentDoc = gql`
    fragment MyInterests on CandidateInterests {
  countries
  departments
  jobTypes
  municipalities
  regions
  weekInterests
  workForms
}
    `;
export const MyQualificationsFragmentDoc = gql`
    fragment MyQualifications on CandidateQualifications {
  specializations
  journalSystems
  driversLicenses
  swedishLicenseStatus
  norwegianLicenseStatus
}
    `;
export const MyLeadFragmentDoc = gql`
    fragment MyLead on CandidateLead {
  employmentStatus
  extent
  startDate
  karens
}
    `;
export const CandidateCommentFragmentDoc = gql`
    fragment CandidateComment on CandidateComment {
  id
  field
  comment
}
    `;
export const FileUploadFragmentDoc = gql`
    fragment FileUpload on FileUpload {
  comment
  id
  referenceUrl
  uploadedAt
  uploadType
}
    `;
export const MyCandidateFragmentDoc = gql`
    fragment MyCandidate on Candidate {
  id
  updatedAt
  personalIdentityNumberUpdatedAt
  personalIdentityNumberSource
  ...MyCandidateBase
  interests {
    ...MyInterests
  }
  qualifications {
    ...MyQualifications
  }
  lead {
    ...MyLead
  }
  comments {
    ...CandidateComment
  }
  fileUploads {
    ...FileUpload
  }
}
    ${MyCandidateBaseFragmentDoc}
${MyInterestsFragmentDoc}
${MyQualificationsFragmentDoc}
${MyLeadFragmentDoc}
${CandidateCommentFragmentDoc}
${FileUploadFragmentDoc}`;
export const SenderFragmentDoc = gql`
    fragment Sender on Identity {
  id
  fullName
  email
}
    `;
export const ContactRequestFragmentDoc = gql`
    fragment ContactRequest on ContactRequest {
  id
  createdBy
  createdAt
  acceptedAt
  contactRequestOpenedAt
  emailSentAt
  employerId
  noteFromEmployer
  profileId
  rejectedAt
  rejectionComment
  rejectionReason
  sentBy
  status
  textSentAt
  vacancyIds
  numberOfMatchingVacancies
  sender {
    ...Sender
  }
}
    ${SenderFragmentDoc}`;
export const ConnectionFragmentDoc = gql`
    fragment Connection on AbstractConnection {
  id
  createdAt
  employerId
  status
  contactRequest {
    ...ContactRequest
  }
  organization {
    id
    displayName
    graphicProfile {
      logoUrl
    }
  }
  company {
    id
    market
    averageRating
    reviewCount
  }
}
    ${ContactRequestFragmentDoc}`;
export const CurrentJobApplicationFragmentDoc = gql`
    fragment CurrentJobApplication on JobApplication {
  createdAt
  firstSentAt
  status
}
    `;
export const ProfessionalIdentityFragmentDoc = gql`
    fragment ProfessionalIdentity on Identity {
  id
  createdAt
  updatedAt
  email
  fullName
  phoneNumber
  contactPreferences {
    ...ContactPreferences
  }
  candidate {
    ...MyCandidate
  }
  connections {
    ...Connection
  }
  jobApplications {
    ...CurrentJobApplication
  }
}
    ${ContactPreferencesFragmentDoc}
${MyCandidateFragmentDoc}
${ConnectionFragmentDoc}
${CurrentJobApplicationFragmentDoc}`;
export const ReviewFragmentDoc = gql`
    fragment Review on CompanyReview {
  companyReply {
    createdAt
    freeText
  }
  createdAt
  freeText
  id
  isSpam
  market
  name
  profession
  rating
}
    `;
export const BaseJobPostingFragmentDoc = gql`
    fragment BaseJobPosting on JobPosting {
  id
  descriptionHtml
  description
  title
}
    `;
export const VacancyFragmentDoc = gql`
    fragment Vacancy on Vacancy {
  bemloJobPosting {
    ...BaseJobPosting
  }
  createdAt
  country
  department
  employerId
  expectedCompensation {
    high
    low
  }
  howMuchWork
  id
  isSpecializationRequired
  jobEndsAt
  jobStartsAt
  lastApplicationDate
  municipality
  profession
  region
  specializations
  summary
  organization {
    id
    graphicProfile {
      logoUrl
    }
  }
}
    ${BaseJobPostingFragmentDoc}`;
export const ReadContactRequestDocument = gql`
    mutation ReadContactRequest($id: String!) {
  readContactRequest(id: $id) {
    ...ContactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type ReadContactRequestMutationFn = Apollo.MutationFunction<ReadContactRequestMutation, ReadContactRequestMutationVariables>;

/**
 * __useReadContactRequestMutation__
 *
 * To run a mutation, you first call `useReadContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readContactRequestMutation, { data, loading, error }] = useReadContactRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReadContactRequestMutation, ReadContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadContactRequestMutation, ReadContactRequestMutationVariables>(ReadContactRequestDocument, options);
      }
export type ReadContactRequestMutationHookResult = ReturnType<typeof useReadContactRequestMutation>;
export type ReadContactRequestMutationResult = Apollo.MutationResult<ReadContactRequestMutation>;
export type ReadContactRequestMutationOptions = Apollo.BaseMutationOptions<ReadContactRequestMutation, ReadContactRequestMutationVariables>;
export const GetContextCompaniesDocument = gql`
    query GetContextCompanies($markets: [Market!]!, $reviewsFrom: [Market!]!) {
  allRecruitingOrganizations(recruitsIn: $markets) {
    ...ContextCompany
  }
}
    ${ContextCompanyFragmentDoc}`;

/**
 * __useGetContextCompaniesQuery__
 *
 * To run a query within a React component, call `useGetContextCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContextCompaniesQuery({
 *   variables: {
 *      markets: // value for 'markets'
 *      reviewsFrom: // value for 'reviewsFrom'
 *   },
 * });
 */
export function useGetContextCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetContextCompaniesQuery, GetContextCompaniesQueryVariables> & ({ variables: GetContextCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>(GetContextCompaniesDocument, options);
      }
export function useGetContextCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>(GetContextCompaniesDocument, options);
        }
export function useGetContextCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>(GetContextCompaniesDocument, options);
        }
export type GetContextCompaniesQueryHookResult = ReturnType<typeof useGetContextCompaniesQuery>;
export type GetContextCompaniesLazyQueryHookResult = ReturnType<typeof useGetContextCompaniesLazyQuery>;
export type GetContextCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetContextCompaniesSuspenseQuery>;
export type GetContextCompaniesQueryResult = Apollo.QueryResult<GetContextCompaniesQuery, GetContextCompaniesQueryVariables>;
export const GetContextCompaniesWithReviewsDocument = gql`
    query GetContextCompaniesWithReviews($markets: [Market!]!, $reviewsFrom: [Market!]!) {
  allRecruitingOrganizations(recruitsIn: $markets) {
    ...ContextCompany
    reviews(markets: $reviewsFrom) {
      ...Review
    }
  }
}
    ${ContextCompanyFragmentDoc}
${ReviewFragmentDoc}`;

/**
 * __useGetContextCompaniesWithReviewsQuery__
 *
 * To run a query within a React component, call `useGetContextCompaniesWithReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextCompaniesWithReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContextCompaniesWithReviewsQuery({
 *   variables: {
 *      markets: // value for 'markets'
 *      reviewsFrom: // value for 'reviewsFrom'
 *   },
 * });
 */
export function useGetContextCompaniesWithReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables> & ({ variables: GetContextCompaniesWithReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>(GetContextCompaniesWithReviewsDocument, options);
      }
export function useGetContextCompaniesWithReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>(GetContextCompaniesWithReviewsDocument, options);
        }
export function useGetContextCompaniesWithReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>(GetContextCompaniesWithReviewsDocument, options);
        }
export type GetContextCompaniesWithReviewsQueryHookResult = ReturnType<typeof useGetContextCompaniesWithReviewsQuery>;
export type GetContextCompaniesWithReviewsLazyQueryHookResult = ReturnType<typeof useGetContextCompaniesWithReviewsLazyQuery>;
export type GetContextCompaniesWithReviewsSuspenseQueryHookResult = ReturnType<typeof useGetContextCompaniesWithReviewsSuspenseQuery>;
export type GetContextCompaniesWithReviewsQueryResult = Apollo.QueryResult<GetContextCompaniesWithReviewsQuery, GetContextCompaniesWithReviewsQueryVariables>;
export const ContactOnJobPostingDocument = gql`
    mutation ContactOnJobPosting($input: ContactOnJobPostingInput!) {
  contactOnJobPosting(input: $input)
}
    `;
export type ContactOnJobPostingMutationFn = Apollo.MutationFunction<ContactOnJobPostingMutation, ContactOnJobPostingMutationVariables>;

/**
 * __useContactOnJobPostingMutation__
 *
 * To run a mutation, you first call `useContactOnJobPostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactOnJobPostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactOnJobPostingMutation, { data, loading, error }] = useContactOnJobPostingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactOnJobPostingMutation(baseOptions?: Apollo.MutationHookOptions<ContactOnJobPostingMutation, ContactOnJobPostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactOnJobPostingMutation, ContactOnJobPostingMutationVariables>(ContactOnJobPostingDocument, options);
      }
export type ContactOnJobPostingMutationHookResult = ReturnType<typeof useContactOnJobPostingMutation>;
export type ContactOnJobPostingMutationResult = Apollo.MutationResult<ContactOnJobPostingMutation>;
export type ContactOnJobPostingMutationOptions = Apollo.BaseMutationOptions<ContactOnJobPostingMutation, ContactOnJobPostingMutationVariables>;
export const GetCommentsDocument = gql`
    query GetComments($blogPostSlug: String!) {
  comments(blogPostSlug: $blogPostSlug) {
    id
    name
    isModerator
    createdAt
    profession
    freeText
    parentCommentId
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      blogPostSlug: // value for 'blogPostSlug'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables> & ({ variables: GetCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export function useGetCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCommentsSuspenseQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetBankIdTransactionDocument = gql`
    query GetBankIdTransaction($orderRef: String!) {
  findBankIdTransaction(orderRef: $orderRef) {
    orderRef
    status
    hintCode
  }
}
    `;

/**
 * __useGetBankIdTransactionQuery__
 *
 * To run a query within a React component, call `useGetBankIdTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankIdTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankIdTransactionQuery({
 *   variables: {
 *      orderRef: // value for 'orderRef'
 *   },
 * });
 */
export function useGetBankIdTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables> & ({ variables: GetBankIdTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>(GetBankIdTransactionDocument, options);
      }
export function useGetBankIdTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>(GetBankIdTransactionDocument, options);
        }
export function useGetBankIdTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>(GetBankIdTransactionDocument, options);
        }
export type GetBankIdTransactionQueryHookResult = ReturnType<typeof useGetBankIdTransactionQuery>;
export type GetBankIdTransactionLazyQueryHookResult = ReturnType<typeof useGetBankIdTransactionLazyQuery>;
export type GetBankIdTransactionSuspenseQueryHookResult = ReturnType<typeof useGetBankIdTransactionSuspenseQuery>;
export type GetBankIdTransactionQueryResult = Apollo.QueryResult<GetBankIdTransactionQuery, GetBankIdTransactionQueryVariables>;
export const GetAggregatedSalaryMetadataDocument = gql`
    query GetAggregatedSalaryMetadata {
  salariesMetadata {
    aggregatedAt
    numberOfReportedSalaries
    ...SalaryMetadataOptions
  }
}
    ${SalaryMetadataOptionsFragmentDoc}`;

/**
 * __useGetAggregatedSalaryMetadataQuery__
 *
 * To run a query within a React component, call `useGetAggregatedSalaryMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedSalaryMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedSalaryMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAggregatedSalaryMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>(GetAggregatedSalaryMetadataDocument, options);
      }
export function useGetAggregatedSalaryMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>(GetAggregatedSalaryMetadataDocument, options);
        }
export function useGetAggregatedSalaryMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>(GetAggregatedSalaryMetadataDocument, options);
        }
export type GetAggregatedSalaryMetadataQueryHookResult = ReturnType<typeof useGetAggregatedSalaryMetadataQuery>;
export type GetAggregatedSalaryMetadataLazyQueryHookResult = ReturnType<typeof useGetAggregatedSalaryMetadataLazyQuery>;
export type GetAggregatedSalaryMetadataSuspenseQueryHookResult = ReturnType<typeof useGetAggregatedSalaryMetadataSuspenseQuery>;
export type GetAggregatedSalaryMetadataQueryResult = Apollo.QueryResult<GetAggregatedSalaryMetadataQuery, GetAggregatedSalaryMetadataQueryVariables>;
export const GetNumberOfReportedSalariesDocument = gql`
    query GetNumberOfReportedSalaries {
  salariesMetadata {
    numberOfReportedSalaries
  }
}
    `;

/**
 * __useGetNumberOfReportedSalariesQuery__
 *
 * To run a query within a React component, call `useGetNumberOfReportedSalariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfReportedSalariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfReportedSalariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNumberOfReportedSalariesQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>(GetNumberOfReportedSalariesDocument, options);
      }
export function useGetNumberOfReportedSalariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>(GetNumberOfReportedSalariesDocument, options);
        }
export function useGetNumberOfReportedSalariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>(GetNumberOfReportedSalariesDocument, options);
        }
export type GetNumberOfReportedSalariesQueryHookResult = ReturnType<typeof useGetNumberOfReportedSalariesQuery>;
export type GetNumberOfReportedSalariesLazyQueryHookResult = ReturnType<typeof useGetNumberOfReportedSalariesLazyQuery>;
export type GetNumberOfReportedSalariesSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfReportedSalariesSuspenseQuery>;
export type GetNumberOfReportedSalariesQueryResult = Apollo.QueryResult<GetNumberOfReportedSalariesQuery, GetNumberOfReportedSalariesQueryVariables>;
export const FetchSalaryDataDocument = gql`
    query FetchSalaryData($profession: Profession!, $country: Country!, $region: Region!) {
  salaryStatisics(
    fetchSalaryStatistics: {profession: $profession, country: $country, region: $region}
  ) {
    noSpecializationSalaryGroup {
      values
    }
    genericSpecializationSalaryGroup {
      values
    }
  }
}
    `;

/**
 * __useFetchSalaryDataQuery__
 *
 * To run a query within a React component, call `useFetchSalaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSalaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSalaryDataQuery({
 *   variables: {
 *      profession: // value for 'profession'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useFetchSalaryDataQuery(baseOptions: Apollo.QueryHookOptions<FetchSalaryDataQuery, FetchSalaryDataQueryVariables> & ({ variables: FetchSalaryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>(FetchSalaryDataDocument, options);
      }
export function useFetchSalaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>(FetchSalaryDataDocument, options);
        }
export function useFetchSalaryDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>(FetchSalaryDataDocument, options);
        }
export type FetchSalaryDataQueryHookResult = ReturnType<typeof useFetchSalaryDataQuery>;
export type FetchSalaryDataLazyQueryHookResult = ReturnType<typeof useFetchSalaryDataLazyQuery>;
export type FetchSalaryDataSuspenseQueryHookResult = ReturnType<typeof useFetchSalaryDataSuspenseQuery>;
export type FetchSalaryDataQueryResult = Apollo.QueryResult<FetchSalaryDataQuery, FetchSalaryDataQueryVariables>;
export const AcceptContactRequestDocument = gql`
    mutation AcceptContactRequest($employerId: String!) {
  acceptContactRequest(employerId: $employerId) {
    ...ContactRequest
    connection {
      ...Connection
    }
  }
}
    ${ContactRequestFragmentDoc}
${ConnectionFragmentDoc}`;
export type AcceptContactRequestMutationFn = Apollo.MutationFunction<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>;

/**
 * __useAcceptContactRequestMutation__
 *
 * To run a mutation, you first call `useAcceptContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContactRequestMutation, { data, loading, error }] = useAcceptContactRequestMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useAcceptContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>(AcceptContactRequestDocument, options);
      }
export type AcceptContactRequestMutationHookResult = ReturnType<typeof useAcceptContactRequestMutation>;
export type AcceptContactRequestMutationResult = Apollo.MutationResult<AcceptContactRequestMutation>;
export type AcceptContactRequestMutationOptions = Apollo.BaseMutationOptions<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>;
export const RejectContactRequestDocument = gql`
    mutation RejectContactRequest($comment: String, $employerId: String!, $reason: ContactRequestRejectionReason) {
  rejectContactRequest(
    comment: $comment
    employerId: $employerId
    reason: $reason
  ) {
    ...ContactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type RejectContactRequestMutationFn = Apollo.MutationFunction<RejectContactRequestMutation, RejectContactRequestMutationVariables>;

/**
 * __useRejectContactRequestMutation__
 *
 * To run a mutation, you first call `useRejectContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectContactRequestMutation, { data, loading, error }] = useRejectContactRequestMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      employerId: // value for 'employerId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectContactRequestMutation, RejectContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectContactRequestMutation, RejectContactRequestMutationVariables>(RejectContactRequestDocument, options);
      }
export type RejectContactRequestMutationHookResult = ReturnType<typeof useRejectContactRequestMutation>;
export type RejectContactRequestMutationResult = Apollo.MutationResult<RejectContactRequestMutation>;
export type RejectContactRequestMutationOptions = Apollo.BaseMutationOptions<RejectContactRequestMutation, RejectContactRequestMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($blogPostSlug: String!, $freeText: String!, $name: String!, $email: String, $profession: Profession) {
  createComment(
    data: {blogPostSlug: $blogPostSlug, freeText: $freeText, name: $name, email: $email, profession: $profession}
  )
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      blogPostSlug: // value for 'blogPostSlug'
 *      freeText: // value for 'freeText'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      profession: // value for 'profession'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateReplyDocument = gql`
    mutation CreateReply($blogPostSlug: String!, $freeText: String!, $name: String!, $parentCommentId: String!) {
  createReply(
    data: {blogPostSlug: $blogPostSlug, freeText: $freeText, name: $name, parentCommentId: $parentCommentId}
  )
}
    `;
export type CreateReplyMutationFn = Apollo.MutationFunction<CreateReplyMutation, CreateReplyMutationVariables>;

/**
 * __useCreateReplyMutation__
 *
 * To run a mutation, you first call `useCreateReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyMutation, { data, loading, error }] = useCreateReplyMutation({
 *   variables: {
 *      blogPostSlug: // value for 'blogPostSlug'
 *      freeText: // value for 'freeText'
 *      name: // value for 'name'
 *      parentCommentId: // value for 'parentCommentId'
 *   },
 * });
 */
export function useCreateReplyMutation(baseOptions?: Apollo.MutationHookOptions<CreateReplyMutation, CreateReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReplyMutation, CreateReplyMutationVariables>(CreateReplyDocument, options);
      }
export type CreateReplyMutationHookResult = ReturnType<typeof useCreateReplyMutation>;
export type CreateReplyMutationResult = Apollo.MutationResult<CreateReplyMutation>;
export type CreateReplyMutationOptions = Apollo.BaseMutationOptions<CreateReplyMutation, CreateReplyMutationVariables>;
export const CreateSalaryDocument = gql`
    mutation CreateSalary($jobType: JobType!, $gender: Gender, $age: Int, $profession: Profession!, $specialization: Specialization, $experience: String!, $country: Country!, $region: Region, $company: String!, $workplace: String!, $workForm: WorkForm!, $baseSalary: Int!, $ob: Boolean!, $obEvening: Int, $obNight: Int, $obWeekend: Int, $obLongWeekend: Int, $vacationIncluded: Boolean!, $tjanstePension: Boolean!, $summerJob: Boolean, $hasPerks: Boolean!, $perks: [Perk!], $otherPerk: String, $email: String) {
  createSalary(
    createSalaryData: {jobType: $jobType, gender: $gender, age: $age, profession: $profession, specialization: $specialization, experience: $experience, country: $country, region: $region, company: $company, workplace: $workplace, workForm: $workForm, baseSalary: $baseSalary, ob: $ob, obEvening: $obEvening, obNight: $obNight, obWeekend: $obWeekend, obLongWeekend: $obLongWeekend, vacationIncluded: $vacationIncluded, tjanstePension: $tjanstePension, summerJob: $summerJob, hasPerks: $hasPerks, perks: $perks, otherPerk: $otherPerk, email: $email}
  ) {
    documentId
  }
}
    `;
export type CreateSalaryMutationFn = Apollo.MutationFunction<CreateSalaryMutation, CreateSalaryMutationVariables>;

/**
 * __useCreateSalaryMutation__
 *
 * To run a mutation, you first call `useCreateSalaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalaryMutation, { data, loading, error }] = useCreateSalaryMutation({
 *   variables: {
 *      jobType: // value for 'jobType'
 *      gender: // value for 'gender'
 *      age: // value for 'age'
 *      profession: // value for 'profession'
 *      specialization: // value for 'specialization'
 *      experience: // value for 'experience'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *      company: // value for 'company'
 *      workplace: // value for 'workplace'
 *      workForm: // value for 'workForm'
 *      baseSalary: // value for 'baseSalary'
 *      ob: // value for 'ob'
 *      obEvening: // value for 'obEvening'
 *      obNight: // value for 'obNight'
 *      obWeekend: // value for 'obWeekend'
 *      obLongWeekend: // value for 'obLongWeekend'
 *      vacationIncluded: // value for 'vacationIncluded'
 *      tjanstePension: // value for 'tjanstePension'
 *      summerJob: // value for 'summerJob'
 *      hasPerks: // value for 'hasPerks'
 *      perks: // value for 'perks'
 *      otherPerk: // value for 'otherPerk'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateSalaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalaryMutation, CreateSalaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalaryMutation, CreateSalaryMutationVariables>(CreateSalaryDocument, options);
      }
export type CreateSalaryMutationHookResult = ReturnType<typeof useCreateSalaryMutation>;
export type CreateSalaryMutationResult = Apollo.MutationResult<CreateSalaryMutation>;
export type CreateSalaryMutationOptions = Apollo.BaseMutationOptions<CreateSalaryMutation, CreateSalaryMutationVariables>;
export const SubscribeToNewsletterDocument = gql`
    mutation SubscribeToNewsletter($email: String!, $profession: Profession!, $origin: String!, $market: Market!) {
  subscribeToNewsletter(
    data: {email: $email, profession: $profession, origin: $origin, market: $market}
  )
}
    `;
export type SubscribeToNewsletterMutationFn = Apollo.MutationFunction<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;

/**
 * __useSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToNewsletterMutation, { data, loading, error }] = useSubscribeToNewsletterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      profession: // value for 'profession'
 *      origin: // value for 'origin'
 *      market: // value for 'market'
 *   },
 * });
 */
export function useSubscribeToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>(SubscribeToNewsletterDocument, options);
      }
export type SubscribeToNewsletterMutationHookResult = ReturnType<typeof useSubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationResult = Apollo.MutationResult<SubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...ProfessionalIdentity
  }
}
    ${ProfessionalIdentityFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const RegisterDocument = gql`
    mutation Register($input: RegisterProfessionalInput!) {
  registerProfessional(data: $input)
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RegisterFileUploadDocument = gql`
    mutation RegisterFileUpload($uploadType: FileUploadType!, $referenceUrl: String!, $comment: String) {
  registerFileUpload(
    data: {uploadType: $uploadType, referenceUrl: $referenceUrl, comment: $comment}
  ) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;
export type RegisterFileUploadMutationFn = Apollo.MutationFunction<RegisterFileUploadMutation, RegisterFileUploadMutationVariables>;

/**
 * __useRegisterFileUploadMutation__
 *
 * To run a mutation, you first call `useRegisterFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFileUploadMutation, { data, loading, error }] = useRegisterFileUploadMutation({
 *   variables: {
 *      uploadType: // value for 'uploadType'
 *      referenceUrl: // value for 'referenceUrl'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRegisterFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFileUploadMutation, RegisterFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFileUploadMutation, RegisterFileUploadMutationVariables>(RegisterFileUploadDocument, options);
      }
export type RegisterFileUploadMutationHookResult = ReturnType<typeof useRegisterFileUploadMutation>;
export type RegisterFileUploadMutationResult = Apollo.MutationResult<RegisterFileUploadMutation>;
export type RegisterFileUploadMutationOptions = Apollo.BaseMutationOptions<RegisterFileUploadMutation, RegisterFileUploadMutationVariables>;
export const UpdateFileUploadDocument = gql`
    mutation UpdateFileUpload($fileUploadId: String!, $referenceUrl: String!) {
  updateFileUpload(
    data: {fileUploadId: $fileUploadId, fileUploadFields: {referenceUrl: $referenceUrl}}
  ) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;
export type UpdateFileUploadMutationFn = Apollo.MutationFunction<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>;

/**
 * __useUpdateFileUploadMutation__
 *
 * To run a mutation, you first call `useUpdateFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileUploadMutation, { data, loading, error }] = useUpdateFileUploadMutation({
 *   variables: {
 *      fileUploadId: // value for 'fileUploadId'
 *      referenceUrl: // value for 'referenceUrl'
 *   },
 * });
 */
export function useUpdateFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>(UpdateFileUploadDocument, options);
      }
export type UpdateFileUploadMutationHookResult = ReturnType<typeof useUpdateFileUploadMutation>;
export type UpdateFileUploadMutationResult = Apollo.MutationResult<UpdateFileUploadMutation>;
export type UpdateFileUploadMutationOptions = Apollo.BaseMutationOptions<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>;
export const DeleteFileUploadDocument = gql`
    mutation DeleteFileUpload($fileUploadId: String!) {
  deleteFileUpload(uploadId: $fileUploadId)
}
    `;
export type DeleteFileUploadMutationFn = Apollo.MutationFunction<DeleteFileUploadMutation, DeleteFileUploadMutationVariables>;

/**
 * __useDeleteFileUploadMutation__
 *
 * To run a mutation, you first call `useDeleteFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileUploadMutation, { data, loading, error }] = useDeleteFileUploadMutation({
 *   variables: {
 *      fileUploadId: // value for 'fileUploadId'
 *   },
 * });
 */
export function useDeleteFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileUploadMutation, DeleteFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileUploadMutation, DeleteFileUploadMutationVariables>(DeleteFileUploadDocument, options);
      }
export type DeleteFileUploadMutationHookResult = ReturnType<typeof useDeleteFileUploadMutation>;
export type DeleteFileUploadMutationResult = Apollo.MutationResult<DeleteFileUploadMutation>;
export type DeleteFileUploadMutationOptions = Apollo.BaseMutationOptions<DeleteFileUploadMutation, DeleteFileUploadMutationVariables>;
export const RequestMoreContactsDocument = gql`
    mutation RequestMoreContacts {
  requestMoreContacts
}
    `;
export type RequestMoreContactsMutationFn = Apollo.MutationFunction<RequestMoreContactsMutation, RequestMoreContactsMutationVariables>;

/**
 * __useRequestMoreContactsMutation__
 *
 * To run a mutation, you first call `useRequestMoreContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMoreContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMoreContactsMutation, { data, loading, error }] = useRequestMoreContactsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestMoreContactsMutation(baseOptions?: Apollo.MutationHookOptions<RequestMoreContactsMutation, RequestMoreContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMoreContactsMutation, RequestMoreContactsMutationVariables>(RequestMoreContactsDocument, options);
      }
export type RequestMoreContactsMutationHookResult = ReturnType<typeof useRequestMoreContactsMutation>;
export type RequestMoreContactsMutationResult = Apollo.MutationResult<RequestMoreContactsMutation>;
export type RequestMoreContactsMutationOptions = Apollo.BaseMutationOptions<RequestMoreContactsMutation, RequestMoreContactsMutationVariables>;
export const ApplyToEmployerDocument = gql`
    mutation ApplyToEmployer($id: String!) {
  applyToEmployer(id: $id)
}
    `;
export type ApplyToEmployerMutationFn = Apollo.MutationFunction<ApplyToEmployerMutation, ApplyToEmployerMutationVariables>;

/**
 * __useApplyToEmployerMutation__
 *
 * To run a mutation, you first call `useApplyToEmployerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyToEmployerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyToEmployerMutation, { data, loading, error }] = useApplyToEmployerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplyToEmployerMutation(baseOptions?: Apollo.MutationHookOptions<ApplyToEmployerMutation, ApplyToEmployerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyToEmployerMutation, ApplyToEmployerMutationVariables>(ApplyToEmployerDocument, options);
      }
export type ApplyToEmployerMutationHookResult = ReturnType<typeof useApplyToEmployerMutation>;
export type ApplyToEmployerMutationResult = Apollo.MutationResult<ApplyToEmployerMutation>;
export type ApplyToEmployerMutationOptions = Apollo.BaseMutationOptions<ApplyToEmployerMutation, ApplyToEmployerMutationVariables>;
export const CreateJobApplicationDocument = gql`
    mutation CreateJobApplication($employerId: String) {
  createJobApplication(data: {employerId: $employerId})
}
    `;
export type CreateJobApplicationMutationFn = Apollo.MutationFunction<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;

/**
 * __useCreateJobApplicationMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationMutation, { data, loading, error }] = useCreateJobApplicationMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useCreateJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>(CreateJobApplicationDocument, options);
      }
export type CreateJobApplicationMutationHookResult = ReturnType<typeof useCreateJobApplicationMutation>;
export type CreateJobApplicationMutationResult = Apollo.MutationResult<CreateJobApplicationMutation>;
export type CreateJobApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;
export const AuthenticateProfileWithBankIdDocument = gql`
    mutation AuthenticateProfileWithBankId {
  authenticateWithBankId {
    orderRef
    autoStartToken
  }
}
    `;
export type AuthenticateProfileWithBankIdMutationFn = Apollo.MutationFunction<AuthenticateProfileWithBankIdMutation, AuthenticateProfileWithBankIdMutationVariables>;

/**
 * __useAuthenticateProfileWithBankIdMutation__
 *
 * To run a mutation, you first call `useAuthenticateProfileWithBankIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateProfileWithBankIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateProfileWithBankIdMutation, { data, loading, error }] = useAuthenticateProfileWithBankIdMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateProfileWithBankIdMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateProfileWithBankIdMutation, AuthenticateProfileWithBankIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateProfileWithBankIdMutation, AuthenticateProfileWithBankIdMutationVariables>(AuthenticateProfileWithBankIdDocument, options);
      }
export type AuthenticateProfileWithBankIdMutationHookResult = ReturnType<typeof useAuthenticateProfileWithBankIdMutation>;
export type AuthenticateProfileWithBankIdMutationResult = Apollo.MutationResult<AuthenticateProfileWithBankIdMutation>;
export type AuthenticateProfileWithBankIdMutationOptions = Apollo.BaseMutationOptions<AuthenticateProfileWithBankIdMutation, AuthenticateProfileWithBankIdMutationVariables>;
export const DeleteProfileDocument = gql`
    mutation DeleteProfile {
  deleteOwnProfile
}
    `;
export type DeleteProfileMutationFn = Apollo.MutationFunction<DeleteProfileMutation, DeleteProfileMutationVariables>;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMutation, { data, loading, error }] = useDeleteProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfileMutation, DeleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfileMutation, DeleteProfileMutationVariables>(DeleteProfileDocument, options);
      }
export type DeleteProfileMutationHookResult = ReturnType<typeof useDeleteProfileMutation>;
export type DeleteProfileMutationResult = Apollo.MutationResult<DeleteProfileMutation>;
export type DeleteProfileMutationOptions = Apollo.BaseMutationOptions<DeleteProfileMutation, DeleteProfileMutationVariables>;
export const CreateReferenceDocument = gql`
    mutation CreateReference($name: String!, $email: String!, $phoneNumber: String) {
  inviteReference(input: {name: $name, email: $email, phoneNumber: $phoneNumber}) {
    id
  }
}
    `;
export type CreateReferenceMutationFn = Apollo.MutationFunction<CreateReferenceMutation, CreateReferenceMutationVariables>;

/**
 * __useCreateReferenceMutation__
 *
 * To run a mutation, you first call `useCreateReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferenceMutation, { data, loading, error }] = useCreateReferenceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useCreateReferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferenceMutation, CreateReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferenceMutation, CreateReferenceMutationVariables>(CreateReferenceDocument, options);
      }
export type CreateReferenceMutationHookResult = ReturnType<typeof useCreateReferenceMutation>;
export type CreateReferenceMutationResult = Apollo.MutationResult<CreateReferenceMutation>;
export type CreateReferenceMutationOptions = Apollo.BaseMutationOptions<CreateReferenceMutation, CreateReferenceMutationVariables>;
export const UpdateReferenceDocument = gql`
    mutation UpdateReference($referenceId: String!, $name: String!, $email: String!, $phoneNumber: String!) {
  updateReference(
    data: {referenceId: $referenceId, name: $name, email: $email, phoneNumber: $phoneNumber}
  ) {
    id
  }
}
    `;
export type UpdateReferenceMutationFn = Apollo.MutationFunction<UpdateReferenceMutation, UpdateReferenceMutationVariables>;

/**
 * __useUpdateReferenceMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceMutation, { data, loading, error }] = useUpdateReferenceMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateReferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceMutation, UpdateReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceMutation, UpdateReferenceMutationVariables>(UpdateReferenceDocument, options);
      }
export type UpdateReferenceMutationHookResult = ReturnType<typeof useUpdateReferenceMutation>;
export type UpdateReferenceMutationResult = Apollo.MutationResult<UpdateReferenceMutation>;
export type UpdateReferenceMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceMutation, UpdateReferenceMutationVariables>;
export const UpdateReferenceStatusDocument = gql`
    mutation UpdateReferenceStatus($referenceId: String!, $profileId: String!, $isOpened: Boolean, $isCompleted: Boolean, $isRejectedByReferer: Boolean) {
  updateReferenceStatus(
    data: {referenceId: $referenceId, profileId: $profileId, isOpened: $isOpened, isCompleted: $isCompleted, isRejectedByReferer: $isRejectedByReferer}
  ) {
    id
  }
}
    `;
export type UpdateReferenceStatusMutationFn = Apollo.MutationFunction<UpdateReferenceStatusMutation, UpdateReferenceStatusMutationVariables>;

/**
 * __useUpdateReferenceStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceStatusMutation, { data, loading, error }] = useUpdateReferenceStatusMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      profileId: // value for 'profileId'
 *      isOpened: // value for 'isOpened'
 *      isCompleted: // value for 'isCompleted'
 *      isRejectedByReferer: // value for 'isRejectedByReferer'
 *   },
 * });
 */
export function useUpdateReferenceStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceStatusMutation, UpdateReferenceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceStatusMutation, UpdateReferenceStatusMutationVariables>(UpdateReferenceStatusDocument, options);
      }
export type UpdateReferenceStatusMutationHookResult = ReturnType<typeof useUpdateReferenceStatusMutation>;
export type UpdateReferenceStatusMutationResult = Apollo.MutationResult<UpdateReferenceStatusMutation>;
export type UpdateReferenceStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceStatusMutation, UpdateReferenceStatusMutationVariables>;
export const DeleteReferenceDocument = gql`
    mutation DeleteReference($referenceId: String!) {
  deleteReference(data: {referenceId: $referenceId})
}
    `;
export type DeleteReferenceMutationFn = Apollo.MutationFunction<DeleteReferenceMutation, DeleteReferenceMutationVariables>;

/**
 * __useDeleteReferenceMutation__
 *
 * To run a mutation, you first call `useDeleteReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReferenceMutation, { data, loading, error }] = useDeleteReferenceMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useDeleteReferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReferenceMutation, DeleteReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReferenceMutation, DeleteReferenceMutationVariables>(DeleteReferenceDocument, options);
      }
export type DeleteReferenceMutationHookResult = ReturnType<typeof useDeleteReferenceMutation>;
export type DeleteReferenceMutationResult = Apollo.MutationResult<DeleteReferenceMutation>;
export type DeleteReferenceMutationOptions = Apollo.BaseMutationOptions<DeleteReferenceMutation, DeleteReferenceMutationVariables>;
export const GetReferencesByProfileIdDocument = gql`
    query GetReferencesByProfileId {
  myReferences {
    id
    name
    createdAt
    completedAt
  }
}
    `;

/**
 * __useGetReferencesByProfileIdQuery__
 *
 * To run a query within a React component, call `useGetReferencesByProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferencesByProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferencesByProfileIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferencesByProfileIdQuery(baseOptions?: Apollo.QueryHookOptions<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>(GetReferencesByProfileIdDocument, options);
      }
export function useGetReferencesByProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>(GetReferencesByProfileIdDocument, options);
        }
export function useGetReferencesByProfileIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>(GetReferencesByProfileIdDocument, options);
        }
export type GetReferencesByProfileIdQueryHookResult = ReturnType<typeof useGetReferencesByProfileIdQuery>;
export type GetReferencesByProfileIdLazyQueryHookResult = ReturnType<typeof useGetReferencesByProfileIdLazyQuery>;
export type GetReferencesByProfileIdSuspenseQueryHookResult = ReturnType<typeof useGetReferencesByProfileIdSuspenseQuery>;
export type GetReferencesByProfileIdQueryResult = Apollo.QueryResult<GetReferencesByProfileIdQuery, GetReferencesByProfileIdQueryVariables>;
export const GetReferenceByIdDocument = gql`
    query GetReferenceById($id: String!) {
  reference(id: $id) {
    id
    referentId
    name
    email
    phoneNumber
    createdAt
    answers {
      workPlaceRelationshipToApplicant
      wouldRecommend
    }
    completedAt
    referentName
  }
}
    `;

/**
 * __useGetReferenceByIdQuery__
 *
 * To run a query within a React component, call `useGetReferenceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReferenceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReferenceByIdQuery, GetReferenceByIdQueryVariables> & ({ variables: GetReferenceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>(GetReferenceByIdDocument, options);
      }
export function useGetReferenceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>(GetReferenceByIdDocument, options);
        }
export function useGetReferenceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>(GetReferenceByIdDocument, options);
        }
export type GetReferenceByIdQueryHookResult = ReturnType<typeof useGetReferenceByIdQuery>;
export type GetReferenceByIdLazyQueryHookResult = ReturnType<typeof useGetReferenceByIdLazyQuery>;
export type GetReferenceByIdSuspenseQueryHookResult = ReturnType<typeof useGetReferenceByIdSuspenseQuery>;
export type GetReferenceByIdQueryResult = Apollo.QueryResult<GetReferenceByIdQuery, GetReferenceByIdQueryVariables>;
export const UpdateReferenceAnswersDocument = gql`
    mutation UpdateReferenceAnswers($referenceAnswersInput: ReferenceAnswersInput!, $id: String!) {
  updateReferenceAnswers(
    data: {referenceId: $id, answers: $referenceAnswersInput}
  ) {
    id
  }
}
    `;
export type UpdateReferenceAnswersMutationFn = Apollo.MutationFunction<UpdateReferenceAnswersMutation, UpdateReferenceAnswersMutationVariables>;

/**
 * __useUpdateReferenceAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceAnswersMutation, { data, loading, error }] = useUpdateReferenceAnswersMutation({
 *   variables: {
 *      referenceAnswersInput: // value for 'referenceAnswersInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateReferenceAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceAnswersMutation, UpdateReferenceAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceAnswersMutation, UpdateReferenceAnswersMutationVariables>(UpdateReferenceAnswersDocument, options);
      }
export type UpdateReferenceAnswersMutationHookResult = ReturnType<typeof useUpdateReferenceAnswersMutation>;
export type UpdateReferenceAnswersMutationResult = Apollo.MutationResult<UpdateReferenceAnswersMutation>;
export type UpdateReferenceAnswersMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceAnswersMutation, UpdateReferenceAnswersMutationVariables>;
export const GetReviewsDocument = gql`
    query GetReviews($employerId: String!, $markets: [Market!]!) {
  reviews: companyReviews(employerId: $employerId, markets: $markets) {
    ...Review
  }
}
    ${ReviewFragmentDoc}`;

/**
 * __useGetReviewsQuery__
 *
 * To run a query within a React component, call `useGetReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewsQuery({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      markets: // value for 'markets'
 *   },
 * });
 */
export function useGetReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetReviewsQuery, GetReviewsQueryVariables> & ({ variables: GetReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewsQuery, GetReviewsQueryVariables>(GetReviewsDocument, options);
      }
export function useGetReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewsQuery, GetReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewsQuery, GetReviewsQueryVariables>(GetReviewsDocument, options);
        }
export function useGetReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewsQuery, GetReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewsQuery, GetReviewsQueryVariables>(GetReviewsDocument, options);
        }
export type GetReviewsQueryHookResult = ReturnType<typeof useGetReviewsQuery>;
export type GetReviewsLazyQueryHookResult = ReturnType<typeof useGetReviewsLazyQuery>;
export type GetReviewsSuspenseQueryHookResult = ReturnType<typeof useGetReviewsSuspenseQuery>;
export type GetReviewsQueryResult = Apollo.QueryResult<GetReviewsQuery, GetReviewsQueryVariables>;
export const CreateReviewDocument = gql`
    mutation CreateReview($data: CreateCompanyReviewInput!) {
  createReview: createCompanyReview(data: $data) {
    autoStartToken
    orderRef
  }
}
    `;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const CreateReviewWithoutBankIdDocument = gql`
    mutation CreateReviewWithoutBankId($data: CreateCompanyReviewInput!) {
  createReviewWithoutBankId: createCompanyReviewWithoutBankId(data: $data)
}
    `;
export type CreateReviewWithoutBankIdMutationFn = Apollo.MutationFunction<CreateReviewWithoutBankIdMutation, CreateReviewWithoutBankIdMutationVariables>;

/**
 * __useCreateReviewWithoutBankIdMutation__
 *
 * To run a mutation, you first call `useCreateReviewWithoutBankIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewWithoutBankIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewWithoutBankIdMutation, { data, loading, error }] = useCreateReviewWithoutBankIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReviewWithoutBankIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewWithoutBankIdMutation, CreateReviewWithoutBankIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewWithoutBankIdMutation, CreateReviewWithoutBankIdMutationVariables>(CreateReviewWithoutBankIdDocument, options);
      }
export type CreateReviewWithoutBankIdMutationHookResult = ReturnType<typeof useCreateReviewWithoutBankIdMutation>;
export type CreateReviewWithoutBankIdMutationResult = Apollo.MutationResult<CreateReviewWithoutBankIdMutation>;
export type CreateReviewWithoutBankIdMutationOptions = Apollo.BaseMutationOptions<CreateReviewWithoutBankIdMutation, CreateReviewWithoutBankIdMutationVariables>;
export const UpdateCandidateInformationDocument = gql`
    mutation UpdateCandidateInformation($candidateId: String!, $comments: [CreateCandidateCommentInput!]!, $description: String, $email: String, $experience: Int, $fullName: String, $homeMunicipality: String, $interests: CandidateInterestsInput, $lead: CandidateLeadInput, $personalIdentityNumber: String, $phoneNumber: String, $profession: Profession, $qualifications: CandidateQualificationsInput, $hprNumber: String) {
  updateCandidate(
    id: $candidateId
    updates: {description: $description, email: $email, experience: $experience, fullName: $fullName, homeMunicipality: $homeMunicipality, interests: $interests, lead: $lead, personalIdentityNumber: $personalIdentityNumber, phoneNumber: $phoneNumber, profession: $profession, qualifications: $qualifications, hprNumber: $hprNumber}
  ) {
    id
    ...MyCandidate
  }
  createCandidateComments(candidateId: $candidateId, input: $comments) {
    ...CandidateComment
  }
}
    ${MyCandidateFragmentDoc}
${CandidateCommentFragmentDoc}`;
export type UpdateCandidateInformationMutationFn = Apollo.MutationFunction<UpdateCandidateInformationMutation, UpdateCandidateInformationMutationVariables>;

/**
 * __useUpdateCandidateInformationMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateInformationMutation, { data, loading, error }] = useUpdateCandidateInformationMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      comments: // value for 'comments'
 *      description: // value for 'description'
 *      email: // value for 'email'
 *      experience: // value for 'experience'
 *      fullName: // value for 'fullName'
 *      homeMunicipality: // value for 'homeMunicipality'
 *      interests: // value for 'interests'
 *      lead: // value for 'lead'
 *      personalIdentityNumber: // value for 'personalIdentityNumber'
 *      phoneNumber: // value for 'phoneNumber'
 *      profession: // value for 'profession'
 *      qualifications: // value for 'qualifications'
 *      hprNumber: // value for 'hprNumber'
 *   },
 * });
 */
export function useUpdateCandidateInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateInformationMutation, UpdateCandidateInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateInformationMutation, UpdateCandidateInformationMutationVariables>(UpdateCandidateInformationDocument, options);
      }
export type UpdateCandidateInformationMutationHookResult = ReturnType<typeof useUpdateCandidateInformationMutation>;
export type UpdateCandidateInformationMutationResult = Apollo.MutationResult<UpdateCandidateInformationMutation>;
export type UpdateCandidateInformationMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateInformationMutation, UpdateCandidateInformationMutationVariables>;
export const UpdateContactPreferencesDocument = gql`
    mutation UpdateContactPreferences($data: UpdateContactPreferencesInput!) {
  updateContactPreferences(data: $data) {
    isInterestedInContact
    isInterestedInMatchingVacancies
  }
}
    `;
export type UpdateContactPreferencesMutationFn = Apollo.MutationFunction<UpdateContactPreferencesMutation, UpdateContactPreferencesMutationVariables>;

/**
 * __useUpdateContactPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateContactPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactPreferencesMutation, { data, loading, error }] = useUpdateContactPreferencesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactPreferencesMutation, UpdateContactPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactPreferencesMutation, UpdateContactPreferencesMutationVariables>(UpdateContactPreferencesDocument, options);
      }
export type UpdateContactPreferencesMutationHookResult = ReturnType<typeof useUpdateContactPreferencesMutation>;
export type UpdateContactPreferencesMutationResult = Apollo.MutationResult<UpdateContactPreferencesMutation>;
export type UpdateContactPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateContactPreferencesMutation, UpdateContactPreferencesMutationVariables>;
export const GetEmployersForVacancyDocument = gql`
    query GetEmployersForVacancy($id: String!) {
  vacancy(id: $id) {
    id
    profession
    alternativeEmployerIds
    staffingAgencies {
      id
      displayName
      graphicProfile {
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetEmployersForVacancyQuery__
 *
 * To run a query within a React component, call `useGetEmployersForVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployersForVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployersForVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployersForVacancyQuery(baseOptions: Apollo.QueryHookOptions<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables> & ({ variables: GetEmployersForVacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>(GetEmployersForVacancyDocument, options);
      }
export function useGetEmployersForVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>(GetEmployersForVacancyDocument, options);
        }
export function useGetEmployersForVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>(GetEmployersForVacancyDocument, options);
        }
export type GetEmployersForVacancyQueryHookResult = ReturnType<typeof useGetEmployersForVacancyQuery>;
export type GetEmployersForVacancyLazyQueryHookResult = ReturnType<typeof useGetEmployersForVacancyLazyQuery>;
export type GetEmployersForVacancySuspenseQueryHookResult = ReturnType<typeof useGetEmployersForVacancySuspenseQuery>;
export type GetEmployersForVacancyQueryResult = Apollo.QueryResult<GetEmployersForVacancyQuery, GetEmployersForVacancyQueryVariables>;
export const ApplyToVacancyDocument = gql`
    mutation ApplyToVacancy($employerId: String!, $vacancyId: String!) {
  applyToVacancy(employerId: $employerId, vacancyId: $vacancyId) {
    id
    employerId
    identityId
    status
  }
}
    `;
export type ApplyToVacancyMutationFn = Apollo.MutationFunction<ApplyToVacancyMutation, ApplyToVacancyMutationVariables>;

/**
 * __useApplyToVacancyMutation__
 *
 * To run a mutation, you first call `useApplyToVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyToVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyToVacancyMutation, { data, loading, error }] = useApplyToVacancyMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useApplyToVacancyMutation(baseOptions?: Apollo.MutationHookOptions<ApplyToVacancyMutation, ApplyToVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyToVacancyMutation, ApplyToVacancyMutationVariables>(ApplyToVacancyDocument, options);
      }
export type ApplyToVacancyMutationHookResult = ReturnType<typeof useApplyToVacancyMutation>;
export type ApplyToVacancyMutationResult = Apollo.MutationResult<ApplyToVacancyMutation>;
export type ApplyToVacancyMutationOptions = Apollo.BaseMutationOptions<ApplyToVacancyMutation, ApplyToVacancyMutationVariables>;